/*eslint-disable */
import Axios from "axios";
import cogoToast from "cogo-toast";
import {
  ErrorMessage, Field, FieldArray, Form,
  Formik, getIn
} from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Table as TableB } from "react-bootstrap";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  Button, Dropdown,
  Form as FormUi, Grid,
  Header, Icon,
  Input, Modal,
  Table,
  TableHeaderCell
} from "semantic-ui-react";
import * as yup from "yup";
import {
  errorAlertDispatcher, successAlertDispatcher
} from "../../redux/actions/alertAction";
import { billingPartyOrderDetailsAccess, deliverOrderDetailsAccess, LOCAL_STORAGE,TransactionTypes, orderDetailsAccess, scheduleOrderDetailsAccess, FEATURES } from "../../utils/constant";
import { AllRegex } from "../../utils/validation";
import { INVALID_FIELDS, INVALID_FILE_TYPE, ERROR_MESSAGES } from "../../utils/validationConstant";
import MyPSLineItem from "../apiInputs/mypslineItem";
import CreatAxios from "../axiosComponent/create";
import DeleteDocumentAxios from "../axiosComponent/deletedocument";
import PdfAxios from "../axiosComponent/downloadpdf";
import FileCreatAxios from "../axiosComponent/fileupload";
import ReadAxios from "../axiosComponent/read";
import ReadMasterAxios from "../axiosComponent/readMaster";
import UpdateAxios from "../axiosComponent/update";
import ErrorMessages from "../createShipmentComponent/ErrorMessages";
import ModalEditAddDeliveries from "../createShipmentComponent/modalEditAddDeliveries";
import ModeOfTransportDropdown from "../dropdowns/modeOfTransportDropdown";
import MyBillingPartyComponent from "../dynamicComponent/billingparty";
import MyConsigneeComponent from "../dynamicComponent/consignee";
import MyConsignor from "../dynamicComponent/consignor";
import { DateData } from "../dynamicComponent/datepick";
import {
  MyInput, MyNormalInput,
  MyNumInput, MyTextArea, numberInput
} from "../dynamicComponent/myInputs";
import MyLoad from "../dynamicComponent/myLoad";
import MyPackagingType from "../dynamicComponent/myPackingType";
import MyProductsCat from "../dynamicComponent/myProductCat";
import MyProducts from "../dynamicComponent/myProducts";
import MyServiceType from "../dynamicComponent/myServiceType";
import MyVehicleType from "../dynamicComponent/myVehicleType";
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
import MySKU from "../dynamicComponent/mySKU";
import MyUser from "../apiInputs/myUser";
import MyTransactionTypes from "../apiInputs/transactionType";
import MyCompanyCode from "../apiInputs/myCompanyCode";
import MyGLCode from "../apiInputs/myGLCode";
import MyCostCenter from "../apiInputs/myCostCenter";
import ConfirmationModal from "../common/confirmationModal";

function OrderDetails(props) {
  const [getCurrentOrderDetails, setGetCurrentOrderDetails] = useState(
    props.currenOrder
  );

  const [yard, setyard] = useState([]);
  const [cha, setcha] = useState([]);
  const [shipingline, setshipingline] = useState([]);
  const [vehicleType, setvehicleType] = useState();
  const [fileDaughterInvoice, setFileDaughterInvoice] = useState("");
  const [fileGoodsInvoice, setFileGoodsInvoice] = useState("");
  const [fileUploadDO, setfileUploadDO] = useState("");
  const [disablebtn, setdisablebtn] = useState(true);
  const [disableGoodsInvoicebtn, setdisableGoodsInvoicebtn] = useState(true);
  const [enablePLR, setEnablePLR] = useState(true)
  const [enableOtherDocs, setEnableOtherDocs] = useState(true)
  const [enableInvoiceDoc, setEnableInvoiceDoc] = useState(true)
  const [enableEwayDoc, setEnableEwayDoc] = useState(true)
  const [orderEditMode, setOrderEditMode] = useState(false);
  const [orderEditModeAftrAllotConsignor, setOrderEditModeAftrAllotConsignor] =
    useState(false);
  const [orderEditModeAftrAllotConsignee, setOrderEditModeAftrAllotConsignee] =
    useState(false);
  const [orderEditModeAftrAllotDeliverTo, setOrderEditModeAftrAllotDeliverTo] =
    useState(false);
  const [defaultContainerNoVal, setDefaultContainerNoVal] =
    useState();
  const [quantityIndex, setQuantityIndex] = useState(0)
  const [orderEditModeAftrAllotBillingParty, setOrderEditModeAftrAllotBillingParty] = useState(false);
  const [orderEditModeAftrAllotServiceType, setOrderEditModeAftrAllotServiceType] = useState(false);

  const [
    orderEditModeAftrAllotDeliveryRefNo,
    setOrderEditModeAftrAllotDeliveryRefNo,
  ] = useState(false);
  const [orderEditModeAftrAllotRemarks, setOrderEditModeAftrAllotRemarks] =
    useState(false);

  const [ownership, setownershiptype] = useState([]);
  const [branchs, setbranchArray] = useState([]);
  const [userbranchs, setUserbranchArray] = useState([]);
  const [billingpartybranch, setBillingPartyBranch] = useState([]);
  const [containerType, setcontainerType] = useState([]);
  const [customertype, setcustomertype] = useState([]);
  const [updateDeliveryLocation, setUpdateDeliveryLocation] = useState(false);
  const [updateDeliveryRefNo, setUpdateDeliveryRefNo] = useState(false);
  const [updateRemarks, setUpdateRemarks] = useState(false);
  const [consignorArray, setConsignorArray] = useState([]);
  const [consigneeArray, setConsigneeArray] = useState([]);
  const [openModalDelivery, setOpenModalDelivery] = useState(false);
  const [componentReload, setComponentReload] = useState(false);
  const [deletedOtherCharges, setDeletedOtherCharges] = useState([]);
  const [updateContainerNo, setUpdateContainerNo] = useState(false);
  const [quantityModal, setQuantityModal] = useState(false)
  const [editFreightRate, setEditFreightRate] = useState(false)
  const [orderEditModeAftrAllotContainerNumber, setorderEditModeAftrAllotContainerNumber] =
    useState(false);
  const [containerSizeList, setContainerSizeList] = useState([])
  const [lrNumbers , setLrNumbers] = useState({})
  const [salesPersonDetails, setSalesPersonDetails] = useState({})
  const [uomValues, setUomValues] = useState([])
  const [sapFieldsEditMode, setSapFieldsEditMode] = useState(false)
  const [sapFieldEditFlag, setSapFieldEditFlag] = useState(false)
  const [deliveryEditMode, setDeliveryEditMode] = useState(false)
  const [orderSubmitting, setOrderSubmitting] = useState(false)
  const [deliverySubmitting, setDeliverySubmitting] = useState(false)
  const [sapFieldsSubmitting, setSapFieldsSubmitting] = useState(false)
  const [consigneeToPayError, setConigneeToPayError] = useState(false)
  const [actWeightConfirmationModal, setActWeightConfirmationModal] = useState(false)
  const [actWeightConfirmed, setActWeightConfirmed] = useState(false)
  const [serviceTypeChanged, setServiceTypeChanged] = useState(false)

  let setOrderFields

  const { t } = props;
  let UomSelected;
  useEffect(() => {
    getCustomerType();
    getContainerSizeArray()
  }, [])
  useEffect(() => {
    if(FEATURES.transactionDetailsEnabled && getCurrentOrderDetails) setSapEditFlag(getCurrentOrderDetails);
  }, [])
  useEffect(() => {
    getCustomerType()
    getOwnershipType();
    getCurrentUserBranch();
    getContainerType();
    getBranch();
    getShipingLine();
    getYard();
    getCha();
    getUomValues();
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${props.currenOrder.vendor_order_id}`,
    }).then((res) => {
      let temp = res.data.order;
      if (temp?.deliveries) {
        temp.deliveries.forEach((element) => {
          element["grossWeightFlag"] = element["gross_weight"] ? false : true;
          element["chargedWeightFlag"] = element["charged_weight"]
            ? false
            : true;
          element["uom"] = element["uom_id"]
          element['invoices'] = element['invoices']
            ? element.invoices.map((invoice) => {
              return {
                ...invoice,
                eway_bill_no: invoice.eway_bill_no && invoice.eway_bill_no != 0 ? invoice.eway_bill_no : null,
              }
            })
            : [];
        });
      }
      setGetCurrentOrderDetails(temp);
    });
    if (props.currenOrder.proposed_vehicle_type) {
      getVehicleType(props.currenOrder.proposed_vehicle_type);
    }
  }, [componentReload]);

  useEffect(()=>{
    getCurrentOrderDetails && setLrInitially(getCurrentOrderDetails?.deliveries)
  },[getCurrentOrderDetails])

  const getUomValues = () => {
    ReadAxios({
      url: `unitOfMeasurement`,
    })
      .then((result) => {
        let data = result?.data?.resultSet;
        if(data && data.length){
          let list = data.map((item, index) => {
            return {
              key: item.uomId,
              text: item.unit,
              value: item.uomId,
              raw: { ...item },
            };
          });
          setUomValues(list);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getShipingLine = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/shippingLine`,
    })
      .then((result) => {
        let containerData = result.data.resultSet;
        setshipingline(
          containerData.map((item, index) => {
            return {
              key: index + 1,
              text: item.shippingLine,
              value: item.shippingLineId,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const setSapEditFlag = async (data) => {
    try{
      if(data && data.order_no){
        let response = await ReadAxios({
         baseURL : `${process.env.REACT_APP_BILLING_API}`,
         url : 'purchaseorder/getIsUsedDetails ',
         readItems : {
           orderNo : data.order_no
         }
        })
        if(response && response?.data?.status == 1 && response?.data?.data?.isUsed == 0){
          setSapFieldEditFlag(true)
        }else{
          setSapFieldEditFlag(false)
        }
      }
    }catch(err){
      setSapFieldEditFlag(false)
    }
  }

  const getContainerSizeArray = () => {
    let token = LOCAL_STORAGE.userToken
    let userId = LOCAL_STORAGE.userId
    let customerNo = LOCAL_STORAGE.customerNo

    Axios.get(
      `${process.env.REACT_APP_MASTER_API}/container_size?customerNumber=${customerNo}&userId=${userId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
      .then((response) => {
        let containerData = response.data.resultSet;
        setContainerSizeList(
          containerData.map((item, index) => {
            return {
              key: index + 1,
              text: item.containerSize,
              name: item.containerSizeCode,
              value: item.containerSizeCode,
              raw: { ...item },
            };
          })
        );
      })
      .catch((error) => console.log(error));
  };

  const getCha = () => {
    ReadAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/cha` })
      .then((result) => {
        let containerData = result.data.resultSet;
        setcha(
          containerData.map((item, index) => {
            return {
              key: index + 1,
              text: item.CHAName,
              value: item.CHAId,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getYard = () => {
    ReadAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/yard` })
      .then((result) => {
        let containerData = result.data.resultSet;
        setyard(
          containerData.map((item, index) => {
            return {
              key: index + 1,
              text: `${item.yardCode} - ${item.yardName}`,
              value: item.yardId,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getBranch = () => {
    ReadAxios({
      url: `branch`,
      mainUserId: LOCAL_STORAGE.userId,
    })
      .then((res) => {
        let branchArray = res.data.resultSet;
        setbranchArray(
          branchArray.map((item, index) => {
            return {
              key: index + 1,
              text: item.branchName,
              value: item.branchName,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getVehicleType = (id) => {
    // let vehicleTypeManager =
    ReadAxios({ url: `vehicleTypeMaster/${id}` }).then((res) => {
      setvehicleType(res.data.resultSet?.[0]?.vehicleType);
    });
  };

  const getCustomerType = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/billingPartyPaymentType`,
    })
      .then((res) => {
        let ownership = res.data.resultSet;
        setcustomertype(
          ownership.map((item, index) => {
            return {
              key: index,
              value: item.billingPartyPaymentTypeId,
              text: item.billingPartyPaymentTypeName,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getOwnershipType = () => {
    // setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/vehicleOwnershipType`,
    })
      .then((res) => {
        let ownership = res.data.resultSet;
        setownershiptype(
          ownership.map((item, index) => {
            return {
              key: index,
              value: item.vehicleOwnershipTypeId,
              text: item.vehicleOwnershipTypeName,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCancelConfirmationModal = ()=>{
    setActWeightConfirmationModal(false)
    setActWeightConfirmed(false)
  }

  const handleSubmitConfirmModal = (submitForm)=>{
    setActWeightConfirmationModal(false)
    setActWeightConfirmed(true)
    submitForm()
  }

  const getCurrentUserBranch = () => {
    let temparray = LOCAL_STORAGE.branch_Ids;
    ReadAxios({
      url: `branch`,
      mainUserId: LOCAL_STORAGE.userId,
    })
      .then((res) => {
        let branchArray = res.data.resultSet;
        if (temparray != "") {
          let temp = temparray.split(",");
          let tempa = [];
          for (let index = 0; index < branchArray.length; index++) {
            for (let indexj = 0; indexj < temp.length; indexj++) {
              if (branchArray[index].branchId == +temp[indexj]) {
                tempa.push(branchArray[index]);
              }
            }
          }
          setUserbranchArray(
            tempa.map((item, index) => {
              return {
                key: index + 1,
                text: `${item.branchName} (${item.branchCode})`,
                value: item.branchId,
                raw: { ...item },
              };
            })
          );
        } else {
          setUserbranchArray(
            branchArray.map((item, index) => {
              return {
                key: index + 1,
                text: `${item.branchName} (${item.branchCode})`,
                value: item.branchId,
                raw: { ...item },
              };
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getContainerType = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/container_type`,
    })
      .then((result) => {
        let containerData = result.data.resultSet;
        setcontainerType(
          containerData.map((item, index) => {
            return {
              key: index + 1,
              text: item.containerType,
              value: item.containerTypeId,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getOrderDetails = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${props.currenOrder.vendor_order_id}`,
    }).then((res) => {
      let temp = res.data.order;
      if (temp?.deliveries) {
        temp.deliveries.forEach((element) => {
          // element.sales_person_id && setFieldValue
          element["grossWeightFlag"] = element["gross_weight"] ? false : true;
          element["chargedWeightFlag"] = element["charged_weight"]
            ? false
            : true;
          element["uom"] = element["uom_id"]
          element['invoices'] = element['invoices']
            ? element.invoices.map((invoice) => {
              return {
                ...invoice,
                eway_bill_no: invoice.eway_bill_no && invoice.eway_bill_no != 0 ? invoice.eway_bill_no : null,
              }
            })
            : [];
        });
      }
      setGetCurrentOrderDetails(temp);
      //setComponentReload(!componentReload);
    });
    if (props.currenOrder.proposed_vehicle_type) {
      getVehicleType(props.currenOrder.proposed_vehicle_type);
    }
  };

  let formatProducts = (products) => {
    return products.map((o, i) => {
      let transaction_fields = FEATURES.transactionDetailsEnabled ? 
      {
        transaction_amount : o?.transaction_amount ? o.transaction_amount : null,
        transaction_quantity : o?.transaction_quantity ? o.transaction_quantity : null,
      } : {}

      return {
        product_code: o.sku ? o.sku.product_code : null,
        quantity: +o.quantity,
        invoice_no: o.invoice_no,
        product_category_id: o.product_category_id,
        product_category_name: o.product_category_name || '',
        product_id: o.product_id,
        product_name: o.product_name,
        packaging_type_id: o.packaging_type_id,
        length: o?.["length"] ? +o["length"] : null,
        breadth: o?.breadth ? +o.breadth : null,
        height: o?.height ? +o.height : null,
        sku_serial_no : o?.sku_serial_no || null,
        ...transaction_fields
      };
    });
  };

  let getDiff = (actual_date, predicted_date) => {
    if (actual_date == null || predicted_date == null) {
      return null;
    } else {
      let diff = Math.abs(new Date(actual_date) - new Date(predicted_date));
      let diff2 = Math.floor(diff / 60000);
      let tim = diff2;
      let seconds = +tim * 60;
      let d = Math.floor(seconds / (3600 * 24));
      let h = Math.floor((seconds % (3600 * 24)) / 3600);
      let m = Math.floor((seconds % 3600) / 60);
      let dDisplay = d > 0 ? d + (d == 1 ? " day " : " days ") : "";
      let hDisplay = h > 0 ? h + (h == 1 ? " hr " : " hrs ") : "";
      let mDisplay = m > 0 ? m + (m == 1 ? " min " : " mins ") : "";
      return dDisplay + hDisplay + mDisplay;
    }
  };

  let getReturnDiff = (actual_date, predicted_date) => {
    if (actual_date == null || predicted_date == null) {
      return null;
    } else {
      let diff = Math.abs(new Date(actual_date) - new Date(predicted_date));
      let diff2 = Math.floor(diff / 60000);
      let tim = diff2;
      let seconds = +tim * 60;
      let d = Math.floor(seconds / (3600 * 24));
      let h = Math.floor((seconds % (3600 * 24)) / 3600);
      let m = Math.floor((seconds % 3600) / 60);
      let dDisplay = d > 0 ? d + (d == 1 ? " day " : " days ") : "";
      let hDisplay = h > 0 ? h + (h == 1 ? " hr " : " hrs ") : "";
      let mDisplay = m > 0 ? m + (m == 1 ? " min " : " mins ") : "";
      return dDisplay + hDisplay + mDisplay;
    }
  };

  let getDiffDelivery = (actual_date, predicted_date) => {
    if (actual_date == null || predicted_date == null) {
      return null;
    } else {
      let diff = Math.abs(new Date(actual_date) - new Date(predicted_date));
      let diff2 = Math.floor(diff / 60000);
      let tim = diff2;
      let seconds = +tim * 60;
      let d = Math.floor(seconds / (3600 * 24));
      let h = Math.floor((seconds % (3600 * 24)) / 3600);
      let m = Math.floor((seconds % 3600) / 60);
      let dDisplay = d > 0 ? d + (d == 1 ? " day " : " days ") : "";
      let hDisplay = h > 0 ? h + (h == 1 ? " hr " : " hrs ") : "";
      let mDisplay = m > 0 ? m + (m == 1 ? " min " : " mins ") : "";
      return dDisplay + hDisplay + mDisplay;
    }
  };

  let formatInvoices = (invoices) => {
    return invoices.map((o, i) => {
      return {
        invoice_id: o.id,
        invoice_no: o.invoice_no,
        invoice_reference_no: o.invoice_reference_no,
        bl_no: o.bl_no,
        invoice_date: o.invoice_date,
        boe_date: o.boe_date,
        boe_no: o.boe_no,
        invoice_quantity: +o.invoice_quantity,
        invoice_amount: +o.invoice_amount,
        tracking_number: o.tracking_number,
        eway_bill_no: o.eway_bill_no,
        eway_bill_expirydate: o.eway_bill_expirydate
          ? moment(o.eway_bill_expirydate).format("YYYY-MM-DD HH:mm:ss")
          : "",
      };
    });
  };

  let formatLrOtherCharges = (lrOtherCharges) => {
    Array.prototype.push.apply(lrOtherCharges, deletedOtherCharges);
    return lrOtherCharges.map((o, i) => {
      return {
        charge_type_code: o.charge_type_code,
        charge_type_desc: o.charge_type_desc,
        charge_type_id: o.charge_type_id,
        charges: o.charges,
        delivery_id: o.delivery_id,
        lr_other_charges_id: o.lr_other_charges_id,
        is_deleted: o.is_deleted ? o.is_deleted : 0,
      };
    });
  };

  let setDOFile = (name, file) => {
    setdisablebtn(false);
    setfileUploadDO(file);
  };

  let setFile = (name, file, container, deliveryid) => {
    setdisablebtn(false);
    setFileDaughterInvoice(file);
  };

  let setGoodsInvoiceFile = (name, file) => {
    setdisableGoodsInvoicebtn(false);
    setFileGoodsInvoice(file);
  };

  let douploadfile = (name, file, deliveryid) => {
    let values = { [name]: file };
    FileCreatAxios({
      deliveryorderURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${deliveryid}/doDocument`,
      payload: { ...values },
    })
      .then((res) => {
        if (res.data.status == 1) {
          cogoToast.success("File Updated Successfully");
          props.CloseModal(true);
        }
        // this.props.success({
        //   type: "success",
        //   messageHeader: "Success",
        //   messageBody: "File Updated Successfully",
        // });
        // window.location.reload();
      })
      .catch((err) => {
        // this.props.error({
        //   type: "error",
        //   messageHeader: "Error",
        //   messageBody: err.response.data.error,
        // });
        // window.location.reload();
      });
  };

  const setLrInitially = (deliveries)=>{
    let lr_numbers = lrNumbers
    deliveries.length > 0 && deliveries.map((del, index)=>{
      if(del.booking_branch_id && del.lr_no){
        lr_numbers[index]= lr_numbers[index] || {}
        lr_numbers[index][del.booking_branch_id] = lr_numbers[index][del.booking_branch_id] || {}
        lr_numbers[index][del.booking_branch_id].defaultLR = del.lr_no
      }
      })
    setLrNumbers(lr_numbers)
  }

  const handleLRSeriesNo = async (bookingBranchId, index, setFieldValue) => {
    if(lrNumbers && lrNumbers[index] && lrNumbers[index][bookingBranchId] && lrNumbers[index][bookingBranchId].defaultLR){
      setFieldValue(`deliveries[${index}].lr_no`, lrNumbers[index][bookingBranchId].defaultLR)
      setFieldValue(`deliveries[${index}].is_lr_generated_by_lr_series`, true)

    }else if(lrNumbers && lrNumbers[index] && lrNumbers[index][bookingBranchId]){
      var difference = (new Date() - lrNumbers[index][bookingBranchId].time);
      difference = Math.round((difference/1000)/60);
      if(difference >= 30 ){
        let lr_numbers = lrNumbers
        lr_numbers[index][bookingBranchId]=null
        setLrNumbers(lr_numbers)
      }else{
        if (index || index === 0) {
        setFieldValue(`deliveries[${index}].lr_no`, lrNumbers[index][bookingBranchId].lrNumber)
        setFieldValue(`deliveries[${index}].is_lr_generated_by_lr_series`, true)
        }
      }
    }else{
      let lrNumber = await getLRSeriesNumber(bookingBranchId)
      if (lrNumber) {
        let currentTime = new Date()
        let lr_numbers = lrNumbers
        lr_numbers[index]= lr_numbers[index] || {}
        lr_numbers[index][bookingBranchId] = {lrNumber,time : currentTime}
        setLrNumbers(lr_numbers)
        if (index || index === 0) {
          setFieldValue(`deliveries[${index}].lr_no`, lrNumber)
          setFieldValue(`deliveries[${index}].is_lr_generated_by_lr_series`, true)
        }
      }else{
        if (index || index === 0) {
          setFieldValue(`deliveries[${index}].lr_no`, "")
          setFieldValue(`deliveries[${index}].is_lr_generated_by_lr_series`, false)
        }
      }
    }
  }

  const handleConsigneeCustomerTypeChange = (data, index, setFieldValue)=>{
    try{
    let delivery_details = getCurrentOrderDetails.deliveries[index]
     if(FEATURES.contractualCustomerFieldEnabled && data && data.consignee_name && data.customer_type_id && Number(data.customer_type_id) == 2){
      ReadAxios({
        completeURL: `${process.env.REACT_APP_MASTER_API}/billing_party?searchString=${data.consignee_name}`,
      }).then((result) => {
        if(result?.data?.resultSet?.length){
          let billingparty_details = result?.data?.resultSet[0]
          setFieldValue(`deliveries[${index}].billing_party_id`, billingparty_details.billingPartyId)
          setFieldValue(`deliveries[${index}].billing_party_name`, billingparty_details.billingPartyName)
          
          if(delivery_details && delivery_details.billing_party_id && !delivery_details.contractual_customer_id){
            setFieldValue(`deliveries[${index}].contractual_customer_id`, delivery_details.billing_party_id)
          }
          getBillingPartySelected(billingparty_details.billingPartyId)
          setConigneeToPayError(false)
        }else{
          cogoToast.error(ERROR_MESSAGES.CONSIGNEE_NOT_BILLINGPARTY, { hideAfter: 4 });
          setConigneeToPayError(true)
        }
      }).catch((err)=>{
        console.log(err);
      })
     }else if(FEATURES.contractualCustomerFieldEnabled && data && data.billing_party_id && data.customer_type_id && Number(data.customer_type_id) == 1){
      if(data.contractual_customer_id && delivery_details && delivery_details.customer_type_id && delivery_details.customer_type_id == 2){
        setFieldValue(`deliveries[${index}].billing_party_id`, data.contractual_customer_id)
        getBillingPartySelected(data.contractual_customer_id)
      }else{
        setFieldValue(`deliveries[${index}].contractual_customer_id`, data.billing_party_id)
      }
      setConigneeToPayError(false)
     }else{
      setConigneeToPayError(false)
     }

    }catch(err){
      console.log(err);
    }
  }
  const getLRSeriesNumber = async (bookingBranchId) => {
    try {
      let lrResponse = await ReadAxios({ completeURL: `${process.env.REACT_APP_BASE_URL}/v1/common-services/delivery/lrseries/lrnumber?branch_id=${bookingBranchId}` })
      return lrResponse?.data?.lr_number;
    } catch (err) {
      props.errorAlertDispatcher({
        type: "error",
        messageHeader: "Error",
        messageBody: err.response?.data?.message || "Couldn't Fetch LR Number From LR Series",
      });
      return false
      console.log(err);
    }
  }

  let updateFile = (name, file, container, deliveryid) => {
    let values = { [name]: file };
    FileCreatAxios({
      daughterInviceURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${deliveryid}/container/${container}/documents`,
      payload: { ...values },
    })
      .then((res) => {
        if (res.data.status == 1) {
          cogoToast.success("File Updated Successfully");
          props.CloseModal(true);
        }
        // this.props.success({
        //   type: "success",
        //   messageHeader: "Success",
        //   messageBody: "File Updated Successfully",
        // });
        // window.location.reload();
      })
      .catch((err) => {
        // this.props.error({
        //   type: "error",
        //   messageHeader: "Error",
        //   messageBody: err.response.data.error,
        // });
        // window.location.reload();
      });
  };

  let updateGoodsInvoice = (name, file, invoiceId) => {
    let values = { [name]: file };
    FileCreatAxios({
      goodsInvoiceURL: `${process.env.REACT_APP_BASE_URL}/v1/common-services/invoice/${invoiceId}/upload`,
      payload: { ...values },
    })
      .then((res) => {
        if (res.data.status == 1) {
          cogoToast.success("File Updated Successfully");
          props.CloseModal(true);
        }
        // this.props.success({
        //   type: "success",
        //   messageHeader: "Success",
        //   messageBody: "File Updated Successfully",
        // });
        // window.location.reload();
      })
      .catch((err) => {
        // this.props.error({
        //   type: "error",
        //   messageHeader: "Error",
        //   messageBody: err.response.data.error,
        // });
        // window.location.reload();
      });
  };

  const getBillingPartySelected = (billingPartyId, customerTypeName, customerTypeId, setFieldValue) => {
    if (billingPartyId) {
      let token = LOCAL_STORAGE.userToken;
      let userId = LOCAL_STORAGE.userId;
      let customerNo = LOCAL_STORAGE.customerNo;
      let billingPartyBranchIds = LOCAL_STORAGE.billing_Party_Branch_Ids;

      if (
        FEATURES.orderDetails_GetBillingPartyTypeMapping
      ) {
        ReadMasterAxios({
          completeURLL: `${process.env.REACT_APP_MASTER_API}/billing_party_type_mapping?${billingPartyId}`,
          mainUserId: LOCAL_STORAGE.userId,
          billingPartyId: billingPartyId,
        })
          .then((res) => {
            if (res.data.status == 200) {
              let ownership = res.data.resultSet[0].paymentType;
              let cutomerTypeData = ownership.map((item, index) => {
                return {
                  key: index,
                  value: item.id,
                  text: item.name,
                  raw: { ...item },
                };
              })
              setcustomertype(
                cutomerTypeData
              );
              if (cutomerTypeData?.[0]?.text) {
                setFieldValue(customerTypeName, cutomerTypeData[0].text)
                setFieldValue(customerTypeId, cutomerTypeData[0].value)
              }
            } else if (res.data.status == 204) {
              getCustomerType()
            }
          })
          .catch((err) => { });
      }

      Axios.get(
        `${process.env.REACT_APP_MASTER_API}/billing_party_branch?customerNumber=${customerNo}&userId=${userId}&billingPartyId=${billingPartyId}&billingPartyBranchIds=${billingPartyBranchIds}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      )
        .then((response) => {
          let billingPartyBranchArray = response.data.resultSet;
          let options = [];
          if (billingPartyBranchArray.length > 0) {
            billingPartyBranchArray.map((object, index) => {
              let temp = {};
              temp.key = object.billingPartyBranchId;
              temp.text = object.billingPartyBranchName;
              temp.value = object.billingPartyBranchId;
              return (options[index] = temp);
            });
          }
          setBillingPartyBranch(options);
        })
        .catch((error) => console.log(error));
    } else {
      setBillingPartyBranch([]);
    }
  };

  const getConsigneeConsignorArray = (billingPartyId, billingPartyBranchId) => {
    let token = LOCAL_STORAGE.userToken
    let userId = LOCAL_STORAGE.userId
    let customerNo = LOCAL_STORAGE.customerNo

    Axios.get(
      `${process.env.REACT_APP_MASTER_API}mappings/consignor_billing_party_branch?customerNumber=${customerNo}&userId=${userId}&billingPartyId=${billingPartyId}&billingPartyBranchId=${billingPartyBranchId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
      .then((response) => {
        setConsignorArray(response.data.resultSet);
      })
      .catch((error) => console.log(error));

    Axios.get(
      `${process.env.REACT_APP_MASTER_API}mappings/consignee_billing_party_branch?customerNumber=${customerNo}&userId=${userId}&billingPartyId=${billingPartyId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
      .then((response) => {
        setConsigneeArray(response.data.resultSet);
      })
      .catch((error) => console.log(error));
  };

  let uploadDODoc = (name, deliveryid) => {
    let values = { [name]: fileUploadDO };

    FileCreatAxios({
      deliveryorderURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${deliveryid}/doDocument`,
      payload: { ...values },
    })
      .then((res) => {
        if (res.data.status == 1) {
          setdisablebtn(false);
          cogoToast.success("File Uploaded Successfully");
        }
        // this.props.success({
        //   type: "success",
        //   messageHeader: "Success",
        //   messageBody: "File Updated Successfully",
        // });
        // window.location.reload();
      })
      .catch((err) => {
        // this.props.error({
        //   type: "error",
        //   messageHeader: "Error",
        //   messageBody: err.response.data.error,
        // });
        // window.location.reload();
      });
  };

  let uploadDaughterInvoice = (name, container, deliveryid) => {
    setdisablebtn(true);
    let values = { [name]: fileDaughterInvoice };
    FileCreatAxios({
      daughterInviceURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${deliveryid}/container/${container}/documents`,
      payload: { ...values },
    })
      .then((res) => {
        if (res.data.status == 1) {
          setdisablebtn(false);
          cogoToast.success("File Uploaded Successfully");
        }
        // this.props.success({
        //   type: "success",
        //   messageHeader: "Success",
        //   messageBody: "File Updated Successfully",
        // });
        // window.location.reload();
      })
      .catch((err) => {
        // this.props.error({
        //   type: "error",
        //   messageHeader: "Error",
        //   messageBody: err.response.data.error,
        // });
        // window.location.reload();
      });
  };

  let uploadGoodsInvoice = (name, invoiceID) => {
    setdisableGoodsInvoicebtn(true);
    let values = { [name]: fileGoodsInvoice };
    FileCreatAxios({
      goodsInvoiceURL: `${process.env.REACT_APP_BASE_URL}/v1/common-services/invoice/${invoiceID}/upload`,
      payload: { ...values },
    })
      .then((res) => {
        if (res.data.status == 1) {
          setdisableGoodsInvoicebtn(false);
          cogoToast.success("File Uploaded Successfully");
        }
      })
      .catch((err) => { });
  };

  let downloadDO = (deliveryid, documentid) => {
    PdfAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${deliveryid}/documents/${documentid}`,
    })
      .then((res) => {
        if (res.data.status == 1) {
          cogoToast.success("File Downloaded Successfully");
        }
        // let link = res.data;
        // link.setAttribute(link)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  let downloadFile = (container, deliveryid, documentid) => {
    PdfAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${deliveryid}/container/${container}/documents/${documentid}`,
    })
      .then((res) => {
        if (res.data.status == 1) {
          cogoToast.success("File Downloaded Successfully");
        }
        // let link = res.data;
        // link.setAttribute(link)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  let downloadGoodsInvoiceFile = (invoiceid) => {
    PdfAxios({
      completeURL: `${process.env.REACT_APP_BASE_URL}/v1/common-services/invoice/download?invoice_id=${invoiceid}`,
    })
      .then((res) => {
        if (res.data.status == 1) {
          cogoToast.success("File Downloaded Successfully");
        }
        // let link = res.data;
        // link.setAttribute(link)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  let getdoField = (id) => {
    document.getElementById(id).click();
  };

  let getFileid = (id) => {
    document.getElementById(id).click();
  };

  let closeDelEdit = () => {
    getOrderDetails();
  };

  let deleteDO = (deliveryid, documentid) => {
    DeleteDocumentAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${deliveryid}/documents/${documentid}`,
    })
      .then((res) => {
        if (res.data.status == 1) {
          cogoToast.success("File Deleted Successfully");
          props.CloseModal(true);
        }
        // let link = res.data;
        // link.setAttribute(link)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  let deleteFile = (container, deliveryid, documentid) => {
    DeleteDocumentAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${deliveryid}/container/${container}/documents/${documentid}`,
    })
      .then((res) => {
        if (res.data.status == 1) {
          cogoToast.success("File Deleted Successfully");
          props.CloseModal(true);
        }
        // let link = res.data;
        // link.setAttribute(link)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const validateSchema = yup.object().shape({
    min_temp: yup.number().optional().nullable(),
    total_quantity: yup.number().nullable().optional(),
    max_temp: yup
      .number()
      .optional()
      .nullable()
      .when("min_temp", (min_temp) =>
        min_temp
          ? yup.number().optional().nullable().min(min_temp, "min")
          : yup.number().optional().nullable()
      ),
    transaction_no : FEATURES.transactionDetailsEnabled ? yup
      .string()
      .optional()
      .nullable()
      .when("transaction_type_code", (transaction_type_code) =>
      transaction_type_code && transaction_type_code != TransactionTypes.OTHERS
          ? yup.string().required("required")
          : yup.string().optional().nullable()
      ) : yup
      .string()
      .optional()
      .nullable(),
      gross_weight: FEATURES.weightInTonCustomers ? 
      yup
        .number()
        .required("required")
        .min(1, "min")
        .when("net_weight", (net_weight) =>
          net_weight
            ? yup.number().optional().nullable().min(net_weight, "min_net").test('gross_weight', "invalid_value", value => value ? AllRegex.INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS.test(value) : true)
            : yup.number().required("required").min(1, "min").test('gross_weight', "invalid_value", value => value => value ? AllRegex.INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS.test(value) : true).nullable()
        )
      : yup
        .number()
        .required("required")
        .min(1, "min")
        .when("net_weight", (net_weight) =>
          net_weight
            ? yup.number().optional().nullable().min(net_weight, "min_net")
            : yup.number().required("required").min(1, "min")
        ),
  //     transaction_amount : FEATURES.transactionDetailsEnabled ? yup
  //     .string()
  //     .optional()
  //     .nullable()
  //     .when("transaction_type_code", (transaction_type_code) =>{
  //     console.log(transaction_type_code,'rowdata- validation schema');
  //     transaction_type_code && (transaction_type_code != TransactionTypes.OTHERS || transaction_type_code != TransactionTypes.SO)
  //         ? yup.string().required("required")
  //         : yup.string().optional().nullable()
  // }) : yup
  //     .string()
  //     .optional()
  //     .nullable(),
  //   transaction_quantity : FEATURES.transactionDetailsEnabled ? yup.string().required("required") : yup.string().optional().nullable(),
    deliveries: yup.array().of(
      yup.object().shape({
        contractual_customer_id : FEATURES.contractualCustomerFieldEnabled ? yup
              .string()
              .optional()
              .nullable()
              .when("customer_type_id", (customer_type_id) =>
              customer_type_id && customer_type_id == 2
                  ? yup.string().required("Required").nullable()
                  : yup.string().optional().nullable()
          ) : yup
              .string()
              .optional()
              .nullable(),
        actual_weight: FEATURES.weightInTonCustomers ? yup.number().nullable().optional().test('actual_weight', "Invalid Value", value => value ? AllRegex.INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS.test(value) : true) : yup.number().nullable().optional(),
        gross_weight: FEATURES.weightInTonCustomers ? yup.number().nullable().optional().test('gross_weight', "Invalid Value", value => value ? AllRegex.INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS.test(value) : true) : yup.number().nullable().optional(),
        charged_weight: FEATURES.weightInTonCustomers ? yup.number().nullable().optional().test('charged_weight', "Invalid Value", value => value ? AllRegex.INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS.test(value) : true) : yup.number().nullable().optional(),
        invoices: yup.array().of(
          yup.object().shape({
            invoice_code: yup.string().optional().nullable(),
            invoice_date: yup.string().optional().nullable(),
            invoice_quantity: yup
              .number()
              .optional()
              .min(1, "min")
              .nullable(),
            invoice_amount: yup.number().optional().nullable(),
            eway_bill_expirydate: yup.string().optional().nullable(),
            eway_bill_no: yup.string().matches(AllRegex.ewayBillNumber, INVALID_FIELDS.INVALID_EWAYBILL_NO).optional().nullable(),
          })
        )
      })
    ),
  });

  const setOpenModalDeliveryClose = () => {
    setOpenModalDelivery(false);
  };

  const addDeliveryDetails = async (data) => {
    let temp = getCurrentOrderDetails;
    for (let index = 0; index < data.length; index++) {
      data[index].fromEdit = true;
      data[index]["grossWeightFlag"] = data[index]["gross_weight"]
        ? false
        : true;
      data[index]["chargedWeightFlag"] = data[index]["charged_weight"]
        ? false
        : true;
      temp?.deliveries.push(data[index]);
    }
    setGetCurrentOrderDetails(temp);
    let formatted_values = await generateInitialValues()
    if(formatted_values?.deliveries?.length) setOrderFields("deliveries", formatted_values?.deliveries);
  };

  const removeAddedDelivery = (e, data, index) => {
    let temp = getCurrentOrderDetails;
    temp?.deliveries.splice(index, 1);
    setGetCurrentOrderDetails(temp);
    setComponentReload(!componentReload);
  };

  const saveAddedProduct = (data, deliveryID) => {
    let dataTemplate = {
      product_code: data.product_code ? data.product_code : null,
      quantity: +data.quantity,
      invoice_no: data.invoice_no,
      product_category_id: data.product_category_id,
      product_category_name: data.product_category_name || '',
      product_id: data.product_id,
      product_name: data.product_name,
      packaging_type_id: data.packaging_type_id,
      length: +data["length"],
      breadth: +data.breadth,
      height: +data.height,
      sku_serial_no : data.sku_serial_no || ""
    };
    if(FEATURES.transactionDetailsEnabled){
      dataTemplate.transaction_amount = data?.transaction_amount || null
      dataTemplate.transaction_quantity = data?.transaction_quantity || null
    }

    CreatAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${deliveryID}/product`,
      payload: { products: [dataTemplate] },
    })
      .then((response) => {
        cogoToast.success("Product is added.");
        /* window.location.reload(); */
      })
      .catch((err) => {
        console.log(err);
        cogoToast.success("Failed to add Product.");
      });
  };

  const saveAddedInvoice = (data, deliveryID) => {
    let dataTemplate = {
      invoice_id: data.invoice_id,
      invoice_no: data.invoice_no,
      invoice_reference_no: data.invoice_reference_no,
      bl_no: data.bl_no,
      invoice_date: data.invoice_date,
      boe_date: data.boe_date,
      boe_no: data.boe_no,
      invoice_quantity: +data.invoice_quantity,
      invoice_amount: +data.invoice_amount,
      tracking_number: data.tracking_number,
      eway_bill_expirydate: data.eway_bill_expirydate,
      eway_bill_no: +data.eway_bill_no
    };

    CreatAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${deliveryID}/invoice`,
      payload: { invoices: [dataTemplate] },
    })
      .then((response) => {
        cogoToast.success("Invoice is added.");
        /*  window.location.reload(); */
      })
      .catch((err) => {
        console.log(err);
        cogoToast.error("Failed to add Invoice.");
      });
  };

  const uploadLRs = (docType, file, commonDeliveryId) => {
    let payloadData = {
      file: file,
      doc_type: docType,
      doc_name: file.name
    }
    FileCreatAxios({
      fileUploadURL: `${process.env.REACT_APP_BASE_URL}/v1/common-services/delivery/${commonDeliveryId}/delivery_related_lr_documents/upload`,
      payload: { ...payloadData },
    }).then((result) => {
      if (result?.data?.message)
        cogoToast.success(result.data.message);
      setComponentReload(!componentReload)
    }).catch((err) => {
      if (err?.response?.data?.message)
        cogoToast.error(err.response.data.message);
    })
  }

  const downloadLRs = (name, docKey, commonDeliveryId) => {
    PdfAxios({
      PDFURL: `${process.env.REACT_APP_BASE_URL}/v1/common-services/delivery/delivery_related_lr_documents/donwload?key=${docKey}`,
    })
      .then((result) => {
        if (result?.data?.message)
          cogoToast.success(result.data.message);
      }).catch((err) => {
        if (err?.response?.data?.message)
          cogoToast.error(err.response.data.message);
      })
  }

  const deleteLRs = (name, docKey, commonDeliveryId) => {
    DeleteDocumentAxios({
      deleteURL: `${process.env.REACT_APP_BASE_URL}/v1/common-services/delivery/delivery_related_lr_documents/delete?key=${docKey}`,
      data: commonDeliveryId,
    })
      .then((result) => {
        if (result?.data?.message)
          cogoToast.success(result.data.message);
        setComponentReload(!componentReload)
      }).catch((err) => {
        if (err?.response?.data?.message)
          cogoToast.error(err.response.data.message);
      })
  }

  const deleteInvoiceDocs = (name, docKey, commonDeliveryId) => {
    DeleteDocumentAxios({
      deleteURL: `${process.env.REACT_APP_BASE_URL}/v1/common-services/invoice/invoice_documents/delete?key=${docKey}`,
      data: commonDeliveryId,
    })
      .then((result) => {
        if (result?.data?.message)
          cogoToast.success(result.data.message);
        setComponentReload(!componentReload)
      }).catch((err) => {
        if (err?.response?.data?.message)
          cogoToast.error(err.response.data.message);
      })
  }

  const uploadInvoices = (docType, file, InvoiceId) => {
    let payloadData = {
      file: file,
      doc_type: docType,
      doc_name: file.name
    }
    FileCreatAxios({
      fileUploadURL: `${process.env.REACT_APP_BASE_URL}/v1/common-services/invoice/${InvoiceId}/invoice_documents/upload`,
      payload: { ...payloadData },
    }).then((result) => {
      if (result?.data?.message)
        cogoToast.success(result.data.message);
      setComponentReload(!componentReload)
    }).catch((err) => {
      if (err?.response?.data?.message)
        cogoToast.error(err.response.data.message);
    })
  }

  const downloadInvoices = (name, docKey, InvoiceId) => {
    PdfAxios({
      PDFURL: `${process.env.REACT_APP_BASE_URL}/v1/common-services/invoice/invoice_documents/download?key=${docKey}`,
    })
      .then((result) => {
        if (result?.data?.message)
          cogoToast.success(result.data.message);
      }).catch((err) => {
        if (err?.response?.data?.message)
          cogoToast.error(err.response.data.message);
      })
  }

  const handleServiceTypeChange= (previous_value, current_value) =>{
    if(previous_value != current_value) setServiceTypeChanged(true);
  }

  const generateInitialValues = () => {
    var temp = getCurrentOrderDetails;

    if (temp?.deliveries) {
      temp.deliveries.forEach((element) => {
        
        element["other_lr"] = {};
        element["physical_lr"] = {};
        element["cft_kg_enable"] = element?.cft_kg_factor && element?.cft_kg_factor > 0 ? true : false;
        element["grossWeightFlag"] = FEATURES.weightAutoFillingInDelivery ? false : (element["gross_weight"] ? false : true);
        element["chargedWeightFlag"] = FEATURES.weightAutoFillingInDelivery ? false : (element["charged_weight"] ? false : true);
        element["contractual_customer_id"] = element["contractual_customer_id"] ? (element["contractual_customer_id"] == 0 ? null : element["contractual_customer_id"]) : null ; 
        if (!element.defaultInvoice) {
          element.defaultInvoice = true
          element.invoices.push({
            invoice_code: null,
            invoice_reference_no: null,
            invoice_date: null,
            invoice_quantity: null,
            invoice_amount: null,
            eway_bill_no: null,
            eway_bill_expirydate: null
          })
        }
        if (element?.invoices?.length > 0) {
          element.invoices.forEach((invoiceDetail, i) => {
            const invCopy = invoiceDetail?.invoice_related_documents?.find(({ doc_type }) => doc_type == "invoice_no");
            const eway_bill = invoiceDetail?.invoice_related_documents?.find(({ doc_type }) => doc_type == "eway_bill");
            invoiceDetail.eway_bill_expirydate = invoiceDetail?.eway_bill_expirydate && invoiceDetail?.eway_bill_expirydate != "0000-00-00" ? invoiceDetail?.eway_bill_expirydate : null;
            invoiceDetail.invoice_copy = invCopy?.doc_key;
            invoiceDetail.eway_bill_copy = eway_bill?.doc_key;
          });
        }
        if (element?.products?.length > 0) {
          element.products.forEach((productDetail) => {
            if (productDetail.sku == null || productDetail.sku == undefined) {
              productDetail.sku = {};
              productDetail.sku["product_code"] = "";
              productDetail.sku["product_name"] = "";
            }
          });
        }
      });
    }
    return {
      bookingNumber: getCurrentOrderDetails.booking_number,
      gross_weight: getCurrentOrderDetails.gross_weight,
      freight_rate: getCurrentOrderDetails.freight_rate,
      booking_branch_id: getCurrentOrderDetails.booking_branch_id,
      service_type_id: getCurrentOrderDetails.service_type_id,
      proposed_vehicle_type: getCurrentOrderDetails.proposed_vehicle_type,
      ownership_type_id: getCurrentOrderDetails.ownership_type_id,
      load_type_id: getCurrentOrderDetails.load_type_id,
      deliveries: temp?.deliveries
        ? temp.deliveries
        : getCurrentOrderDetails.deliveries,
      min_temp: getCurrentOrderDetails.min_temp,
      max_temp: getCurrentOrderDetails.max_temp,
      mode_of_transport: getCurrentOrderDetails.mode_of_transport,
      actual_hire_charge: getCurrentOrderDetails.actual_hire_charge ? Number(getCurrentOrderDetails.actual_hire_charge) : "",
      proposed_hire_charge: getCurrentOrderDetails.proposed_hire_charge ? Number(getCurrentOrderDetails.proposed_hire_charge) : "",
      transaction_type_code : getCurrentOrderDetails.transaction_type_code || "",
      transaction_no : getCurrentOrderDetails.transaction_no || "",
      // transaction_amount : getCurrentOrderDetails.transaction_amount || "",
      // transaction_quantity : getCurrentOrderDetails.transaction_quantity || "",
      company_code : getCurrentOrderDetails.company_code || "",
      gl_code : getCurrentOrderDetails.gl_code || "",
      cost_center_code : getCurrentOrderDetails.cost_center_code || "",
      gross_volume: getCurrentOrderDetails.gross_volume
    };
  };

  const evaluateFreightRate = (
    value,
    setFieldValue,
    proposedFreightRate,
    actualFreightRate,
    finalFreightRate,
    CFTKGFactor,
    chargedWeight,
    cftKgEnable,
    finalRate,
    charges,
    index
  ) => {
    setFieldValue(cftKgEnable, true)
    // let optionsUOM = [
    //   { key: "4", text: "Trip", value: "trip" },
    //   { key: "2", text: "KG", value: "kg" },
    //   { key: "5", text: "Ton", value: "ton" },
    //   { key: "6", text: "KM", value: "km" },
    //   { key: "7", text: "Per Case", value: "percase" },
    //   { key: "8", text: "CFT", value: "cft" },
    //   { key: "9", text: "CFT KG Factor", value: "CFTKGFactor" },
    // ];

    UomSelected = value.deliveries[index].uom ;
    let uomName = value.deliveries[index].uom_name ;

    // optionsUOM.forEach((element) => {
    //   if (element.value == value.deliveries[index].uom) {
    //     UomSelected = element.key;
    //   }
    // });

    let UoMCFTFactorCalculation = 0;

    value.deliveries.forEach((element) => {
      if (element?.products?.length > 0) {
        element.products.forEach((products) => {
          let temp =
            products.length *
            products.breadth *
            products.height *
            products.quantity;
          if (!isNaN(temp))
            UoMCFTFactorCalculation = UoMCFTFactorCalculation + temp;
          else UoMCFTFactorCalculation = UoMCFTFactorCalculation;
        });
      }
    });

    let chargedWeightValue = value.deliveries[index].charged_weight; //2,5
    let totalWeightValue = value.deliveries[index].total_quantity; //7

    ReadAxios({
      baseURL: `${process.env.REACT_APP_TA_API_URL}`,
      url: `orders/freight/rate`,
      readItems: {
        customer_no: LOCAL_STORAGE.customerNo,
        user_id: LOCAL_STORAGE.userId,
        trip_type_id: "1", // one-way/two-way
        movement_type: props.movement_type,
        billing_party_id: value.deliveries[index].billing_party_id,
        route_id: props.currenOrder.shipment.route_id,
        proposed_vehicle_type: value.proposed_vehicle_type,
        consignor_id: value?.deliveries?.[index]?.consignor?.consignor_id
          ? value.deliveries[index].consignor.consignor_id
          : value.deliveries?.[index]?.consignor?.id
            ? value.deliveries[index].consignor.id
            : "",
        consignee_id: value?.deliveries?.[index]?.consignee?.consignee_id
          ? value.deliveries[index].consignee.consignee_id
          : value.deliveries?.[index]?.consignee?.id
            ? value.deliveries[index].consignee.id
            : "",
        vendor_id: props.currenOrder.vendor_id,
        booking_branch_id: value.deliveries[index].booking_branch_id,
        container_type_id: value.deliveries[index].container_type_id,
        uom: UomSelected,
        load_type_id: value.load_type_id,
        date: moment(
          value?.deliveries?.[index]?.lr_date
            ? value.deliveries[index].lr_date
            : new Date()
        ).format("YYYY-MM-DD"), // LR date
        engine_type_id: 2, //vendor-customer-company
        grossWeightFlag: value.deliveries[index].grossWeightFlag,
        chargedWeightFlag: value.deliveries[index].chargedWeightFlag,
        //expense_particular_id: "101", //
        rate_type_id: 1, // Progressive-fixed-slab
        //loading_pattern_id: "2" // vehicle type, 20-20+20-40>
        mode_of_transport : value?.mode_of_transport,
        total_no_of_boxes : value?.deliveries?.[index]?.total_quantity
      },
    })
      .then((result) => {
        if (result?.data?.data?.amount) {
          if (
            value?.deliveries?.[index]?.actual_freight_rate &&
            value?.deliveries?.[index]?.final_freight_rate &&
            value.deliveries[index].actual_freight_rate != 0 &&
            value.deliveries[index].final_freight_rate != null
          ) {
            let amountFromAPI = result.data.data.amount;
            let cftFactorFromAPI = result.data.data.CFTKGFactor;
            let calculatedAmount =
              amountFromAPI *
              (value.deliveries[index].final_freight_rate /
                value.deliveries[index].actual_freight_rate);
            setFieldValue(proposedFreightRate, amountFromAPI);
            setFieldValue(actualFreightRate, amountFromAPI);
            setFieldValue(CFTKGFactor, cftFactorFromAPI);

            setFrieghtValueCalculation(
              uomName,
              chargedWeightValue,
              totalWeightValue,
              amountFromAPI,
              UoMCFTFactorCalculation,
              cftFactorFromAPI,
              chargedWeight,
              finalFreightRate,
              calculatedAmount,
              setFieldValue
            );
          } else {
            let amountFromAPI = result.data.data.amount;
            let cftFactorFromAPI = result.data.data.CFTKGFactor;
            setFieldValue(proposedFreightRate, amountFromAPI);
            setFieldValue(actualFreightRate, amountFromAPI);
            setFieldValue(CFTKGFactor, cftFactorFromAPI);

            setFrieghtValueCalculation(
              uomName,
              chargedWeightValue,
              totalWeightValue,
              amountFromAPI,
              UoMCFTFactorCalculation,
              cftFactorFromAPI,
              chargedWeight,
              finalFreightRate,
              calculatedAmount,
              setFieldValue
            );
          }
          //setProposedFreightRateValue(result.data.data)
        }
      })
      .catch((err) => {
        console.log(err);
      });
    value.deliveries.map((obj) => {
      return setFieldValue(finalRate, +obj.charges + +obj.final_freight_rate)
    })
  };

  const setFrieghtValueCalculation = (
    UomSelected,
    chargedWeightValue,
    totalWeightValue,
    amountFromAPI,
    UoMCFTFactorCalculation,
    cftFactorFromAPI,
    chargedWeight,
    finalFreightRate,
    calculatedAmount,
    setFieldValue
  ) => {
    let distanceOrder = props.budgeted_kms.split(" ")[0];
    distanceOrder = parseInt(distanceOrder);
    if (UomSelected && UomSelected.toUpperCase() == "TRIP") {
      setFieldValue(finalFreightRate, amountFromAPI);
    }

    if (
      UomSelected && (UomSelected.toUpperCase() == 'KG' || UomSelected.toUpperCase() == 'TON') &&
      !isNaN(chargedWeightValue) &&
      +chargedWeightValue > 0
    ) {
      let charged_weight = Number(chargedWeightValue)
      if(UomSelected.toUpperCase() == 'TON'){
        charged_weight = FEATURES.weightInTonCustomers ? charged_weight : charged_weight/1000
      }else{
        charged_weight = FEATURES.weightInTonCustomers ? charged_weight * 1000 : charged_weight
      }
      let tempCalculation = amountFromAPI * chargedWeightValue;
      setFieldValue(finalFreightRate, tempCalculation);
    } else if (UomSelected && (UomSelected.toUpperCase() == 'KG' || UomSelected.toUpperCase() == 'TON')) {
      setFieldValue(finalFreightRate, 0);
    }

    if (UomSelected && UomSelected.toUpperCase() == 'PER CASE' && !isNaN(totalWeightValue) && +totalWeightValue > 0) {
      let tempCalculation = amountFromAPI * totalWeightValue;
      setFieldValue(finalFreightRate, tempCalculation);
    } else if (UomSelected && UomSelected.toUpperCase() == 'PER CASE') {
      setFieldValue(finalFreightRate, 0);
    }

    if (UomSelected && UomSelected.toUpperCase() == 'KM' && !isNaN(distanceOrder) && +distanceOrder > 0) {
      let distance = distanceOrder;
      let tempCalculation = amountFromAPI * distance;
      setFieldValue(finalFreightRate, tempCalculation);
    } else if (UomSelected && UomSelected.toUpperCase() == 'KM') {
      setFieldValue(finalFreightRate, tempCalculation);
    }

    if (UomSelected && UomSelected.toUpperCase() == 'PER TON PER KM' && !isNaN(distanceOrder) && +distanceOrder > 0 &&  !isNaN(chargedWeightValue) && +chargedWeightValue > 0) {
      let distance = distanceOrder;
      let weight_in_ton = FEATURES.weightInTonCustomers ? Number(chargedWeightValue) : Number(chargedWeightValue)/1000
      let tempCalculation = amountFromAPI * distance * weight_in_ton;
      setFieldValue(finalFreightRate, tempCalculation);
    } else if (UomSelected && UomSelected.toUpperCase() == 'PER TON PER KM') {
      setFieldValue(finalFreightRate, tempCalculation);
    }

    if (
      UomSelected && (UomSelected.toUpperCase() == 'CFT' || UomSelected.toUpperCase() == 'PER CFT KG') &&
      +UoMCFTFactorCalculation > 0
    ) {
      if (UomSelected.toUpperCase() == 'PER CFT KG') {
        let volumeWithCFT = cftFactorFromAPI * UoMCFTFactorCalculation;
        setFieldValue(chargedWeight, volumeWithCFT);
        setFieldValue(finalFreightRate, calculatedAmount);
      }
      if (UomSelected.toUpperCase() == 'CFT') {
        setFieldValue(finalFreightRate, calculatedAmount);
      }
    } else if (UomSelected && (UomSelected.toUpperCase() == 'CFT' || UomSelected.toUpperCase() == 'PER CFT KG')) {
      setFieldValue(finalFreightRate, 0);
    }
  };

  const getCounts = (arr) => {
    let sum = arr && arr?.reduce(function (sum, elem) {
      return sum + elem?.quantity;
    }, 0)
    if (sum != false) {
      return sum
    } else {
      return 0
    }
  }

  const orderDetails = { display: orderDetailsAccess ? "none" : "" }
  const scheduleAccess = { display: "" }
  const partyOrderDetailsAccess = { display: billingPartyOrderDetailsAccess ? "none" : "" }
  const deliverAccess = { display: deliverOrderDetailsAccess ? "none" : "" }

  const editEvaluateFreightRate = (value, index) => {
    const optionsUOM = [
      { key: "4", text: "Trip", value: "trip" },
      { key: "2", text: "KG", value: "kg" },
      { key: "5", text: "Ton", value: "ton" },
      { key: "6", text: "KM", value: "km" },
      { key: "7", text: "Per Case", value: "percase" },
      { key: "8", text: "CFT", value: "cft" },
      { key: "9", text: "CFT KG Factor", value: "CFTKGFactor" },
    ];

    optionsUOM.forEach(element => {
      if (element.value == value.deliveries[index].uom) {
        UomSelected = element.key;
      }
    });
  };

  const onFreightUpdate = (values) => {
    // if (values.deliveries.length > 0) {
    values.deliveries.map((o, i) => {
      let temp = {};

      // if (o.active) {

      temp.consignor_code = o.consignor
        ? o.consignor.consignorCode
        : null;
      temp.consignee_code = o.consignee
        ? o.consignee.consigneeCode
        : null;
      temp.container_no = o.container_no;
      temp.pickup_area = o.pickup_area;
      temp.drop_area = o.drop_area;
      temp.container_size = o?.container_size
        ? o.container_size
        : null;
      temp.container_type_id = o?.container_type_id
        ? o.container_type_id
        : null;
      temp.container_no = o.container_no
        ? o.container_no
        : null;
      temp.container_seal_no = o?.container_seal_no
        ? o.container_seal_no
        : null;
      temp.lr_no = o.lr_no;
      temp.delivery_reference_no = o.delivery_reference_no;
      temp.lr_date = o.lr_date;
      temp.transporter_lr_no = o.transporter_lr_no;
      temp.transporter_lr_date = o.transporter_lr_date;
      temp.import_declaration_no = o.import_declaration_no;
      temp.boarding_no = o.boarding_no;
      temp.billing_party_id = o.billing_party_id
        ? o.billing_party_id
        : null;
      temp.billing_party_branch_id = o.billing_party_branch_id
        ? o.billing_party_branch_id
        : null;
      temp.do_no = o.do_no;
      temp.do_validity_date = o.do_validity_date;
      temp.charged_weight = o?.charged_weight
        ? parseInt(o.charged_weight)
        : null;
      temp.actual_weight = o.actual_weight;

      temp.proposed_freight_rate = o.proposed_freight_rate;
      temp.uom = o.uom_name;

      temp.actual_freight_rate = o.actual_freight_rate;
      temp.cft_kg_factor = o.cft_kg_factor;
      temp.final_freight_rate = o.final_freight_rate;
      temp.final_rate = o.final_rate;
      temp.total_quantity = parseInt(o.total_quantity);
      temp.gross_weight = o.gross_weight;
      temp.remarks = o.remarks;
      temp.cha_id = o.cha_id;
      temp.yard_id = o.yard_id;
      temp.shipping_line_id = o.shipping_line_id;
      temp.customer_type_id = o.customer_type_id;

      temp.booking_branch_id = o.booking_branch_id;
      temp.booking_branch_name = o.booking_branch_name;
      temp.billing_branch_name = o.billing_branch_name;
      temp.billing_branch_id = o.billing_branch_id;

      temp.deliver_to = o.deliver_to;
      temp.deliver_to_address = o.deliver_to_address;
      temp.container_pickup_date = o.container_pickup_date
        ? moment(o.container_pickup_date).format(
          "YYYY-MM-DD HH:mm:ss"
        )
        : null;
      temp.actual_pickup_date = o.actual_pickup_date
        ? moment(o.actual_pickup_date).format(
          "YYYY-MM-DD HH:mm:ss"
        )
        : null;
      temp.delivery_date = o.delivery_date
        ? moment(o.delivery_date).format("YYYY-MM-DD HH:mm:ss")
        : null;
      temp.actual_delivery_date = o.actual_delivery_date
        ? moment(o.actual_delivery_date).format(
          "YYYY-MM-DD HH:mm:ss"
        )
        : null;
      temp.actual_container_return_date =
        o.actual_container_return_date
          ? moment(o.actual_container_return_date).format(
            "YYYY-MM-DD HH:mm:ss"
          )
          : null;
      temp.container_return_date = o.container_return_date
        ? moment(o.container_return_date).format(
          "YYYY-MM-DD HH:mm:ss"
        )
        : null;
      temp.storage_expiration_date = o.storage_expiration_date
        ? moment(o.storage_expiration_date).format(
          "YYYY-MM-DD HH:mm:ss"
        )
        : null;
      temp.demurrage_expiration_date = o.demurrage_expiration_date
        ? moment(o.demurrage_expiration_date).format(
          "YYYY-MM-DD HH:mm:ss"
        )
        : null;
      temp.ata_date = o.ata_date
        ? moment(o.ata_date).format("YYYY-MM-DD HH:mm:ss")
        : null;
      temp.lr_other_charges =
        o.lr_other_charges.length > 0 && o.lr_other_charges[0].charge_type_id != "" && o.lr_other_charges[0].charges != "" || deletedOtherCharges.length > 0
          ? formatLrOtherCharges(o.lr_other_charges)
          : [];
      UpdateAxios({
        patchURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${o.delivery_id}`,
        payload: temp,
        uniqueId: o.delivery_id,
      })
        .then((response) => {
          setEditFreightRate(false)

          if (response.data.status == 1) {
            let alert = {
              type: "success",
              messageHeader: "Success",
              messageBody: `Delivery is updated.`,
            };
            props.successAlertDispatcher(alert);
            getOrderDetails();
          }
        })
        .catch((err) => {
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: err.response?.data?.message
              ? err.response.data.message
              : "Error while saving data...",
          };
          props.errorAlertDispatcher(alert);
          console.log(err);
        });

      // }
    });
    // }
  };

  return (
    <>
      <Modal
        open={props.OpenModal}
        size="fullscreen"
        centered={false}
        scrolling="true"
        closeIcon
        onClose={props.CloseModal}
      >
        <Modal.Header>
          <Table.Row>
            <Table.HeaderCell className="p-bold-500">
              {FEATURES.orderPageHeadingAsBookingDetails
                ? "Booking Details"
                : t('title') || "Order Detail"}
            </Table.HeaderCell>
          </Table.Row>
        </Modal.Header>
        {getCurrentOrderDetails ? (
          <Formik
            enableReinitialize={true}
            initialValues={generateInitialValues()}
            validationSchema={validateSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true)
              let deliveryValues = [];
              if (values.deliveries.length > 0) {
                values.deliveries.map((o, i) => {
                  let temp = {};

                  if ((deliveryEditMode || o?.deliveryEditMode) && o.active) {
                    setDeliverySubmitting(true)
                    if(o.sales_person_number || o.sales_person_email){
                      let sales_person_details = salesPersonDetails
                      sales_person_details[i] = {
                        'sales_person_number': o.sales_person_number,
                        'sales_person_email': o.sales_person_email
                      }
                      setSalesPersonDetails(salesPersonDetails)
                    }
                    if(FEATURES.contractualCustomerFieldEnabled && consigneeToPayError){
                      cogoToast.error(ERROR_MESSAGES.CONSIGNEE_NOT_BILLINGPARTY_ON_SUBMIT, { hideAfter: 4 });
                      setSubmitting(false)
                      setDeliverySubmitting(false)
                      return;
                    }
                    temp.consignor_code = o.consignor
                      ? o.consignor.consignorCode
                      : null;
                    temp.consignee_code = o.consignee
                      ? o.consignee.consigneeCode
                      : null;
                    temp.container_no = o.container_no;
                    temp.pickup_area = o.pickup_area;
                    temp.drop_area = o.drop_area;
                    temp.container_size = o?.container_size
                      ? o.container_size
                      : null;
                    temp.container_type_id = o?.container_type_id
                      ? o.container_type_id
                      : null;
                    temp.container_no = o.container_no
                      ? o.container_no
                      : null;
                    temp.container_seal_no = o?.container_seal_no
                      ? o.container_seal_no
                      : null;
                    temp.lr_no = o.lr_no;
                    temp.sales_person_id = o.sales_person_id;
                    temp.delivery_reference_no = o.delivery_reference_no;
                    temp.lr_date = o.lr_date;
                    temp.transporter_lr_no = o.transporter_lr_no;
                    temp.transporter_lr_date = o.transporter_lr_date;
                    temp.import_declaration_no = o.import_declaration_no;
                    temp.boarding_no = o.boarding_no;
                    temp.billing_party_id = o.billing_party_id
                      ? o.billing_party_id
                      : null;
                    temp.billing_party_branch_id = o.billing_party_branch_id
                      ? o.billing_party_branch_id
                      : null;
                    temp.do_no = o.do_no;
                    temp.do_validity_date = o.do_validity_date;
                    temp.charged_weight = o?.charged_weight
                      ? Number(o.charged_weight)
                      : null;
                    temp.actual_weight = o.actual_weight && Number(o.actual_weight);

                    temp.proposed_freight_rate = o.proposed_freight_rate;
                    temp.uom = o.uom_name;

                    temp.actual_freight_rate = o.actual_freight_rate;
                    temp.cft_kg_factor = o.cft_kg_factor;
                    temp.final_freight_rate = o.final_freight_rate;
                    temp.final_rate = o.final_rate;
                    temp.total_quantity = parseInt(o.total_quantity);
                    temp.gross_weight = o.gross_weight && Number(o.gross_weight);
                    temp.remarks = o.remarks;
                    temp.cha_id = o.cha_id;
                    temp.yard_id = o.yard_id;
                    temp.shipping_line_id = o.shipping_line_id;
                    temp.customer_type_id = o.customer_type_id;

                    temp.booking_branch_id = o.booking_branch_id;
                    temp.booking_branch_name = o.booking_branch_name;
                    temp.billing_branch_name = o.billing_branch_name;
                    temp.billing_branch_id = o.billing_branch_id;

                    temp.insurance_no = o.insurance_no;

                    if(serviceTypeChanged) temp.service_type_id = o.service_type_id;

                    temp.contractual_customer_id = o.contractual_customer_id
                    temp.contractual_customer_name = o.contractual_customer_name;

                    temp.deliver_to = o.deliver_to;
                    temp.deliver_to_address = o.deliver_to_address;
                    temp.container_pickup_date = o.container_pickup_date
                      ? moment(o.container_pickup_date).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )
                      : null;
                    temp.actual_pickup_date = o.actual_pickup_date
                      ? moment(o.actual_pickup_date).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )
                      : null;
                    temp.delivery_date = o.delivery_date
                      ? moment(o.delivery_date).format("YYYY-MM-DD HH:mm:ss")
                      : null;
                    temp.actual_delivery_date = o.actual_delivery_date
                      ? moment(o.actual_delivery_date).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )
                      : null;
                    temp.actual_container_return_date =
                      o.actual_container_return_date
                        ? moment(o.actual_container_return_date).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )
                        : null;
                    temp.container_return_date = o.container_return_date
                      ? moment(o.container_return_date).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )
                      : null;
                    temp.storage_expiration_date = o.storage_expiration_date
                      ? moment(o.storage_expiration_date).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )
                      : null;
                    temp.demurrage_expiration_date = o.demurrage_expiration_date
                      ? moment(o.demurrage_expiration_date).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )
                      : null;
                    temp.ata_date = o.ata_date
                      ? moment(o.ata_date).format("YYYY-MM-DD HH:mm:ss")
                      : null;
                    temp.products =
                      o.products.length > 0 ? formatProducts(o.products) : [];

                    const filterInvoiceList = [];
                    o.invoices.map((invoice) => {
                      if (
                        invoice.bl_no != null ||
                        invoice.invoice_amount != null ||
                        invoice.invoice_reference_no != null ||
                        invoice.invoice_date != null ||
                        invoice.eway_bill_no != null ||
                        invoice.eway_bill_expirydate != null ||
                        invoice.invoice_no != null ||
                        invoice.invoice_quantity != null
                      ) {
                        filterInvoiceList.push(invoice);
                      }
                    });

                    temp.invoices =
                      filterInvoiceList.length > 0 ? formatInvoices(filterInvoiceList) : [];

                    temp.lr_other_charges =
                      o.lr_other_charges.length > 0 && o.lr_other_charges[0].charge_type_id != "" && o.lr_other_charges[0].charges != "" || deletedOtherCharges.length > 0
                        ? formatLrOtherCharges(o.lr_other_charges)
                        : [];
                    // temp.lr_other_charges.append(deletedOtherCharges)
                    deliveryValues[i] = temp;
                    let deliveries = { ...temp };

                    if (o?.fromEdit) {
                      CreatAxios({
                        completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${o.vendor_order_id}/create`,
                        payload: { deliveries: [deliveries] },
                      })
                        .then((response) => {
                          if (response.data.status == 1) {
                            let alert = {
                              type: "success",
                              messageHeader: "Success",
                              messageBody: `Delivery is updated.`,
                            };
                            props.successAlertDispatcher(alert);
                            getOrderDetails();
                            setSubmitting(false)
                            setDeliverySubmitting(false)
                          }
                        })
                        .catch((err) => {
                          let alert = {
                            type: "error",
                            messageHeader: "Error",
                            messageBody: err.response?.data?.message
                              ? err.response.data.message
                              : "Error while saving data...",
                          };
                          props.errorAlertDispatcher(alert);
                          setDeliverySubmitting(false)
                          console.log(err);
                        });
                    } else {
                      if(FEATURES.actWeightWarningOnDeliveryUpdation && !actWeightConfirmed && !temp?.actual_weight){
                        setActWeightConfirmationModal(true)
                        setDeliverySubmitting(false)
                        return;
                      }
                      if(FEATURES.weightAutoFillingInDelivery){
                        if(temp.actual_weight && !temp.gross_weight || Number(temp.gross_weight) <= 1) temp.gross_weight = temp.actual_weight ;
                        if(temp.gross_weight && (!temp.charged_weight || Number(temp.charged_weight) <= 1)) temp.charged_weight = temp.gross_weight
                      }
                      UpdateAxios({
                        patchURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${o.delivery_id}`,
                        payload: { ...temp },
                        uniqueId: o.delivery_id,
                      })
                        .then((response) => {
                          if (response.data.status == 1) {
                            let alert = {
                              type: "success",
                              messageHeader: "Success",
                              messageBody: `Delivery is updated.`,
                            };
                            // props.CloseModal(true);
                            props.successAlertDispatcher(alert);
                            // window.location.reload();
                            setDeliveryEditMode(false);
                            getOrderDetails();
                            // props.onFormSubmit();
                            setSubmitting(false)
                            setDeliverySubmitting(false)
                            setActWeightConfirmed(false)
                          }
                        })
                        .catch((err) => {
                          let alert = {
                            type: "error",
                            messageHeader: "Error",
                            messageBody: err.response?.data?.message
                              ? err.response.data.message
                              : "Error while saving data...",
                          };
                          props.errorAlertDispatcher(alert);
                          console.log(err);
                          setDeliverySubmitting(false)
                        });
                    }
                  } else if (
                    updateDeliveryLocation ||
                    updateDeliveryRefNo ||
                    updateRemarks ||
                    updateContainerNo ||
                    orderEditModeAftrAllotBillingParty||
                    orderEditModeAftrAllotServiceType
                  ) {
                    let temp = {};
                    values.deliveries.map((o, i) => {
                      temp.consignor_code = o.consignor
                        ? o.consignor.consignorCode
                        : null;
                      temp.consignee_code = o.consignee
                        ? o.consignee.consigneeCode
                        : null;
                      temp.pickup_area = o.pickup_area;
                      temp.drop_area = o.drop_area;
                      temp.deliver_to = o.deliver_to;
                      temp.delivery_reference_no = o.delivery_reference_no
                        ? o.delivery_reference_no
                        : null;
                      temp.remarks = o.remarks ? o.remarks : null;
                      temp.container_no = o.container_no ? o.container_no : null;
                      temp.billing_party_id = o.billing_party_id
                      ? o.billing_party_id
                      : null;
                    temp.billing_party_branch_id = o.billing_party_branch_id
                      ? o.billing_party_branch_id
                      : null;
                    
                    if(serviceTypeChanged) temp.service_type_id = o.service_type_id;

                      UpdateAxios({
                        patchURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${o.delivery_id}`,
                        payload: { ...temp },
                        uniqueId: o.delivery_id,
                      })
                        .then((response) => {
                          if (response.data.status == 1) {
                            let alert = {
                              type: "success",
                              messageHeader: "Success",
                              messageBody: `Delivery is updated.`,
                            };
                            setOrderEditModeAftrAllotConsignor(false);
                            setOrderEditModeAftrAllotConsignee(false);
                            setOrderEditModeAftrAllotDeliverTo(false);
                            setOrderEditModeAftrAllotDeliveryRefNo(false);
                            setOrderEditModeAftrAllotRemarks(false);
                            setorderEditModeAftrAllotContainerNumber(false);
                            //setOrderEditModeAftrAllotContainerNo(false); - commented because not decalared , only used here
                            setOrderEditModeAftrAllotBillingParty(false);
                            setOrderEditModeAftrAllotServiceType(false)
                            props.successAlertDispatcher(alert);
                            getOrderDetails();
                            setSubmitting(false);
                          }
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                    });
                  } else if ((orderEditMode) && (o.fromEdit == null || o.fromEdit == undefined)) {
                    setOrderSubmitting(true) ;
                    if(values.gross_weight && !AllRegex.INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS.test(values.gross_weight)){
                      cogoToast.error("Invalid gross weight value in order.");
                      setSubmitting(false);
                      setOrderSubmitting(false) ;
                      return;
                    }
                    let tempOrder = {};
                    tempOrder.gross_weight = values.gross_weight && Number(values.gross_weight);
                    tempOrder.freight_rate = values.freight_rate;
                    tempOrder.net_weight = values.net_weight && Number(values.net_weight);
                    tempOrder.proposed_vehicle_type =
                      values.proposed_vehicle_type;
                    tempOrder.service_type_id = values.service_type_id;
                    tempOrder.load_type_id = values.load_type_id;
                    tempOrder.min_temp = values.min_temp;
                    tempOrder.max_temp = values.max_temp;
                    tempOrder.mode_of_transport = values.mode_of_transport;
                    tempOrder.booking_branch_id = values.booking_branch_id;
                    tempOrder.ownership_type_id = values.ownership_type_id;
                    tempOrder.actual_hire_charge = values.actual_hire_charge
                    tempOrder.proposed_hire_charge = values.proposed_hire_charge
                    tempOrder.gross_volume = values.gross_volume

                    //validation for transaction details
                    if(FEATURES.transactionDetailsEnabled && values?.transaction_type_code){
                      // if(values?.transaction_type_code===TransactionTypes.PO || values?.transaction_type_code===TransactionTypes.STO){
                      //   if(getCurrentOrderDetails.transaction_amount && values.transaction_amount && getCurrentOrderDetails.transaction_amount != values.transaction_amount && Number(values.transaction_amount) < Number(getCurrentOrderDetails.transaction_amount)){
                      //     cogoToast.error("Transaction amount should be greater than existing tansaction amount",{position:"top-right"});
                      //     setSubmitting(false);
                      //     return;
                      //   }
                      // }
                      if(values?.transaction_type_code===TransactionTypes.PO || values?.transaction_type_code===TransactionTypes.STO || values?.transaction_type_code===TransactionTypes.SO){
                        values.cost_center_code = ''
                      }
                    }
                    tempOrder.transaction_type_code = values.transaction_type_code
                    tempOrder.transaction_no = values.transaction_no
                    // tempOrder.transaction_amount = values.transaction_amount
                    // tempOrder.transaction_quantity = values.transaction_quantity
                    tempOrder.company_code = values.company_code
                    tempOrder.gl_code = values.gl_code
                    tempOrder.cost_center_code = values.cost_center_code

                    UpdateAxios({
                      patchURL: `${process.env.REACT_APP_TA_API_URL}/orders/${props.currenOrder.vendor_order_id}`,
                      payload: { ...tempOrder },
                      uniqueId: props.currenOrder.vendor_order_id,
                    })
                      .then((response) => {
                        let alert = {
                          type: "success",
                          messageHeader: "Success",
                          messageBody: `Order is updated.`,
                        };
                        // props.CloseModal(true)
                        // window.location.reload()
                        setOrderEditMode(false);
                        setSapFieldsEditMode(false);
                        props.successAlertDispatcher(alert);
                        setOrderEditModeAftrAllotConsignor(false);
                        setOrderEditModeAftrAllotConsignee(false);
                        setOrderEditModeAftrAllotDeliverTo(false);
                        // props.onFormSubmit();
                        setSubmitting(false);
                        setOrderSubmitting(false) ;
                      })
                      .catch((err) => {
                        console.log(err);
                        let alert = {
                          type: "error",
                          messageHeader: "Error",
                          messageBody: err.response?.data?.message
                            ? err.response.data.message
                            : "Error while saving data...",
                        };
                        props.errorAlertDispatcher(alert);
                        setOrderSubmitting(false) ;
                      });
                  }else if (sapFieldsEditMode) {
                    setSapFieldsSubmitting(true);
                    let tempOrder = {};
                    tempOrder.order_id = props.currenOrder.vendor_order_id
                    tempOrder.common_order_id = props.currenOrder.common_order_id
                    tempOrder.transaction_no = values.transaction_no

                    UpdateAxios({
                      patchURL: `${process.env.REACT_APP_TA_API_URL}/orders/update/sap_details`,
                      payload: { ...tempOrder }
                    })
                      .then((response) => {
                        if(response && response.data && response.data.status == 1){
                          let alert = {
                            type: "success",
                            messageHeader: "Success",
                            messageBody: `Transaction Number Updated.`,
                          };
                          props.successAlertDispatcher(alert);
                          setOrderEditMode(false);
                          setSapFieldsEditMode(false);
                          setOrderEditModeAftrAllotConsignor(false);
                          setOrderEditModeAftrAllotConsignee(false);
                          setOrderEditModeAftrAllotDeliverTo(false);
                        }else{
                          let alert = {
                            type: "error",
                            messageHeader: "Error",
                            messageBody: response.data.message || `Something went wrong.`,
                          };
                          props.errorAlertDispatcher(alert);
                        }
                        setSubmitting(false);
                       setSapFieldsSubmitting(false) ;
                      })
                      .catch((err) => {
                        console.log(err);
                        let alert = {
                          type: "error",
                          messageHeader: "Error",
                          messageBody: err.response?.data?.message
                            ? err.response.data.message
                            : "Error while saving data...",
                        };
                        props.errorAlertDispatcher(alert);
                        setSapFieldsSubmitting(false) ;
                      });
                  }
                });
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              isSubmitting,
              handleBlur,
              setFieldValue,
              handleReset,
              submitForm
            }) => {
              setOrderFields = (name, value)=>{
                setFieldValue(name, value)
              }
              return(
              <Form className="ui form tiny">
                <Modal.Content>
                  <Modal.Description>
                    <>
                      <div className="pad w3-small w3-white">
                        <Grid columns={4} className="ml-2">
                          <Grid.Row>
                            <Grid.Column width={3}>
                              <Header
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("order_reference_no") ||
                                  "Order Reference Number"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                {getCurrentOrderDetails.order_no}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={3}>
                              <Header
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {(FEATURES.weightInTonCustomers ? t("gross_weight_ton") : t("gross_weight")) || "Gross Weight"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={3}>
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                <Field
                                  disabled={orderEditMode ? false : true}
                                  className="p-disabled"
                                  type="number"
                                  component={MyNormalInput}
                                  name="gross_weight"
                                />
                              </Header>
                            </Grid.Column>
                            <Grid.Column floated="right" width={3}>
                              {props.currenOrder.allotment_status ? (
                                <>
                                  { props?.currenOrder?.undo_vendor_possible && (
                                    <>
                                      {props.edit == true ? (
                                        <>
                                          <Button
                                            icon
                                            basic
                                            size="mini"
                                            className="ui green"
                                            disabled={
                                              props.role == "Quality Control"
                                                ? true
                                                : false
                                            }
                                            type="button"
                                            onClick={() => {
                                              setOrderEditMode(!orderEditMode);
                                            }}
                                          >
                                            <Icon
                                              name={
                                                orderEditMode ? "times" : "edit"
                                              }
                                            />
                                          </Button>
                                        </>
                                      ) : null}

                                      {orderEditMode ? (
                                        <Button
                                          icon
                                          basic
                                          size="mini"
                                          className="ui blue"
                                          disabled={
                                            props.role == "Quality Control"
                                              ? true
                                              : false
                                          }
                                          type={"button"}
                                          onClick={()=>{
                                            if(!orderSubmitting){
                                              setConigneeToPayError(false)
                                              setSapFieldsEditMode(false)
                                              setDeliveryEditMode(false)
                                              submitForm();
                                            }
                                          }}
                                        >
                                          <Icon name={orderSubmitting ? "loading spinner" : "save"} />
                                        </Button>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {props.edit == true ? (
                                    <>
                                      <Button
                                        icon
                                        basic
                                        size="mini"
                                        className="ui green"
                                        disabled={
                                          props.role == "Quality Control"
                                            ? true
                                            : false
                                        }
                                        type="button"
                                        onClick={() => {
                                          setOrderEditMode(!orderEditMode);
                                        }}
                                      >
                                        <Icon
                                          name={
                                            orderEditMode ? "times" : "edit"
                                          }
                                        />
                                      </Button>
                                    </>
                                  ) : null}

                                  {orderEditMode ? (
                                    <Button
                                      icon
                                      basic
                                      className="ui blue"
                                      size="mini"
                                      disabled={
                                        props.role == "Quality Control"
                                          ? true
                                          : false
                                      }
                                      type={isSubmitting ? "button" : "submit"}
                                    >
                                      <Icon name={isSubmitting ? "loading spinner" : "save"} />
                                    </Button>
                                  ) : (
                                    ""
                                  )}
                                </>
                              )}
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row>
                            {props.role == "Elixir" ||
                              props.role == "Administrator" ? (
                              <>
                                <Grid.Column width={3}>
                                  <Header
                                    className="p-bold-200 labelName"
                                    size="tiny"
                                    as="label"
                                    color="grey"
                                  >
                                    {t("final_rate") || "Final Rate"}
                                  </Header>
                                </Grid.Column>
                                <Grid.Column width={4}>
                                  <Header
                                    className="p-bold-500 labelName"
                                    size="tiny"
                                    as="label"
                                    color="black"
                                  >
                                    <Field
                                      disabled={orderEditMode ? false : true}
                                      type="number"
                                      component={numberInput}
                                      name="freight_rate"
                                      value={values.freight_rate}
                                    />
                                  </Header>
                                </Grid.Column>
                              </>
                            ) : null}
                            <Grid.Column width={3}>
                              <Header
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("proposed_vehicle_type") ||
                                  "Proposed Vehicle Type"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                <Field
                                  disabled={orderEditMode ? false : true}
                                  className="p-disabled"
                                  component={MyVehicleType}
                                  value={+values.proposed_vehicle_type}
                                  name="proposed_vehicle_type"
                                />
                              </Header>
                            </Grid.Column>
                          </Grid.Row>

                          <Grid.Row>
                            {props.movement_type &&
                              (props.movement_type === "Primary" ||
                                props.movement_type === "Primário") ? (
                              <>

                                <Grid.Column width={3}>
                                  <Header
                                    className="p-bold-200 labelName"
                                    size="tiny"
                                    as="label"
                                    color="grey"
                                  >
                                    {t("load_type") || "Load Type"}
                                  </Header>
                                </Grid.Column>
                                <Grid.Column width={4}>
                                  <Header
                                    className="p-bold-500 labelName"
                                    size="tiny"
                                    as="label"
                                    color="black"
                                  >
                                    <Field
                                      component={MyLoad}
                                      disabled={orderEditMode ? false : true}
                                      className="p-disabled"
                                      value={values.load_type_id}
                                      name="load_type_id"
                                    />
                                  </Header>
                                </Grid.Column>

                              </>
                            ) : null}

                            <Grid.Column width={3}>
                              <Header
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                              >
                                {(FEATURES.weightInTonCustomers? t("actual_weight_ton") : t("actual_weight")) ||
                                                "Actual Weight"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={3}>
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                <Field
                                  readOnly
                                  className="p-disabled"
                                  type="number"
                                  component={MyNormalInput}
                                  value={values?.deliveries.reduce((actualVal, object) => {
                                    return parseFloat(actualVal) + (object?.actual_weight && object?.actual_weight > 0 ? Number(object?.actual_weight) : 0)
                                  }, 0)}
                                />
                              </Header>
                            </Grid.Column>
                          </Grid.Row>

                          <Grid.Row>
                            {values.load_type_id == "1" ||
                              values.load_type_id == "2" ||
                              values.load_type_id == "3" ? (
                              <>

                                <Grid.Column width={3}>
                                  <Header
                                    className="p-bold-200 labelName"
                                    size="tiny"
                                    as="label"
                                    color="grey"
                                  >
                                    {t("temp_min") || "Temperature Minimum"}
                                  </Header>
                                </Grid.Column>
                                <Grid.Column width={4}>
                                  <Header
                                    className="p-bold-500 labelName"
                                    size="tiny"
                                    as="label"
                                    color="black"
                                  >
                                    <Field
                                      disabled={orderEditMode ? false : true}
                                      type="number"
                                      component={MyNormalInput}
                                      name="min_temp"
                                      value={values.min_temp}
                                      error={
                                        getIn(errors, `min_temp`) &&
                                          getIn(touched, `min_temp`)
                                          ? true
                                          : false
                                      }
                                    />
                                    {
                                      <ErrorMessages
                                        name="min_temp"
                                        trans={"delivery_form.temperature_min"}
                                      />
                                    }
                                  </Header>
                                </Grid.Column>
                                <Grid.Column width={3}>
                                  <Header
                                    className="p-bold-200 labelName"
                                    size="tiny"
                                    as="label"
                                    color="grey"
                                  >
                                    {t("temp_max") || "Temperature Maximum"}
                                  </Header>
                                </Grid.Column>
                                <Grid.Column width={4}>
                                  <Header
                                    className="p-bold-500 labelName"
                                    size="tiny"
                                    as="label"
                                    color="black"
                                  >
                                    <Field
                                      disabled={orderEditMode ? false : true}
                                      type="number"
                                      component={MyNormalInput}
                                      name="max_temp"
                                      error={
                                        getIn(errors, `max_temp`) &&
                                          getIn(touched, `max_temp`)
                                          ? true
                                          : false
                                      }
                                    />
                                    {
                                      <ErrorMessages
                                        name="max_temp"
                                        trans={"delivery_form.temperature_max"}
                                      />
                                    }
                                  </Header>
                                </Grid.Column>

                              </>
                            ) : null}


                          </Grid.Row>

                          <Grid.Row>

                            <Grid.Column width={3} style={orderDetails} >
                              <Header
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("ownership_type") || "Ownership Type"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4} style={orderDetails}>
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                <Dropdown
                                  clearable
                                  style={{
                                    width: "100%",
                                    fontWeight: "normal",
                                  }}
                                  search
                                  selection
                                  disabled={orderEditMode ? false : true}
                                  placeholder={
                                    props.t("ownership_type") ||
                                    "Vehicle Ownership Type"
                                  }
                                  value={values.ownership_type_id}
                                  onChange={(name, data) => {
                                    setFieldValue(
                                      "ownership_type_id",
                                      data.value
                                    );
                                  }}
                                  options={ownership}
                                />
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={3} style={orderDetails}>
                              <Header
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("booking_branch") || "Booking Branch"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4} style={orderDetails}>
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                <Dropdown
                                  clearable
                                  style={{
                                    width: "100%",
                                    fontWeight: "normal",
                                  }}
                                  search
                                  selection
                                  disabled={orderEditMode ? false : true}
                                  placeholder={
                                    props.t("booking_branch") ||
                                    "Booking Branch"
                                  }
                                  value={values.booking_branch_id}
                                  onChange={(name, data) => {
                                    setFieldValue(
                                      "booking_branch_id",
                                      data.value
                                    );
                                  }}
                                  options={userbranchs}
                                />
                              </Header>
                            </Grid.Column>
                          </Grid.Row>

                          <Grid.Row>
                          <Grid.Column width={3}>
                              <Header
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("actual_hire_charge") ||
                                  "Actual Hire Charge"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                <Field
                                  name="actual_hire_charge"
                                  style={{
                                    width: "100%",
                                    fontWeight: "normal",
                                  }}
                                  value={values.actual_hire_charge}
                                  type="number"
                                  disabled={orderEditMode ? false : true}
                                />
                              </Header>
                            </Grid.Column>

                            <Grid.Column width={3}>
                              <Header
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("proposed_hire_charge") ||
                                  "Proposed Hire Charge"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                <Field
                                  name="proposed_hire_charge"
                                  style={{
                                    width: "100%",
                                    fontWeight: "normal",
                                  }}
                                  value={values.proposed_hire_charge}
                                  type="number"
                                  disabled={orderEditMode ? false : true}
                                />
                              </Header>
                            </Grid.Column>
                          </Grid.Row>

                          <Grid.Row>
                            <Grid.Column width={3} style={scheduleAccess}>
                              <Header
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("Mode of Transport") ||
                                  "Mode of Transport"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4} style={scheduleAccess}>
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                <Field
                                  component={ModeOfTransportDropdown}
                                  disabled={orderEditMode ? false : true}
                                  name="mode_of_transport"
                                  style={{
                                    width: "100%",
                                    fontWeight: "normal",
                                  }}
                                  value={values.mode_of_transport}
                                />
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={3}>
                              <Header
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("gross_volume") ||
                                  "Volume"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                <Field
                                  name="gross_volume"
                                  style={{
                                    width: "100%",
                                    fontWeight: "normal",
                                  }}
                                  value={values.gross_volume}
                                  type="number"
                                  disabled={orderEditMode ? false : true}
                                />
                              </Header>
                            </Grid.Column>
                          </Grid.Row>
                          {
                            FEATURES.transactionDetailsEnabled &&
                            <>         
                            <Grid.Row>
                            <Table>
                            <Table.Header>
                                <Table.Row>
                                <Table.HeaderCell colSpan="16">SAP Integration Fields</Table.HeaderCell>
                                <Table.HeaderCell textAlign="right">

                                    <Button
                                        icon
                                        basic
                                        size="mini"
                                        className="ui green"
                                        disabled={
                                          props.role == "Quality Control"
                                          ? true
                                          : (sapFieldEditFlag ? false : true)
                                        }
                                        type="button"
                                        onClick={() => {
                                          setSapFieldsEditMode(!sapFieldsEditMode);
                                        }}
                                        >
                                        <Icon
                                          name={
                                            sapFieldsEditMode ? "times" : "edit"
                                          }
                                          />
                                      </Button>
                                    {sapFieldsEditMode && (
                                    <Button
                                      icon
                                      basic
                                      className="ui blue"
                                      size="mini"
                                      disabled={
                                        props.role == "Quality Control"
                                          ? true
                                          : false
                                      }
                                      type="button"
                                      onClick={()=> {
                                        if(!sapFieldsSubmitting){
                                          setConigneeToPayError(false)
                                          setDeliveryEditMode(false)
                                          setOrderEditMode(false)
                                          submitForm();
                                        }
                                      }}
                                    >
                                      <Icon name={sapFieldsSubmitting ? "loading spinner" : "save"} />
                                    </Button>
                                  )}
                                      </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                            <Table.Row>
                            <Table.Cell colSpan="3">
                              <Header
                                className={`p-bold-200 labelName ${getCurrentOrderDetails.transaction_type_code &&"disabled"}`}
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("transaction_type") ||
                                  "Transaction Type"}
                              </Header>
                              </Table.Cell>
                            <Table.Cell colSpan="3">
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                <Field
                                  component={MyTransactionTypes}
                                  name="transaction_type_code"
                                  value={values.transaction_type_code}
                                  className={`${getCurrentOrderDetails.transaction_type_code &&"disabled"}`}
                                  disabled={sapFieldsEditMode && !getCurrentOrderDetails.transaction_type_code ? false : true}
                                />
                              </Header>
                              </Table.Cell>

                            <Table.Cell colSpan="3">
                              <Header
                                className={`p-bold-200 labelName ${!sapFieldEditFlag &&"disabled"}`}
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("transaction_no") ||
                                  "Transaction Number"}
                              </Header>
                              </Table.Cell>
                            <Table.Cell colSpan="3">
                              <Header
                                className={`p-bold-500 labelName`}
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                <Field
                                  name="transaction_no"
                                  style={{
                                    width: "100%",
                                    fontWeight: "normal",
                                  }}
                                  className={`${getCurrentOrderDetails.transaction_type_code &&"disabled"}`}
                                  value={values.transaction_no}
                                  disabled={sapFieldsEditMode && sapFieldEditFlag ? false : true}
                                />
                                {
                                  errors?.transaction_no && <small className="text-danger">{errors.transaction_no}</small>
                                }
                              </Header>
                              </Table.Cell>
                              {/* <Table.Cell colSpan="3">
                              <Header
                                className={`p-bold-200 labelNam ${(values.transaction_type_code && (values.transaction_type_code==TransactionTypes.OTHERS || values.transaction_type_code==TransactionTypes.SO) && "disabled")}`}
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("transaction_amount") ||
                                  "Transaction Amount"}
                              </Header>
                              </Table.Cell>
                            <Table.Cell colSpan="3">
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                
                                <Field
                                component={MyInput}
                                name="transaction_amount"
                                disabled={orderEditMode && (values.transaction_type_code==TransactionTypes.PO || values.transaction_type_code==TransactionTypes.STO) ? false : true}
                                value={values.transaction_amount}
                                />
                                {
                                  errors?.transaction_amount && <small className="text-danger">{errors.transaction_amount}</small>
                                }
                              </Header>
                              </Table.Cell>
                            
                              </Table.Row>

                            <Table.Row>
                            <Table.Cell colSpan="3">
                              <Header
                                className={`p-bold-200 labelNam`}
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("transaction_quantity") ||
                                  "Transaction Quantity"}
                              </Header>
                              </Table.Cell>
                            <Table.Cell colSpan="3">
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                
                                <Field
                                component={MyInput}
                                type="number"
                                name="transaction_quantity"
                                disabled={orderEditMode && !getCurrentOrderDetails.transaction_type_code ? false : true}
                                value={values.transaction_quantity}
                                />
                                {
                                  errors?.transaction_quantity && <small className="text-danger">{errors.transaction_quantity}</small>
                                }
                              </Header>
                              </Table.Cell> */}
                              <Table.Cell colSpan="3">
                              <Header
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("company") ||
                                  "Company"}
                              </Header>
                              </Table.Cell>
                            <Table.Cell colSpan="3">
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                <Field
                                  component={MyCompanyCode}
                                  name="company_code"
                                  value={values.company_code}
                                  disabled={sapFieldsEditMode ? false : true}
                                />
                              </Header>
                              </Table.Cell>
                          
                            
                              </Table.Row>

                            <Table.Row>
                          <Table.Cell colSpan="3">
                              <Header
                                className={`p-bold-200 labelName`}
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("gl_code") ||
                                  "GL Code"}
                              </Header>
                              </Table.Cell>
                            <Table.Cell colSpan="3">
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                <Field
                                  component={MyGLCode}
                                  name="gl_code"
                                  value={values.gl_code}
                                  disabled={sapFieldsEditMode ? false : true}
                                  transactionType = {values?.transaction_type_code}
                                />
                                
                                
                              </Header>
                              </Table.Cell>
                              <Table.Cell colSpan="3">
                              <Header
                                className={`p-bold-200 labelName ${(values?.transaction_type_code && 
                                  (values?.transaction_type_code===TransactionTypes.PO || values?.transaction_type_code===TransactionTypes.STO || values?.transaction_type_code===TransactionTypes.SO)) && "disabled"}`}
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("cost_center") ||
                                  "Cost Center"}
                              </Header>
                              </Table.Cell>
                            <Table.Cell colSpan="3">
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                {(values?.transaction_type_code && 
                                  (values?.transaction_type_code===TransactionTypes.PO || values?.transaction_type_code===TransactionTypes.STO || values?.transaction_type_code===TransactionTypes.SO)) ? 
                                  <>
                                  <Field
                                  component={MyInput}
                                  name="cost_center_code"
                                  disabled={true}
                                /> 
                                </>: 
                                <Field
                                component={MyCostCenter}
                                name="cost_center_code"
                                costCenterName='cost_center_name'
                                value={values.cost_center_code}
                                disabled={sapFieldsEditMode ? false : true}
                                />}
                                
                              </Header>
                              </Table.Cell>

                              </Table.Row>
                            </Table.Body>
                            </Table>
                            </Grid.Row>
                            </>
                          }



                          <FieldArray
                            name="deliveries"
                            render={(arrayHelpers) => (
                              <>
                                {values.deliveries.map((delivery, index) => (
                                  <Grid.Row key={`delivery+${index}`}>
                                    <Table unstackable key="deliveries-table">
                                      <Table.Header>
                                        <Table.Row>
                                          <Table.HeaderCell colSpan="9">
                                            {t("delivery_title") || "Delivery"} {index + 1}
                                          </Table.HeaderCell>
                                          <Table.HeaderCell textAlign="right">
                                            {!values?.deliveries?.[index]
                                              ?.fromEdit &&
                                              props.currenOrder
                                                .allotment_status ? (
                                              <>
                                                { props?.currenOrder?.undo_vendor_possible && (
                                                  <>
                                                    {props.edit == true ? (
                                                      <>
                                                        <Button
                                                          icon
                                                          basic
                                                          className="ui green"
                                                          size="mini"
                                                          type="button"
                                                          disabled={
                                                            props.role ==
                                                              "Quality Control"
                                                              ? true
                                                              : false
                                                          }
                                                          onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setFieldValue(
                                                              `deliveries[${index}]['active']`,
                                                              !values
                                                                .deliveries[
                                                              index
                                                              ]["active"]
                                                            );
                                                            deliveryEditMode && setConigneeToPayError(false) ;
                                                            setDeliveryEditMode(!deliveryEditMode)
                                                            values.deliveries[
                                                              index
                                                            ]["active"]
                                                              ? handleReset()
                                                              : null;
                                                          }}
                                                        >
                                                          <Icon
                                                            name={
                                                              values.deliveries[
                                                                index
                                                              ]["active"]
                                                                ? "times"
                                                                : "edit"
                                                            }
                                                          />
                                                        </Button>
                                                      </>
                                                    ) : null}

                                                    {values.deliveries[index][
                                                      "active"
                                                    ] ? (
                                                      <Button
                                                        icon
                                                        basic
                                                        className="ui blue"
                                                        type={"button"}
                                                        size="mini"
                                                        onClick={deliverySubmitting ? null :
                                                          () =>{
                                                            !values.deliveries[
                                                            index
                                                            ]["active"];

                                                            setOrderEditMode(false)
                                                            setSapFieldsEditMode(false)
                                                            submitForm();
                                                          }
                                                        }
                                                      >
                                                        <Icon name={deliverySubmitting ? "loading spinner" : "save"} />
                                                      </Button>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                {!values?.deliveries?.[index]
                                                  ?.fromEdit &&
                                                  props.edit == true ? (
                                                  <>
                                                    <Button
                                                      icon
                                                      basic
                                                      size="mini"
                                                      className="ui green"
                                                      type="button"
                                                      disabled={
                                                        props.role ==
                                                          "Quality Control"
                                                          ? true
                                                          : false
                                                      }
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setFieldValue(
                                                          `deliveries[${index}]['active']`,
                                                          !values.deliveries[
                                                          index
                                                          ]["active"]
                                                        );
                                                        setDeliveryEditMode(!deliveryEditMode)
                                                        values.deliveries[
                                                          index
                                                        ]["active"]
                                                          ? handleReset()
                                                          : null;
                                                      }}
                                                    >
                                                      <Icon
                                                        name={
                                                          values.deliveries[
                                                            index
                                                          ]["active"]
                                                            ? "times"
                                                            : "edit"
                                                        }
                                                      />
                                                    </Button>
                                                  </>
                                                ) : null}
                                                {!values?.deliveries?.[index]
                                                  ?.fromEdit &&
                                                  values.deliveries[index][
                                                  "active"
                                                  ] ? (
                                                  <Button
                                                    icon
                                                    basic
                                                    size="mini"
                                                    className="ui blue"
                                                    type={isSubmitting ? "button" : "submit"}
                                                    onClick={isSubmitting ? null :
                                                      () =>
                                                        !values.deliveries[index][
                                                        "active"
                                                        ]
                                                    }
                                                  >
                                                    <Icon name={isSubmitting ? "loading spinner" : "save"} />
                                                  </Button>
                                                ) : (
                                                  ""
                                                )}
                                              </>
                                            )}
                                            {props.edit == true &&
                                              values?.deliveries?.[index]
                                                ?.fromEdit ? (
                                              <>
                                                <Button
                                                  icon
                                                  basic
                                                  className="ui red"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    removeAddedDelivery(
                                                      e,
                                                      values.deliveries[index],
                                                      index
                                                    );
                                                  }}
                                                >
                                                  <Icon name="remove" />
                                                </Button>
                                                <Button
                                                  icon
                                                  basic
                                                  className="ui blue"
                                                  type={isSubmitting ? "button" : "submit"}
                                                >
                                                  <Icon name={isSubmitting ? "loading spinner" : "save"} />
                                                </Button>
                                              </>
                                            ) : null}
                                          </Table.HeaderCell>
                                        </Table.Row>
                                      </Table.Header>
                                      <Table.Body>
                                        <Table.Row>
                                          <Table.Cell colSpan="4">
                                            <Header
                                              className="p-bold-200 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {t("delivery_reference_number") ||
                                                "Reference Number"}
                                            </Header>
                                          {/* </Table.Cell>
                                          <Table.Cell colSpan="2"> */}
                                            <div className="display-flex-center">
                                              {/* <Header
                                                className="p-bold-500 labelName margin-0"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              > */}
                                                {!values.deliveries[index][
                                                  "active"
                                                ] &&
                                                  !(
                                                    orderEditModeAftrAllotDeliveryRefNo &&
                                                    props.edit &&
                                                    ((props?.currenOrder
                                                      ?.allotment_status &&
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "ALLOC") ||
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "CANCEL" ||
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "COMPLETE")
                                                  ) ? (
                                                  <>
                                                    {
                                                      delivery.delivery_reference_no
                                                    }

                                                    {props.edit &&
                                                      ((props?.currenOrder
                                                        ?.allotment_status &&
                                                        props?.currenOrder
                                                          ?.allotment_status
                                                          ?.allotment_code ==
                                                        "ALLOC") ||
                                                        props?.currenOrder
                                                          ?.allotment_status
                                                          ?.allotment_code ==
                                                        "CANCEL" ||
                                                        props?.currenOrder
                                                          ?.allotment_status
                                                          ?.allotment_code ==
                                                        "COMPLETE") ? (
                                                      <>
                                                        <Button
                                                          icon
                                                          basic
                                                          size="medium"
                                                          className="margin-left-20 green"
                                                          disabled={
                                                            props.role ==
                                                              "Quality Control"
                                                              ? true
                                                              : false
                                                          }
                                                          type="button"
                                                          onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setOrderEditModeAftrAllotDeliveryRefNo(
                                                              true
                                                            );
                                                          }}
                                                        >
                                                          <Icon name="edit" />
                                                        </Button>
                                                      </>
                                                    ) : null}
                                                  </>
                                                ) : (
                                                  <>
                                                    <Field
                                                      style={{
                                                        // paddingTop: "5.5px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                      component={MyInput}
                                                      name={`deliveries[${index}].delivery_reference_no`}
                                                      value={
                                                        values.deliveries[index]
                                                          .delivery_reference_no
                                                      }
                                                      className="width70"
                                                    />
                                                  </>
                                                )}
                                              {/* </Header> */}
                                              <Header className="margin-0">
                                                {!values.deliveries[index][
                                                  "active"
                                                ] &&
                                                  !(
                                                    orderEditModeAftrAllotDeliveryRefNo &&
                                                    props.edit &&
                                                    ((props?.currenOrder
                                                      ?.allotment_status &&
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "ALLOC") ||
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "CANCEL" ||
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "COMPLETE")
                                                  ) ? null : (
                                                  <>
                                                    {!values.deliveries[index][
                                                      "active"
                                                    ] ||
                                                      (orderEditModeAftrAllotDeliveryRefNo &&
                                                        props.edit &&
                                                        ((props?.currenOrder
                                                          ?.allotment_status &&
                                                          props?.currenOrder
                                                            ?.allotment_status
                                                            ?.allotment_code ==
                                                          "ALLOC") ||
                                                          props?.currenOrder
                                                            ?.allotment_status
                                                            ?.allotment_code ==
                                                          "CANCEL" ||
                                                          props?.currenOrder
                                                            ?.allotment_status
                                                            ?.allotment_code ==
                                                          "COMPLETE")) ? (
                                                      <>
                                                        <div className="order-edit-mode-allot display-flex-center-justify-spacearnd">
                                                          <Button
                                                            className="ui blue"
                                                            disabled={
                                                              props.role ==
                                                                "Quality Control"
                                                                ? true
                                                                : false
                                                            }
                                                            onClick={isSubmitting ? null :
                                                              (e) => {
                                                                e.stopPropagation();
                                                                setUpdateDeliveryRefNo(
                                                                  true
                                                                );
                                                              }}
                                                            type={isSubmitting ? "button" : "submit"}
                                                            basic
                                                            size="medium"
                                                            icon
                                                          >
                                                            <Icon name={isSubmitting ? "loading spinner" : "save"} />
                                                          </Button>
                                                          <Button
                                                            className="ui blue"
                                                            // className="order-edit-mode-allot"
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              /*cancelOrderUpdate();*/ setUpdateDeliveryRefNo(
                                                                true
                                                              );
                                                              setOrderEditModeAftrAllotDeliveryRefNo(
                                                                false
                                                              );
                                                            }}
                                                            basic
                                                            size="medium"
                                                            icon
                                                          >
                                                            <Icon name="times" />
                                                          </Button>
                                                        </div>
                                                      </>
                                                    ) : null}
                                                  </>
                                                )}
                                              </Header>
                                            </div>
                                          </Table.Cell>

                                          <Table.Cell colSpan="4" style={orderDetails}>
                                            <Header
                                              className="p-bold-200 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {t("lr_no") || "LR Number"}
                                            </Header>
                                          {/* </Table.Cell>
                                          <Table.Cell colSpan="2" style={orderDetails}> */}
                                            {/* <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="black"
                                            > */}
                                              <div>
                                              <Field
                                                disabled={
                                                  !values.deliveries[index][
                                                  "active"
                                                  ]
                                                }
                                                readOnly={ FEATURES.lr_series_fixed_customer ?  props?.currenOrder?.vendor_name && FEATURES.lr_series_fixed(props.currenOrder.vendor_name) && values.deliveries[index].is_lr_generated_by_lr_series : values.deliveries[index].is_lr_generated_by_lr_series}
                                                name={`deliveries[${index}].lr_no`}
                                                component={MyNormalInput}
                                                className="width80"
                                              />
                                            </div>
                                            {/* </Header> */}
                                          </Table.Cell>
                                          <Table.Cell style={orderDetails} colSpan="4">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {t("lr_date") || "LR Date"}
                                            </Header>
                                          {/* </Table.Cell>
                                          <Table.Cell style={orderDetails}> */}
                                          <div className="width80">
                                            {/* <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            > */}
                                              {!values.deliveries[index][
                                                "active"
                                              ] ? (
                                                <>
                                                  {values.deliveries[index]
                                                    .lr_date
                                                    ? moment(
                                                      values.deliveries[
                                                        index
                                                      ].lr_date
                                                    ).format("DD-MM-YYYY")
                                                    : "NA"}
                                                </>
                                              ) : (
                                                <DateData
                                                  name={`deliveries.[${index}].lr_date`}
                                                  disabled={
                                                    !values.deliveries[
                                                    index
                                                    ]["active"]
                                                  }
                                                  autoComplete="off"
                                                  popperClassName="dateTime"
                                                  dateFormat="dd/MM/yyyy"
                                                  selected={
                                                    new Date(
                                                      values.deliveries[
                                                        index
                                                      ].lr_date
                                                    )
                                                  }
                                                  timeIntervals={5}
                                                  customInput={
                                                    <Input
                                                      icon="time"
                                                      iconPosition="left"
                                                    />
                                                  }
                                                />
                                              )}
                                            {/* </Header> */}
                                            </div>
                                          </Table.Cell>
                                        </Table.Row>

                                        <Table.Row style={orderDetails}>
                                          <>
                                            <Table.Cell colSpan="2">
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {t("booking_branch") ||
                                                  "Booking Branch"}
                                              </Header>
                                            </Table.Cell>
                                            <Table.Cell colSpan="2">
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {!values.deliveries[index][
                                                  "active"
                                                ] ? (
                                                  <>
                                                    {values.deliveries[index]
                                                      .booking_branch_name
                                                      ? values.deliveries[index]
                                                        .booking_branch_name
                                                      : "NA"}
                                                  </>
                                                ) : (
                                                  <Dropdown
                                                    clearable
                                                    style={{
                                                      width: "100%",
                                                      fontWeight: "normal",
                                                    }}
                                                    search
                                                    selection
                                                    disabled={
                                                      !values.deliveries[index][
                                                      "active"
                                                      ]
                                                    }
                                                    placeholder={
                                                      props.t(
                                                        "booking_branch"
                                                      ) || "Booking Branch"
                                                    }
                                                    value={
                                                      values.deliveries[index]
                                                        .booking_branch_id
                                                    }
                                                    onChange={(name, data) => {
                                                      data.options.map(
                                                        (item, o) => {
                                                          if (
                                                            item.raw.branchId ==
                                                            data.value
                                                          ) {
                                                            setFieldValue(
                                                              `deliveries[${index}].booking_branch_name`,
                                                              item.raw
                                                                .branchName
                                                            );
                                                          }
                                                        }
                                                      );
                                                      setFieldValue(
                                                        `deliveries[${index}].booking_branch_id`,
                                                        data.value
                                                      );
                                                      FEATURES.lr_series_activated && handleLRSeriesNo(data.value, index,setFieldValue)
                                                    }}
                                                    options={userbranchs}
                                                  />
                                                )}
                                              </Header>
                                            </Table.Cell>
                                          </>

                                          <>
                                            <Table.Cell colSpan="2">
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {t("billing_branch") ||
                                                  "Billing Branch"}
                                              </Header>
                                            </Table.Cell>
                                            <Table.Cell colSpan="2">
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {!values.deliveries[index][
                                                  "active"
                                                ] ? (
                                                  <>
                                                    {values.deliveries[index]
                                                      .billing_branch_name
                                                      ? values.deliveries[index]
                                                        .billing_branch_name
                                                      : "NA"}
                                                  </>
                                                ) : (
                                                  <Dropdown
                                                    clearable
                                                    style={{
                                                      width: "100%",
                                                      fontWeight: "normal",
                                                    }}
                                                    search
                                                    selection
                                                    disabled={
                                                      !values.deliveries[index][
                                                      "active"
                                                      ]
                                                    }
                                                    placeholder={
                                                      props.t(
                                                        "billing_branch"
                                                      ) || "Billing Branch"
                                                    }
                                                    value={
                                                      values.deliveries[index]
                                                        .billing_branch_id
                                                    }
                                                    onChange={(name, data) => {
                                                      data.options.map(
                                                        (item, o) => {
                                                          if (
                                                            item.raw.branchId ==
                                                            data.value
                                                          ) {
                                                            setFieldValue(
                                                              `deliveries[${index}].billing_branch_name`,
                                                              item.raw
                                                                .branchName
                                                            );
                                                          }
                                                        }
                                                      );
                                                      setFieldValue(
                                                        `deliveries[${index}].billing_branch_id`,
                                                        data.value
                                                      );
                                                    }}
                                                    options={userbranchs}
                                                  />
                                                )}
                                              </Header>
                                            </Table.Cell>
                                          </>

                                          <>
                                            <Table.Cell>
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {t("customer_type") ||
                                                  "Customer Type"}
                                              </Header>
                                            </Table.Cell>
                                            <Table.Cell>
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {!values.deliveries[index][
                                                  "active"
                                                ] ? (
                                                  <>
                                                    {values.deliveries[index]
                                                      .customer_type_name
                                                      ? values.deliveries[index]
                                                        .customer_type_name
                                                      : "NA"}
                                                  </>
                                                ) : (
                                                  <Dropdown
                                                    clearable
                                                    style={{
                                                      width: "100%",
                                                      fontWeight: "normal",
                                                    }}
                                                    search
                                                    selection
                                                    name={`deliveries[${index}].customer_type_id`}
                                                    placeholder={
                                                      values.deliveries[index]
                                                        .customer_type_name
                                                    }
                                                    value={
                                                      values.deliveries[index]
                                                        .customer_type_id
                                                    }
                                                    onChange={(name, data) => {
                                                      if (data?.value) {
                                                        setFieldValue(
                                                          `deliveries[${index}].customer_type_id`,
                                                          data.value
                                                        )
                                                        let payload = {
                                                          customer_type_id : data.value,
                                                          consignee_name : values.deliveries[index]?.consignee?.name,
                                                          billing_party_id : values.deliveries[index]?.billing_party_id,
                                                          contractual_customer_id : values.deliveries[index]?.contractual_customer_id
                                                        }
                                                        handleConsigneeCustomerTypeChange(payload, index, setFieldValue);
                                                      } else {
                                                        setFieldValue(
                                                          `deliveries[${index}].customer_type_name`,
                                                          null
                                                        )
                                                      }
                                                    }}
                                                    options={customertype}
                                                  />
                                                )}
                                              </Header>
                                            </Table.Cell>

                                          </>
                                        </Table.Row>

                                        <Table.Row style={orderDetails} className="p-4">
                                          <>
                                            <Table.Cell colSpan="2" className={FEATURES.editBillingPartyAfterAllocation && `border border-right-0`}>
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {t("billing_party") ||
                                                  "Billing Party"}
                                              </Header>
                                            </Table.Cell>
                                            <Table.Cell colSpan="2" className={FEATURES.editBillingPartyAfterAllocation && `border-top border-bottom`}>
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {!values.deliveries[index]["active"] && !orderEditModeAftrAllotBillingParty ? (
                                                  <>
                                                    {values.deliveries[index]
                                                      .billing_party_name
                                                      ? values.deliveries[index]
                                                        .billing_party_name
                                                      : "NA"}
                                                  </>
                                                ) : (
                                                  <Field
                                                    name={`deliveries[${index}].billing_party_id`}
                                                    defaultValue={
                                                      values.deliveries[index]
                                                        .billing_party_id
                                                    }
                                                    value={values.deliveries[index]
                                                      .billing_party_id}
                                                    placeholder={
                                                      values.deliveries[index]
                                                        .billing_party_id
                                                        ? values.deliveries[
                                                          index
                                                        ].billing_party_name
                                                        : props.t(
                                                          "billing_party"
                                                        ) || "Billing Party"
                                                    }
                                                    component={
                                                      MyBillingPartyComponent
                                                    }
                                                    getBillingPartySelected={
                                                      getBillingPartySelected
                                                    }
                                                    getConsigneeConsignorArray={
                                                      getConsigneeConsignorArray
                                                    }
                                                    billingPartyId={
                                                      values.deliveries[index]
                                                        .billing_party_id
                                                    }
                                                    customerTypeName={`deliveries[${index}].customer_type_name`}
                                                    customerTypeId={`deliveries[${index}].customer_type_id`}
                                                    billingPartyBranchId={`deliveries[${index}].billing_party_branch_id`}
                                                    billingPartyBranchName={`deliveries[${index}].billing_party_branch_name`}
                                                    consignorCode={`deliveries[${index}].consignor.consignorCode`}
                                                    consignorGst={`deliveries[${index}].consignor.gst_number`}
                                                    deliverToAddress={`deliveries[${index}].deliver_to_address`}
                                                    consignorAddress={`deliveries[${index}].consignor.consignor_address`}
                                                    consignorName={`deliveries[${index}].consignor.name`}
                                                    consigneeCode={`deliveries[${index}].consignee.consigneeCode`}
                                                    consigneeGst={`deliveries[${index}].consignee.gst_number`}
                                                    consigneeAddress={`deliveries[${index}].consignee.consignee_address`}
                                                    consigneeName={`deliveries[${index}].consignee.name`}
                                                    orderModal={true}
                                                    customer_type_id={values.deliveries[index].customer_type_id}
                                                    onChangeExtra={(value)=>{
                                                      let payload = {
                                                        customer_type_id : values.deliveries[index]?.customer_type_id,
                                                        billing_party_id : value
                                                      }
                                                      handleConsigneeCustomerTypeChange(payload, index, setFieldValue);
                                                    }}
                                                  />
                                                )}
                                              </Header>
                                            </Table.Cell>
                                          </>

                                          <>
                                            <Table.Cell colSpan="2" className={FEATURES.editBillingPartyAfterAllocation && `border-top border-bottom`}>
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {t("billing_party_branch") ||
                                                  "Billing Party Branch"}
                                              </Header>
                                            </Table.Cell>
                                            <Table.Cell colSpan="2" className={FEATURES.editBillingPartyAfterAllocation && `border border-left-0`}>
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {!values.deliveries[index]["active"] && !orderEditModeAftrAllotBillingParty ? (
                                                  <>
                                                    {values.deliveries[index]
                                                      .billing_party_branch_name
                                                      ? values.deliveries[index]
                                                        .billing_party_branch_name
                                                      : "NA"}
                                                  </>
                                                ) : (
                                                  <Dropdown
                                                    name={`deliveries[${index}].billing_party_branch_id`}
                                                    placeholder={
                                                      props.t(
                                                        "billing_party_branch"
                                                      ) ||
                                                      "Billing Party Branch"
                                                    }
                                                    clearable
                                                    style={{ width: "100%" }}
                                                    selection
                                                    search
                                                    onChange={(name, data) => {
                                                      setFieldValue(
                                                        `deliveries[${index}].billing_party_branch_id`,
                                                        +data.value
                                                      );
                                                      getConsigneeConsignorArray(
                                                        values.deliveries[index]
                                                          .billing_party_id,
                                                        +data.value
                                                      );
                                                      if (
                                                        FEATURES.orderDetails_setConsignorDetails
                                                      ) {
                                                        setFieldValue(
                                                          `deliveries[${index}].consignor.consignorCode`,
                                                          ""
                                                        );
                                                        setFieldValue(
                                                          `deliveries[${index}].consignor.gst_number`,
                                                          ""
                                                        );
                                                        setFieldValue(
                                                          `deliveries[${index}].deliver_to_address`,
                                                          ""
                                                        );
                                                        setFieldValue(
                                                          `deliveries[${index}].consignor.consignor_address`,
                                                          ""
                                                        );
                                                        setFieldValue(
                                                          `deliveries[${index}].consignor.name`,
                                                          ""
                                                        );
                                                      }
                                                    }}
                                                    value={
                                                      values.deliveries[index]
                                                        .billing_party_branch_id
                                                    }
                                                    options={billingpartybranch}
                                                  />
                                                )}
                                              </Header>
                                              {FEATURES.editBillingPartyAfterAllocation && props.edit &&
                                                          ((props?.currenOrder
                                                            ?.allotment_status &&
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "ALLOC") ||
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "CANCEL" ||
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "COMPLETE") ? (
                                                          <>
                                                            {orderEditModeAftrAllotBillingParty ? 
                                                            <Button icon basic size="medium" className="margin-left-20 p-2 blue"
                                                              disabled={
                                                                props.role ==
                                                                  "Quality Control"
                                                                  ? true
                                                                  : false
                                                              }
                                                              type={isSubmitting ? "button" : "submit"}
                                                            >
                                                              <Icon name={isSubmitting ? "loading spinner" : "save"} />
                                                            </Button> : 
                                                            <Button icon basic size="medium" className="margin-left-20 p-2 green"
                                                            disabled={
                                                              props.role ==
                                                                "Quality Control"
                                                                ? true
                                                                : false
                                                            }
                                                            type="button"
                                                            onClick={(e) => {
                                                              e.preventDefault();
                                                              e.stopPropagation();
                                                              setOrderEditModeAftrAllotBillingParty(
                                                                true
                                                              );
                                                            }}
                                                          >
                                                            <Icon name="edit" />
                                                          </Button>
                                                            }
                                                          </>
                                                        ) : null}
                                            </Table.Cell>
                                          </>

                                          {/* <Table.Cell>
                                            <Header
                                              className="p-bold-200 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {FEATURES.customerLabelNames() && FEATURES.customerLabelNames().vendor_lr_no ? 
                                              FEATURES.customerLabelNames().vendor_lr_no : 
                                              (t("vendor_lr_no") || "Vendor LR Number")
                                              }
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell>
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="black"
                                            >
                                              <Field
                                                disabled={
                                                  !values.deliveries[index][
                                                  "active"
                                                  ]
                                                }
                                                name={`deliveries[${index}].transporter_lr_no`}
                                                component={MyNormalInput}
                                              />
                                            </Header>
                                          </Table.Cell> */}
                                        </Table.Row>

                                        <Table.Row style={orderDetails} className="p-4">
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-200 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {FEATURES.customerLabelNames() && FEATURES.customerLabelNames().vendor_lr_no ? 
                                              FEATURES.customerLabelNames().vendor_lr_no : 
                                              (t("vendor_lr_no") || "Vendor LR Number")
                                              }
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="black"
                                            >
                                              <Field
                                                disabled={
                                                  !values.deliveries[index][
                                                  "active"
                                                  ]
                                                }
                                                name={`deliveries[${index}].transporter_lr_no`}
                                                component={MyNormalInput}
                                              />
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell style={orderDetails} colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {t("vendor_lr_date") || "Vendor LR Date"}
                                            </Header>
                                            </Table.Cell>
                                            <Table.Cell style={orderDetails} colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="black"
                                            >
                                          <div>
                                              {!values.deliveries[index][
                                                "active"
                                              ] ? (
                                                <>
                                                  {values.deliveries[index]
                                                    .transporter_lr_date
                                                    ? moment(
                                                      values.deliveries[
                                                        index
                                                      ].transporter_lr_date
                                                    ).format("DD-MM-YYYY")
                                                    : "NA"}
                                                </>
                                              ) : (
                                                <DateData
                                                  name={`deliveries.[${index}].transporter_lr_date`}
                                                  disabled={
                                                    !values.deliveries[
                                                    index
                                                    ]["active"]
                                                  }
                                                  autoComplete="off"
                                                  popperClassName="dateTime"
                                                  dateFormat="dd/MM/yyyy"
                                                  selected={
                                                    new Date(
                                                      values.deliveries[
                                                        index
                                                      ].transporter_lr_date
                                                    )
                                                  }
                                                  timeIntervals={5}
                                                  customInput={
                                                    <Input
                                                      icon="time"
                                                      iconPosition="left"
                                                    />
                                                  }
                                                />
                                              )}
                                            </div>
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell>
                                            <Header
                                              className="p-bold-200 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {
                                              (t("vendor_lr_remarks") || "Vendor LR Remarks")
                                              }
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="black"
                                            >
                                              {values?.deliveries?.[index]
                                                ?.transporter_lr_remarks
                                                || "NA"}
                                            </Header>
                                          </Table.Cell>
                                        </Table.Row>

                                        <Table.Row>
                                          {props.movement_type &&
                                            props.movement_type == "Export" ?
                                            <>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {t("yard") || "Yard"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  <Dropdown
                                                    clearable
                                                    style={{
                                                      width: "100%",
                                                      fontWeight: "normal",
                                                    }}
                                                    search
                                                    name={`deliveries[${index}].yard_id`}
                                                    disabled={
                                                      !values.deliveries[index][
                                                      "active"
                                                      ]
                                                    }
                                                    selection
                                                    placeholder={
                                                      props.t("yard") || "Yard"
                                                    }
                                                    defaultValue={
                                                      values.deliveries[index]
                                                        .yard_id
                                                    }
                                                    onChange={(name, data) =>
                                                      setFieldValue(
                                                        `deliveries[${index}].yard_id`,
                                                        data.value
                                                      )
                                                    }
                                                    options={yard}
                                                  />
                                                </Header>
                                              </Table.Cell>
                                            </> : ""
                                          }

                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-200 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {props.movement_type &&
                                                (props.movement_type ===
                                                  "Import" ||
                                                  props.movement_type ===
                                                  "Importar") ? (
                                                <>
                                                  {t("portterminal") ||
                                                    "Port Terminal"}
                                                </>
                                              ) : (
                                                props.movement_type ===
                                                  "Export" ?
                                                  <>
                                                    {t("export_pickup_location") ||
                                                      "Stuffing location"}
                                                  </> :
                                                  <>
                                                    {t("consignor") ||
                                                      "Consignor"}
                                                  </>
                                              )}
                                            </Header>
                                            <br/>
                                            <Header
                                              className="p-bold-200 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {props.movement_type &&
                                                (props.movement_type ===
                                                  "Import" ||
                                                  props.movement_type ===
                                                  "Importar") ? (
                                                <>
                                                  {t("portterminal") ||
                                                    "Port Terminal"}
                                                </>
                                              ) : (
                                                props.movement_type ===
                                                  "Export" ?
                                                  <>
                                                    {t("export_pickup_location") ||
                                                      "Stuffing location"}
                                                  </> :
                                                  <>
                                                    {t("consignor") ||
                                                      "Consignor"}
                                                  </>
                                              )} Code
                                            </Header>

                                            <br />
                                            <Header
                                              className="p-bold-200 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              Pickup Area
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            
                                              {values?.deliveries?.[index]
                                                ?.consignor &&
                                                !values.deliveries[index][
                                                "active"
                                                ] &&
                                                !(
                                                  orderEditModeAftrAllotConsignor &&
                                                  props.edit &&
                                                  ((props?.currenOrder
                                                    ?.allotment_status &&
                                                    props?.currenOrder
                                                      ?.allotment_status
                                                      ?.allotment_code ==
                                                    "ALLOC") ||
                                                    props?.currenOrder
                                                      ?.allotment_status
                                                      ?.allotment_code ==
                                                    "CANCEL" ||
                                                    props?.currenOrder
                                                      ?.allotment_status
                                                      ?.allotment_code ==
                                                    "COMPLETE")
                                                ) ? (
                                                <>
                                                <Header
                                              className="p-bold-200 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                                  {
                                                    values?.deliveries?.[index]
                                                      ?.consignor?.name
                                                  }
                                            </Header>
                                                  <br/>
                                                  <Header
                                              className="p-bold-200 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                                  {
                                                    values?.deliveries?.[index]
                                                      ?.consignor?.consignorCode
                                                  }
                                            </Header>
                                                </>
                                              ) : (
                                                
                                                <>
                                                  {values.deliveries[index][
                                                    "active"
                                                  ] ? (
                                                    <>
                                                      <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="black"
                                                  >
                                                    <div className="display-flex-center-justify-spacebtwn">
                                                      <Field
                                                        disabled={
                                                          !values.deliveries[
                                                          index
                                                          ]["active"]
                                                        }
                                                        name={`deliveries.[${index}].consignor.consignorCode`}
                                                        placeholder={
                                                          values?.deliveries?.[
                                                            index
                                                          ]?.consignor
                                                            ? values.deliveries[
                                                              index
                                                            ].consignor.name
                                                            : null
                                                        }
                                                        dontLoadInit={false}
                                                        setData={
                                                          values?.deliveries?.[
                                                            index
                                                          ]?.consignor
                                                        }
                                                        component={MyConsignor}
                                                        consignorIDName={`deliveries[${index}].consignor.consignor_id`}
                                                        setConsignorArray={
                                                          setConsignorArray
                                                        }
                                                        billingPartyId={
                                                          values.deliveries[
                                                            index
                                                          ]?.billing_party_id
                                                        }
                                                        billingPartyBranchId={
                                                          values.deliveries[
                                                            index
                                                          ]
                                                            ?.billing_party_branch_id
                                                        }
                                                        consignorArray={
                                                          consignorArray
                                                        }
                                                        mode={"edit"}
                                                        gst={`deliveries[${index}].consignor.gst_number`}
                                                        address={`deliveries[${index}].consignor.consignor_address`}
                                                        cname={`deliveries[${index}].consignor.name`}
                                                        value={
                                                          values.deliveries[
                                                            index
                                                          ]?.consignor
                                                            ?.consignorCode
                                                        }
                                                      />
                                                    </div>
                                                    </Header>
                                                     <Field
                                                       disabled={true}
                                                       component={MyNormalInput}
                                                       value={
                                                         values.deliveries[index].consignor.consignorCode
                                                       }
                                                     />
                                                     </>
                                                  ) : (
                                                    "NA"
                                                  )}
                                                </>
                                              )}
                                              <>

                                             
                                                {values.deliveries[index][
                                                  "active"
                                                ] ? (
                                                  <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="black"
                                                >
                                                  <div className="display-flex-center-justify-spacebtwn">
                                                    <Field
                                                      disabled={
                                                        !values.deliveries[
                                                        index
                                                        ]["active"]
                                                      }
                                                      name={`deliveries.[${index}].pickup_area`}
                                                      placeholder={
                                                        values?.deliveries?.[
                                                          index
                                                        ]?.pickup_area
                                                          ? values.deliveries[
                                                            index
                                                          ].pickup_area
                                                          : null
                                                      }
                                                      dontLoadInit={false}
                                                      setData={
                                                        values?.deliveries?.[
                                                          index
                                                        ]?.pickup_area
                                                      }
                                                      component={MyTextArea}
                                                      consignorIDName={`deliveries[${index}].pickup_area`}
                                                      setConsignorArray={
                                                        setConsignorArray
                                                      }
                                                      billingPartyId={
                                                        values.deliveries[
                                                          index
                                                        ]?.billing_party_id
                                                      }
                                                      billingPartyBranchId={
                                                        values.deliveries[
                                                          index
                                                        ]
                                                          ?.billing_party_branch_id
                                                      }
                                                      consignorArray={
                                                        consignorArray
                                                      }
                                                      mode={"edit"}
                                                      value={
                                                        values.deliveries[
                                                          index
                                                        ]?.pickup_area
                                                      }
                                                    />
                                                  </div>
                                                  </Header>
                                                ) : (
                                                  <>
                                                    <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="black"
                                            >
                                                    {
                                                      values.deliveries[
                                                        index
                                                      ]?.pickup_area
                                                    }
                                                    </Header>
                                                  </>
                                                )}
                                                 
                                              </>
                                           
                                          </Table.Cell>
                                          <Table.Cell colSpan={props.movement_type && props.movement_type == "Export" ? "" : "2"} >
                                            <Header
                                              className="p-bold-200 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {props.movement_type &&
                                                (props.movement_type ===
                                                  "Import" ||
                                                  props.movement_type ===
                                                  "Importar") ? (
                                                <>
                                                  {t("deliveryLocation") ||
                                                    "Delivery Loaction"}
                                                </>
                                              ) : (
                                                props.movement_type ===
                                                  "Export" ?
                                                  <>
                                                    {t("portterminal") ||
                                                      "Port Terminal"}
                                                  </> :
                                                  <>
                                                    {t("consignee") ||
                                                      "Consignee"}
                                                  </>
                                              )}
                                              </Header>
                                              <br />
                                              <Header
                                              className="p-bold-200 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {props.movement_type &&
                                                (props.movement_type ===
                                                  "Import" ||
                                                  props.movement_type ===
                                                  "Importar") ? (
                                                <>
                                                  {t("deliveryLocation") ||
                                                    "Delivery Loaction"}
                                                </>
                                              ) : (
                                                props.movement_type ===
                                                  "Export" ?
                                                  <>
                                                    {t("portterminal") ||
                                                      "Port Terminal"}
                                                  </> :
                                                  <>
                                                    {t("consignee") ||
                                                      "Consignee"}
                                                  </>
                                              )} Code
                                              </Header>
                                              <br />
                                              <Header
                                                className="p-bold-200 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                Drop Area
                                              </Header>
                                            
                                          </Table.Cell>

                                          <Table.Cell colSpan="2">
                                            
                                              {values?.deliveries?.[index]
                                                ?.consignee &&
                                                !values.deliveries[index][
                                                "active"
                                                ] &&
                                                !(
                                                  orderEditModeAftrAllotConsignee &&
                                                  props.edit &&
                                                  ((props?.currenOrder
                                                    ?.allotment_status &&
                                                    props?.currenOrder
                                                      ?.allotment_status
                                                      ?.allotment_code ==
                                                    "ALLOC") ||
                                                    props?.currenOrder
                                                      ?.allotment_status
                                                      ?.allotment_code ==
                                                    "CANCEL" ||
                                                    props?.currenOrder
                                                      ?.allotment_status
                                                      ?.allotment_code ==
                                                    "COMPLETE")
                                                ) ? (
                                                <>
                                                <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="black"
                                            >
                                                  {
                                                    values.deliveries?.[index]
                                                    ?.consignee.name
                                                  }
                                                  </Header>
                                                  <br/>
                                                  <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="black"
                                            >
                                                  {
                                                    values.deliveries?.[index]
                                                    ?.consignee.consigneeCode
                                                  }
                                                  </Header>
                                                </>
                                              ) : (
                                                <>
                                                  {values.deliveries[index][
                                                    "active"
                                                  ] ? (
                                                    <>
                                                    <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="black"
                                                  >
                                                    <div className="display-flex-center-justify-spacebtwn">
                                                      <Field
                                                        disabled={
                                                          !values.deliveries[
                                                          index
                                                          ]["active"]
                                                        }
                                                        name={`deliveries.[${index}].consignee.consigneeCode`}
                                                        placeholder={
                                                          values?.deliveries?.[
                                                            index
                                                          ]?.consignee
                                                            ? values.deliveries[
                                                              index
                                                            ].consignee.name
                                                            : null
                                                        }
                                                        component={
                                                          MyConsigneeComponent
                                                        }
                                                        consigneeIDName={`deliveries[${index}].consignee.consignee_id`}
                                                        dontLoadInit={false}
                                                        setData={
                                                          values?.deliveries?.[
                                                            index
                                                          ]?.consignee
                                                        }
                                                        consigneeArray={
                                                          consigneeArray
                                                        }
                                                        setConsigneeArray={
                                                          setConsigneeArray
                                                        }
                                                        billingPartyId={
                                                          values.deliveries[
                                                            index
                                                          ]?.billing_party_id
                                                        }
                                                        mode={"edit"}
                                                        gst={`deliveries[${index}].consignee.gst_number`}
                                                        address={`deliveries[${index}].consignee.consignee_address`}
                                                        deliverTo={`deliveries[${index}].deliver_to_address`}
                                                        value={
                                                          values.deliveries[
                                                            index
                                                          ]?.consignee
                                                            ?.consigneeCode
                                                        }
                                                        cename={`deliveries[${index}].consignee.name`}
                                                        onChangeExtra={(data)=>{
                                                          let payload = {
                                                            consignee_name : data.consigneeName,
                                                            customer_type_id : values.deliveries && values.deliveries[index]?.customer_type_id
                                                          }
                                                          handleConsigneeCustomerTypeChange(payload,index, setFieldValue)
                                                        }}
                                                      />
                                                    </div>
                                                    </Header>
                                                      <Field
                                                      disabled={true}
                                                      component={MyNormalInput}
                                                      value={
                                                        values.deliveries[index].consignee.consigneeCode
                                                      }
                                                    />
                                                    </>
                                                  ) : (
                                                    "NA"
                                                  )}


                                                </>
                                              )}
                                              <br />
                                              <>
                                                {values.deliveries[index][
                                                  "active"
                                                ] ? (
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="black"
                                                  >
                                                  <div className="display-flex-center-justify-spacebtwn">
                                                    <Field
                                                      disabled={
                                                        !values.deliveries[
                                                        index
                                                        ]["active"]
                                                      }
                                                      name={`deliveries.[${index}].drop_area`}
                                                      placeholder={
                                                        values?.deliveries?.[
                                                          index
                                                        ]?.drop_area
                                                          ? values.deliveries[
                                                            index
                                                          ].drop_area
                                                          : null
                                                      }
                                                      dontLoadInit={false}
                                                      setData={
                                                        values?.deliveries?.[
                                                          index
                                                        ]?.drop_area
                                                      }
                                                      component={MyTextArea}
                                                      consignorIDName={`deliveries[${index}].drop_area`}
                                                      setConsignorArray={
                                                        setConsignorArray
                                                      }
                                                      billingPartyId={
                                                        values.deliveries[
                                                          index
                                                        ]?.billing_party_id
                                                      }
                                                      billingPartyBranchId={
                                                        values.deliveries[
                                                          index
                                                        ]
                                                          ?.billing_party_branch_id
                                                      }
                                                      consignorArray={
                                                        consignorArray
                                                      }
                                                      mode={"edit"}
                                                      value={
                                                        values.deliveries[
                                                          index
                                                        ]?.drop_area
                                                      }
                                                    />
                                                  </div>
                                                  </Header>
                                                ) : (
                                                  <>
                                                    <br />
                                                    <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="black"
                                            >
                                                    {
                                                      values.deliveries[
                                                        index
                                                      ]?.drop_area
                                                    }
                                                    </Header>
                                                  </>
                                                )}
                                              </>
                                            
                                          </Table.Cell>
                                          {props.movement_type &&
                                            props.movement_type == "Import" ?
                                            <>
                                              <Table.Cell colSpan="">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {t("yard") || "Yard"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  <Dropdown
                                                    clearable
                                                    style={{
                                                      width: "100%",
                                                      fontWeight: "normal",
                                                    }}
                                                    search
                                                    name={`deliveries[${index}].yard_id`}
                                                    disabled={
                                                      !values.deliveries[index][
                                                      "active"
                                                      ]
                                                    }
                                                    selection
                                                    placeholder={
                                                      props.t("yard") || "Yard"
                                                    }
                                                    defaultValue={
                                                      values.deliveries[index]
                                                        .yard_id
                                                    }
                                                    onChange={(name, data) =>
                                                      setFieldValue(
                                                        `deliveries[${index}].yard_id`,
                                                        data.value
                                                      )
                                                    }
                                                    options={yard}
                                                  />
                                                </Header>
                                              </Table.Cell>
                                            </> : ""
                                          }
                                          {props.movement_type &&
                                            props.movement_type !== "Import" &&
                                            props.movement_type !== "Export" &&
                                            <>
                                              <Table.Cell colSpan="">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {t("") || "Delivery To"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="">
                                                <div className="display-flex-center">
                                                  <Header
                                                    className="p-bold-500 labelName margin-0"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {!values.deliveries[index][
                                                      "active"
                                                    ] &&
                                                      !(
                                                        orderEditModeAftrAllotDeliverTo &&
                                                        props.edit &&
                                                        ((props?.currenOrder
                                                          ?.allotment_status &&
                                                          props?.currenOrder
                                                            ?.allotment_status
                                                            ?.allotment_code ==
                                                          "ALLOC") ||
                                                          props?.currenOrder
                                                            ?.allotment_status
                                                            ?.allotment_code ==
                                                          "CANCEL" ||
                                                          props?.currenOrder
                                                            ?.allotment_status
                                                            ?.allotment_code ==
                                                          "COMPLETE")
                                                      ) ? (
                                                      <>
                                                        {values.deliveries[index]
                                                          .deliver_to
                                                          ? values.deliveries[index]
                                                            .deliver_to
                                                          : "NA"}

                                                        {props.edit &&
                                                          ((props?.currenOrder
                                                            ?.allotment_status &&
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "ALLOC") ||
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "CANCEL" ||
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "COMPLETE") ? (
                                                          <>
                                                            <Button
                                                              icon
                                                              basic
                                                              size="medium"
                                                              className="margin-left-20 green"
                                                              disabled={
                                                                props.role ==
                                                                  "Quality Control"
                                                                  ? true
                                                                  : false
                                                              }
                                                              type="button"
                                                              onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                setOrderEditModeAftrAllotDeliverTo(
                                                                  true
                                                                );
                                                              }}
                                                            >
                                                              <Icon name="edit" />
                                                            </Button>
                                                          </>
                                                        ) : null}
                                                      </>
                                                    ) : (
                                                      <>
                                                        <Dropdown
                                                          name={`deliveries[${index}].deliver_to`}
                                                          clearable
                                                          style={{
                                                            width: "100%",
                                                            fontWeight: "normal",
                                                          }}
                                                          selection
                                                          placeholder={
                                                            t("deliver_to") ||
                                                            "Deliver To"
                                                          }
                                                          onChange={(
                                                            name,
                                                            data
                                                          ) => {
                                                            setFieldValue(
                                                              `deliveries[${index}].deliver_to`,
                                                              data.value
                                                            );
                                                            if (
                                                              data.value ==
                                                              "consignee"
                                                            ) {
                                                              setFieldValue(
                                                                `deliveries[${index}].deliver_to_address`,
                                                                getCurrentOrderDetails
                                                                  .deliveries[index]
                                                                  .consignee
                                                                  .consignee_address
                                                              );
                                                            }
                                                            if (
                                                              data.value == "branch"
                                                            ) {
                                                              setFieldValue(
                                                                `deliveries[${index}].deliver_to_address`,
                                                                ""
                                                              );
                                                            } else {
                                                              setFieldValue(
                                                                `deliveries[${index}].deliver_to_address`,
                                                                getCurrentOrderDetails
                                                                  .deliveries[index]
                                                                  .deliver_to_address
                                                                  ? getCurrentOrderDetails
                                                                    .deliveries[
                                                                    index
                                                                  ]
                                                                    .deliver_to_address
                                                                  : null
                                                              );
                                                            }
                                                          }}
                                                          options={[
                                                            {
                                                              key: "1",
                                                              text: "Consignee",
                                                              value: "consignee",
                                                            },
                                                            {
                                                              key: "2",
                                                              text: "Branch",
                                                              value: "branch",
                                                            },
                                                            {
                                                              key: "3",
                                                              text: "Other",
                                                              value: "other",
                                                            },
                                                          ]}
                                                          value={
                                                            values.deliveries[index]
                                                              .deliver_to
                                                              ? values.deliveries[
                                                                index
                                                              ].deliver_to
                                                              : null
                                                          }
                                                        />
                                                      </>
                                                    )}
                                                  </Header>
                                                  <Header className="margin-0">
                                                    {!values.deliveries[index][
                                                      "active"
                                                    ] &&
                                                      !(
                                                        orderEditModeAftrAllotDeliverTo &&
                                                        props.edit &&
                                                        ((props?.currenOrder
                                                          ?.allotment_status &&
                                                          props?.currenOrder
                                                            ?.allotment_status
                                                            ?.allotment_code ==
                                                          "ALLOC") ||
                                                          props?.currenOrder
                                                            ?.allotment_status
                                                            ?.allotment_code ==
                                                          "CANCEL" ||
                                                          props?.currenOrder
                                                            ?.allotment_status
                                                            ?.allotment_code ==
                                                          "COMPLETE")
                                                      ) ? null : (
                                                      <>
                                                        {!values.deliveries[index][
                                                          "active"
                                                        ] ||
                                                          (orderEditModeAftrAllotDeliverTo &&
                                                            props.edit &&
                                                            ((props?.currenOrder
                                                              ?.allotment_status &&
                                                              props?.currenOrder
                                                                ?.allotment_status
                                                                ?.allotment_code ==
                                                              "ALLOC") ||
                                                              props?.currenOrder
                                                                ?.allotment_status
                                                                ?.allotment_code ==
                                                              "CANCEL" ||
                                                              props?.currenOrder
                                                                ?.allotment_status
                                                                ?.allotment_code ==
                                                              "COMPLETE")) ? (
                                                          <>
                                                            <div className="order-edit-mode-allot display-flex-center-justify-spacearnd">
                                                              <Button
                                                                className="ui blue"
                                                                disabled={
                                                                  props.role ==
                                                                    "Quality Control"
                                                                    ? true
                                                                    : false
                                                                }
                                                                onClick={isSubmitting ? null :
                                                                  (e) => {
                                                                    e.stopPropagation();
                                                                    setUpdateDeliveryLocation(
                                                                      true
                                                                    );
                                                                  }}
                                                                type={isSubmitting ? "button" : "submit"}
                                                                basic
                                                                size="medium"
                                                                icon
                                                              >
                                                                <Icon name={isSubmitting ? "loading spinner" : "save"} />
                                                              </Button>
                                                              <Button
                                                                className="ui blue"
                                                                onClick={(e) => {
                                                                  e.stopPropagation();
                                                                  setUpdateDeliveryLocation(true);
                                                                  setOrderEditModeAftrAllotDeliverTo(
                                                                    false
                                                                  );
                                                                }}
                                                                basic
                                                                size="medium"
                                                                icon
                                                              >
                                                                <Icon name="times" />
                                                              </Button>
                                                            </div>
                                                          </>
                                                        ) : null}
                                                      </>
                                                    )}
                                                  </Header>
                                                </div>
                                              </Table.Cell>
                                            </>
                                          }
                                        </Table.Row>
                                        <Table.Row>
                                          {props.movement_type === "Export" &&
                                            <>
                                              {values.deliveries[index]
                                                .deliver_to == "consignee" ? (
                                                <>
                                                  <Table.Cell colSpan="2">
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      {t("deliver_to_address") ||
                                                        "Delivery Address"}
                                                    </Header>
                                                  </Table.Cell>
                                                  <Table.Cell>
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      {!values.deliveries[index][
                                                        "active"
                                                      ] ? (
                                                        <React.Fragment>
                                                          {getCurrentOrderDetails
                                                            ?.deliveries?.[index]
                                                            ?.consignee
                                                            ? getCurrentOrderDetails
                                                              .deliveries[index]
                                                              .consignee
                                                              .consignee_address
                                                            : null}
                                                        </React.Fragment>
                                                      ) : (
                                                        <Field
                                                          component="textarea"
                                                          readOnly
                                                          style={{
                                                            paddingTop: "5.5px",
                                                            whiteSpace: "nowrap",
                                                          }}
                                                          type="number"
                                                          rows="2"
                                                          name={`deliveries[${index}].deliver_to_address`}
                                                          value={
                                                            values?.deliveries?.[
                                                              index
                                                            ]?.consignee
                                                              ? values.deliveries[
                                                                index
                                                              ].consignee
                                                                .consignee_address
                                                              : "NA"
                                                          }
                                                        />
                                                      )}
                                                    </Header>
                                                  </Table.Cell>
                                                </>
                                              ) : (
                                                <>
                                                  {values.deliveries[index]
                                                    .deliver_to == "other" ? (
                                                    <>
                                                      <Table.Cell colSpan="2">
                                                        <Header
                                                          className="p-bold-500 labelName"
                                                          size="tiny"
                                                          as="label"
                                                          color="grey"
                                                        >
                                                          {t(
                                                            "deliver_to_address"
                                                          ) ||
                                                            "Delivery To Address"}
                                                        </Header>
                                                      </Table.Cell>
                                                      <Table.Cell>
                                                        <Header
                                                          className="p-bold-500 labelName"
                                                          size="tiny"
                                                          as="label"
                                                          color="grey"
                                                        >
                                                          {!values.deliveries[
                                                            index
                                                          ]["active"] ? (
                                                            <>
                                                              {values.deliveries[
                                                                index
                                                              ].deliver_to_address
                                                                ? values
                                                                  .deliveries[
                                                                  index
                                                                ]
                                                                  .deliver_to_address
                                                                : "NA"}
                                                            </>
                                                          ) : (
                                                            <Field
                                                              component="textarea"
                                                              style={{
                                                                paddingTop:
                                                                  "5.5px",
                                                                whiteSpace:
                                                                  "nowrap",
                                                              }}
                                                              type="number"
                                                              rows="2"
                                                              name={`deliveries[${index}].deliver_to_address`}
                                                              values={
                                                                values.deliveries[
                                                                  index
                                                                ]
                                                                  .deliver_to_address
                                                              }
                                                            />
                                                          )}
                                                        </Header>
                                                      </Table.Cell>
                                                    </>
                                                  ) : null}
                                                </>
                                              )}
                                              {values.deliveries[index]
                                                .deliver_to == "branch" ? (
                                                <>
                                                  <Table.Cell colSpan="2">
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      {t("deliver_to_address") ||
                                                        "Delivery To Address"}
                                                    </Header>
                                                  </Table.Cell>
                                                  <Table.Cell>
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      {!values.deliveries[index][
                                                        "active"
                                                      ] ? (
                                                        <>
                                                          {values.deliveries[
                                                            index
                                                          ].deliver_to_address
                                                            ? values.deliveries[
                                                              index
                                                            ].deliver_to_address
                                                            : "NA"}
                                                        </>
                                                      ) : (
                                                        <Dropdown
                                                          name={`deliveries[${index}].deliver_to_address`}
                                                          clearable
                                                          style={{
                                                            width: "100%",
                                                            fontWeight: "normal",
                                                          }}
                                                          selection
                                                          placeholder={
                                                            t(
                                                              "deliver_to_address"
                                                            ) ||
                                                            "Deliver To Address"
                                                          }
                                                          onChange={(
                                                            name,
                                                            data
                                                          ) => {
                                                            setFieldValue(
                                                              `deliveries[${index}].deliver_to_address`,
                                                              data.value
                                                            );
                                                          }}
                                                          options={branchs}
                                                          value={
                                                            values.deliveries[
                                                              index
                                                            ].deliver_to_address
                                                          }
                                                        />
                                                      )}
                                                    </Header>
                                                  </Table.Cell>
                                                </>
                                              ) : null}
                                            </>}
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-200 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {props.movement_type &&
                                                (props.movement_type ===
                                                  "Import" ||
                                                  props.movement_type ===
                                                  "Importar") ? (
                                                <>
                                                  {t("portterminal_address") ||
                                                    "Port Terminal Address"}
                                                </>
                                              ) : (
                                                props.movement_type ===
                                                  "Export" ?
                                                  <>
                                                    {t("export_pickup_location_address") ||
                                                      "Stuffing location"}
                                                  </> :
                                                  <>
                                                    {t("consignor_address") ||
                                                      "Consignor Address"}
                                                  </>
                                              )}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="black"
                                            >
                                              {values?.deliveries?.[index]
                                                ?.consignor
                                                ? values.deliveries[index]
                                                  .consignor.consignor_address
                                                : null}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-200 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {props.movement_type &&
                                                (props.movement_type ===
                                                  "Import" ||
                                                  props.movement_type ===
                                                  "Importar") ? (
                                                <>
                                                  {t(
                                                    "deliveryLocation_address"
                                                  ) ||
                                                    "Delivery Loaction Address"}
                                                </>
                                              ) : (
                                                props.movement_type ===
                                                  "Export" ?
                                                  <>
                                                    {t("portterminal_address") ||
                                                      "Port Terminal Address"}
                                                  </> :
                                                  <>
                                                    {t("consignee_address") ||
                                                      "Consignee Address"}
                                                  </>
                                              )}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="black"
                                            >
                                              {values?.deliveries?.[index]
                                                ?.consignee
                                                ? values.deliveries[index]
                                                  .consignee.consignee_address
                                                : null}
                                            </Header>
                                          </Table.Cell>
                                          {props.movement_type !== "Export" &&
                                            <>
                                              {values.deliveries[index]
                                                .deliver_to == "consignee" ? (
                                                <>
                                                  <Table.Cell colSpan="">
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      {t("deliver_to_address") ||
                                                        "Delivery Address"}
                                                    </Header>
                                                  </Table.Cell>
                                                  <Table.Cell>
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      {!values.deliveries[index][
                                                        "active"
                                                      ] ? (
                                                        <React.Fragment>
                                                          {getCurrentOrderDetails
                                                            ?.deliveries?.[index]
                                                            ?.consignee
                                                            ? getCurrentOrderDetails
                                                              .deliveries[index]
                                                              .consignee
                                                              .consignee_address
                                                            : null}
                                                        </React.Fragment>
                                                      ) : (
                                                        <Field
                                                          component="textarea"
                                                          readOnly
                                                          style={{
                                                            paddingTop: "5.5px",
                                                            whiteSpace: "nowrap",
                                                          }}
                                                          type="number"
                                                          rows="2"
                                                          name={`deliveries[${index}].deliver_to_address`}
                                                          value={
                                                            values?.deliveries?.[
                                                              index
                                                            ]?.consignee
                                                              ? values.deliveries[
                                                                index
                                                              ].consignee
                                                                .consignee_address
                                                              : "NA"
                                                          }
                                                        />
                                                      )}
                                                    </Header>
                                                  </Table.Cell>
                                                </>
                                              ) : (
                                                <>
                                                  {values.deliveries[index]
                                                    .deliver_to == "other" ? (
                                                    <>
                                                      <Table.Cell colSpan="">
                                                        <Header
                                                          className="p-bold-500 labelName"
                                                          size="tiny"
                                                          as="label"
                                                          color="grey"
                                                        >
                                                          {t(
                                                            "deliver_to_address"
                                                          ) ||
                                                            "Delivery To Address"}
                                                        </Header>
                                                      </Table.Cell>
                                                      <Table.Cell>
                                                        <Header
                                                          className="p-bold-500 labelName"
                                                          size="tiny"
                                                          as="label"
                                                          color="grey"
                                                        >
                                                          {!values.deliveries[
                                                            index
                                                          ]["active"] ? (
                                                            <>
                                                              {values.deliveries[
                                                                index
                                                              ].deliver_to_address
                                                                ? values
                                                                  .deliveries[
                                                                  index
                                                                ]
                                                                  .deliver_to_address
                                                                : "NA"}
                                                            </>
                                                          ) : (
                                                            <Field
                                                              component="textarea"
                                                              style={{
                                                                paddingTop:
                                                                  "5.5px",
                                                                whiteSpace:
                                                                  "nowrap",
                                                              }}
                                                              type="number"
                                                              rows="2"
                                                              name={`deliveries[${index}].deliver_to_address`}
                                                              values={
                                                                values.deliveries[
                                                                  index
                                                                ]
                                                                  .deliver_to_address
                                                              }
                                                            />
                                                          )}
                                                        </Header>
                                                      </Table.Cell>
                                                    </>
                                                  ) : null}
                                                </>
                                              )}
                                              {values.deliveries[index]
                                                .deliver_to == "branch" ? (
                                                <>
                                                  <Table.Cell colSpan="">
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      {t("deliver_to_address") ||
                                                        "Delivery To Address"}
                                                    </Header>
                                                  </Table.Cell>
                                                  <Table.Cell>
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      {!values.deliveries[index][
                                                        "active"
                                                      ] ? (
                                                        <>
                                                          {values.deliveries[
                                                            index
                                                          ].deliver_to_address
                                                            ? values.deliveries[
                                                              index
                                                            ].deliver_to_address
                                                            : "NA"}
                                                        </>
                                                      ) : (
                                                        <Dropdown
                                                          name={`deliveries[${index}].deliver_to_address`}
                                                          clearable
                                                          style={{
                                                            width: "100%",
                                                            fontWeight: "normal",
                                                          }}
                                                          selection
                                                          placeholder={
                                                            t(
                                                              "deliver_to_address"
                                                            ) ||
                                                            "Deliver To Address"
                                                          }
                                                          onChange={(
                                                            name,
                                                            data
                                                          ) => {
                                                            setFieldValue(
                                                              `deliveries[${index}].deliver_to_address`,
                                                              data.value
                                                            );
                                                          }}
                                                          options={branchs}
                                                          value={
                                                            values.deliveries[
                                                              index
                                                            ].deliver_to_address
                                                          }
                                                        />
                                                      )}
                                                    </Header>
                                                  </Table.Cell>
                                                </>
                                              ) : null}
                                            </>}
                                        </Table.Row>

                                        <Table.Row>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-200 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {props.movement_type &&
                                                (props.movement_type ===
                                                  "Import" ||
                                                  props.movement_type ===
                                                  "Importar" ||
                                                  props.movement_type ===
                                                  "Export") ? (
                                                <>
                                                  {t("consignor_gst") ||
                                                    "Consignor Gst"}
                                                </>
                                              ) : (
                                                <>
                                                  {t("consignor_gst") ||
                                                    "Consignor Gst"}
                                                </>
                                              )}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="black"
                                            >
                                              {getCurrentOrderDetails
                                                ?.deliveries?.[index]?.consignor
                                                ? getCurrentOrderDetails
                                                  .deliveries[index].consignor
                                                  .gst_number
                                                : null}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-200 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {props.movement_type &&
                                                (props.movement_type ===
                                                  "Import" ||
                                                  props.movement_type ===
                                                  "Importar" ||
                                                  props.movement_type ===
                                                  "Export") ? (
                                                <>
                                                  {t("consignee_gst") ||
                                                    "Consignee Gst"}
                                                </>
                                              ) : (
                                                <>
                                                  {t("consignee_gst") ||
                                                    "Consignee Gst"}
                                                </>
                                              )}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="4">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="black"
                                            >
                                              {getCurrentOrderDetails
                                                ?.deliveries?.[index]?.consignee
                                                ? getCurrentOrderDetails
                                                  .deliveries[index].consignee
                                                  .gst_number
                                                : null}
                                            </Header>
                                          </Table.Cell>
                                        </Table.Row>
                                        <>
                                          <Table.Row>
                                            {props.movement_type &&
                                              (props.movement_type ===
                                                "Import" ||
                                                props.movement_type ===
                                                "Importar" ||
                                                props.movement_type ===
                                                "Export") && (
                                                <>
                                                  <Table.Cell colSpan="2">
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      {t("boarding_no") ||
                                                        "Boarding No"}
                                                    </Header>
                                                  </Table.Cell>
                                                  <Table.Cell colSpan="2">
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      {!values.deliveries[
                                                        index
                                                      ]["active"] ? (
                                                        <>
                                                          {values.deliveries[
                                                            index
                                                          ].boarding_no
                                                            ? values.deliveries[
                                                              index
                                                            ].boarding_no
                                                            : "NA"}
                                                        </>
                                                      ) : (
                                                        <Field
                                                          component={MyInput}
                                                          style={{
                                                            paddingTop: "5.5px",
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                          // label={t("charged_weight") || "Charge Weight"}
                                                          type="text"
                                                          value={
                                                            values.deliveries[
                                                              index
                                                            ].boarding_no
                                                          }
                                                          name={`deliveries[${index}].boarding_no`}
                                                        />
                                                      )}
                                                    </Header>
                                                  </Table.Cell>

                                                  <Table.Cell colSpan="2">
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      {t(
                                                        "import_decleration_number"
                                                      ) ||
                                                        "Import Declaration No"}
                                                    </Header>
                                                  </Table.Cell>
                                                  <Table.Cell colSpan="2">
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      {!values.deliveries[
                                                        index
                                                      ]["active"] ? (
                                                        <>
                                                          {values.deliveries[
                                                            index
                                                          ]
                                                            .import_declaration_no
                                                            ? values.deliveries[
                                                              index
                                                            ]
                                                              .import_declaration_no
                                                            : "NA"}
                                                        </>
                                                      ) : (
                                                        <Field
                                                          component={MyInput}
                                                          style={{
                                                            paddingTop: "5.5px",
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                          // label={t("charged_weight") || "Charge Weight"}
                                                          type="text"
                                                          value={
                                                            values.deliveries[
                                                              index
                                                            ]
                                                              .import_declaration_no
                                                          }
                                                          name={`deliveries[${index}].import_declaration_no`}
                                                        />
                                                      )}
                                                    </Header>
                                                  </Table.Cell>
                                                </>
                                              )}
                                          </Table.Row>
                                        </>

                                        <>
                                          <Table.Row>
                                            <>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {t(
                                                    "total_ordered_quantity"
                                                  ) || "Total Ordered Quantity (No.of boxes)"}
                                                  <br />
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {!values.deliveries[index][
                                                    "active"
                                                  ] ? (
                                                    <>
                                                      {getCurrentOrderDetails
                                                        .deliveries[index]
                                                        .total_quantity
                                                        ? getCurrentOrderDetails
                                                          .deliveries[index]
                                                          .total_quantity
                                                        : "NA"}
                                                    </>
                                                  ) : (
                                                    <Input
                                                      //component={MyNumInput}
                                                      style={{
                                                        whiteSpace: "nowrap",
                                                      }}
                                                      type="number"
                                                      value={
                                                        values.deliveries[index]
                                                          .total_quantity
                                                      }
                                                      name={`deliveries[${index}].total_quantity`}
                                                      onBlur={() => {
                                                        if (values?.deliveries?.[index]?.total_quantity != getCounts(values.deliveries[index].products) && getCounts(values.deliveries[index].products) != 0) {
                                                          setQuantityModal(true)
                                                          setQuantityIndex(index)
                                                        }
                                                      }}
                                                      onChange={(
                                                        name,
                                                        data
                                                      ) => {
                                                        setFieldValue(
                                                          `deliveries[${index}].total_quantity`,
                                                          parseInt(data.value)
                                                        );
                                                        let multiplyFactor = 0,
                                                          actualValue = 0;
                                                        let actualFreightValue =
                                                          values?.deliveries?.[
                                                            index
                                                          ]
                                                            ?.actual_freight_rate;
                                                        if (
                                                          values?.deliveries?.[
                                                            index
                                                          ]?.uom && values?.deliveries?.[
                                                            index
                                                          ]?.uom_name
                                                        ) {
                                                          if (
                                                            values.deliveries[
                                                              index
                                                            ].uom_name.toUpperCase() === "PER CASE"
                                                          ) {
                                                            let multiplyFactor;
                                                            if (data.value) {
                                                              multiplyFactor =
                                                                data.value;
                                                              actualValue =
                                                                multiplyFactor *
                                                                actualFreightValue;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                            } else {
                                                              actualValue =
                                                                data.value;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                            }
                                                          }
                                                        }
                                                      }}
                                                    />
                                                  )}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-200 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {t("service_type") ||
                                                    "Service Type"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="black"
                                                >
                                                <div className="display-flex-center">

                                                
                                                  <Field
                                                    disabled={
                                                      !values.deliveries[index][
                                                      "active"
                                                      ] && !orderEditModeAftrAllotServiceType
                                                    }
                                                    component={MyServiceType}
                                                    name={`deliveries[${index}].service_type_id`}
                                                    value={
                                                      values?.deliveries?.[
                                                        index
                                                      ]?.service_type_id
                                                    }
                                                    onChangeExtra={(value)=>handleServiceTypeChange(getCurrentOrderDetails?.deliveries?.[index]?.service_type_id, value)}
                                                  />

                                                    {!props?.currenOrder?.undo_vendor_possible &&
                                                      !(props?.currenOrder?.allotment_status &&
                                                        props?.currenOrder?.allotment_status?.allotment_code == "CANCEL" ||
                                                        props?.currenOrder?.allotment_status?.allotment_code == "COMPLETE") &&
                                                      <>
                                                        {orderEditModeAftrAllotServiceType ?
                                                          <Button icon basic size="medium" className="margin-left-20 p-2 blue"
                                                            disabled={
                                                              props.role ==
                                                                "Quality Control"
                                                                ? true
                                                                : false
                                                            }
                                                            type={isSubmitting ? "button" : "submit"}
                                                          >
                                                            <Icon name={isSubmitting ? "loading spinner" : "save"} />
                                                          </Button> :
                                                          <Button icon basic size="medium" className="margin-left-20 p-2 green"
                                                            disabled={
                                                              props.role ==
                                                                "Quality Control"
                                                                ? true
                                                                : false
                                                            }
                                                            type="button"
                                                            onClick={(e) => {
                                                              e.preventDefault();
                                                              e.stopPropagation();
                                                              setOrderEditModeAftrAllotServiceType(
                                                                true
                                                              );
                                                            }}
                                                          >
                                                            <Icon name="edit" />
                                                          </Button>
                                                        }
                                                      </>
                                                    }
                                                       
                                                  </div>
                                                </Header>
                                                
                                              </Table.Cell>

                                              <Table.Cell>
                                                <Header
                                                  className="p-bold-200 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {FEATURES.brokerInsteadOfSalesPerson ? 
                                                  (t("broker") || "Broker") :
                                                  (t("sales_person") || "Sales Person")}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell>
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="black"
                                                >
                                              <Field
                                              disabled={
                                                !values.deliveries[index][
                                                "active"
                                                ]
                                              }
                                              placeholder= {FEATURES.brokerInsteadOfSalesPerson ? "Select Broker" : "Select Sales Person"}
                                              component={MyUser}
                                              name={`deliveries[${index}].sales_person_id`}
                                              roleValidation={true}
                                              roleName={FEATURES.brokerInsteadOfSalesPerson ? "broker" : "sales"}
                                              userNumber={`deliveries[${index}].sales_person_number`}
                                              userEmail={`deliveries[${index}].sales_person_email`}
                                              value={values.deliveries[index].sales_person_id}
                                            />
                                            {values.deliveries[index].sales_person_id && 
                                              <div className="mt-1">
                                              <div>
                                                <span className="address-label">{"Contact Number"}</span>
                                                <span className="address-inputfields"> : {values.deliveries[index].sales_person_number || salesPersonDetails[index]?.sales_person_number}
                                                </span>
                                              </div>
                                              <div>
                                                <span className="address-label">{"Email Id"}</span>
                                                <span className="address-inputfields"> : {values.deliveries[index].sales_person_email || salesPersonDetails[index]?.sales_person_email}
                                                </span>
                                              </div>
                                            </div>
                                              }
                                                </Header>
                                              </Table.Cell>
                                            </>
                                          </Table.Row>
                                        </>

                                        <Table.Row style={orderDetails}>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {(FEATURES.weightInTonCustomers? t("actual_weight_ton") : t("actual_weight")) ||
                                                "Actual Weight"}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                              >
                                              {!values.deliveries[index][
                                                "active"
                                              ] ? (
                                                <>
                                                  {getCurrentOrderDetails
                                                    .deliveries[index]
                                                    .actual_weight
                                                    ? getCurrentOrderDetails
                                                      .deliveries[index]
                                                      .actual_weight
                                                    : "NA"}
                                                </>
                                              ) : (
                                                <>
                                                <Input
                                                  style={{
                                                    paddingTop: "5.5px",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                  type={FEATURES.weightInTonCustomers? "text":"number"}
                                                  value={
                                                    values.deliveries[index]
                                                      .actual_weight
                                                  }
                                                  name={`deliveries[${index}].actual_weight`}
                                                  onBlur={() => {
                                                    setFieldValue(
                                                      `deliveries[${index}].grossWeightFlag`,
                                                      false
                                                    ),
                                                      setFieldValue(
                                                        `deliveries[${index}].chargedWeightFlag`,
                                                        false
                                                      );
                                                  }}
                                                  onChange={(
                                                    name,
                                                    data
                                                  ) => {
                                                    if (data.value != "") {
                                                      setFieldValue(
                                                        `deliveries[${index}].actual_weight`,
                                                        FEATURES.weightInTonCustomers ? data.value : parseInt(data.value)
                                                      );
                                                      if (
                                                        data.value &&
                                                        values.deliveries[
                                                          index
                                                        ].grossWeightFlag &&
                                                        values.deliveries[
                                                          index
                                                        ].chargedWeightFlag
                                                      ) {
                                                        setFieldValue(
                                                          `deliveries[${index}].gross_weight`,
                                                          FEATURES.weightInTonCustomers ? data.value : parseInt(data.value)
                                                        );

                                                        setFieldValue(
                                                          `deliveries[${index}].charged_weight`,
                                                          FEATURES.weightInTonCustomers ? data.value : parseInt(data.value)
                                                        );
                                                      }
                                                    } else {
                                                      setFieldValue(
                                                        `deliveries[${index}].actual_weight`,
                                                        null
                                                      );
                                                      if (data.value) {
                                                        setFieldValue(
                                                          `deliveries[${index}].gross_weight`,
                                                          null
                                                        );
                                                        setFieldValue(
                                                          `deliveries[${index}].charged_weight`,
                                                          null
                                                        );
                                                      }
                                                    }
                                                  }}
                                                /><br/>
                                                { errors?.deliveries?.[index]?.actual_weight &&
                                                  <small className="text-danger">{errors?.deliveries?.[index]?.actual_weight}</small>
                                                }
                                                </>
                                              )}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {(FEATURES.weightInTonCustomers? t("delivery_gross_weight_ton") : t("delivery_gross_weight")) ||
                                                "Gross Weight"}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {!values.deliveries[index][
                                                "active"
                                              ] ? (
                                                <>
                                                  {values.deliveries[index]
                                                    .gross_weight
                                                    ? values.deliveries[
                                                      index
                                                    ].gross_weight
                                                    : "NA"}
                                                </>
                                              ) : (
                                                <>
                                                <Input
                                                  style={{
                                                    paddingTop: "5.5px",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                  type={FEATURES.weightInTonCustomers? "text":"number"}
                                                  value={
                                                    values.deliveries[index]
                                                      .gross_weight
                                                  }
                                                  name={`deliveries[${index}].gross_weight`}
                                                  onBlur={() =>
                                                    setFieldValue(
                                                      `deliveries[${index}].chargedWeightFlag`,
                                                      false
                                                    )
                                                  }
                                                  onChange={(
                                                    name,
                                                    data
                                                  ) => {
                                                    if (data.value != "") {
                                                      setFieldValue(
                                                        `deliveries[${index}].gross_weight`,
                                                        FEATURES.weightInTonCustomers ? data.value : parseInt(data.value)
                                                      );
                                                      if (
                                                        data.value &&
                                                        values.deliveries[
                                                          index
                                                        ].chargedWeightFlag
                                                      ) {
                                                        setFieldValue(
                                                          `deliveries[${index}].charged_weight`,
                                                          FEATURES.weightInTonCustomers ? data.value : parseInt(data.value)
                                                        );
                                                      }
                                                    } else {
                                                      setFieldValue(
                                                        `deliveries[${index}].gross_weight`,
                                                        null
                                                      );
                                                      if (
                                                        data.value &&
                                                        values.deliveries[
                                                          index
                                                        ].chargedWeightFlag
                                                      ) {
                                                        setFieldValue(
                                                          `deliveries[${index}].charged_weight`,
                                                          null
                                                        );
                                                      }
                                                    }
                                                  }}
                                                /><br/>
                                                { errors?.deliveries?.[index]?.gross_weight &&
                                                  <small className="text-danger">{errors?.deliveries?.[index]?.gross_weight}</small>
                                                }
                                                </>
                                              )}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell>
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {(FEATURES.weightInTonCustomers ? t("charge_weight_ton") : t("charge_weight")) ||
                                                "Charged Weight"}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell>
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {!values.deliveries[index][
                                                "active"
                                              ] ? (
                                                <>
                                                  {values.deliveries[index]
                                                    .charged_weight
                                                    ? values.deliveries[
                                                      index
                                                    ].charged_weight
                                                    : "NA"}
                                                </>
                                              ) : (
                                                <>
                                                <Input
                                                  //component={MyNumInput}
                                                  style={{
                                                    whiteSpace: "nowrap",
                                                  }}
                                                  type={FEATURES.weightInTonCustomers ? "text" : "number"}
                                                  name={`deliveries[${index}].charged_weight`}
                                                  disabled={
                                                    values?.deliveries?.[
                                                      index
                                                    ]?.uom_name && 
                                                    values?.deliveries?.[
                                                      index
                                                    ]?.uom_name.toUpperCase() === "PER CFT KG"
                                                      ? true
                                                      : false
                                                  }
                                                  value={
                                                    values.deliveries[index]
                                                      .charged_weight
                                                  }
                                                  onChange={(
                                                    name,
                                                    data
                                                  ) => {
                                                    if(FEATURES.weightInTonCustomers){
                                                      setFieldValue(
                                                        `deliveries[${index}].charged_weight`,
                                                        data.value
                                                      );
                                                    }
                                                    else{
                                                      if (data.value != "") {
                                                      setFieldValue(
                                                        `deliveries[${index}].charged_weight`,
                                                        parseInt(data.value)
                                                      );
                                                    } else {
                                                      setFieldValue(
                                                        `deliveries[${index}].charged_weight`,
                                                        null
                                                      );
                                                    }}
                                                    let multiplyFactor = 0,
                                                      actualValue = 0;
                                                    let actualFreightValue =
                                                      values?.deliveries?.[
                                                        index
                                                      ]
                                                        ?.actual_freight_rate;
                                                    if (
                                                      values?.deliveries?.[
                                                        index
                                                      ]?.uom && values?.deliveries?.[
                                                        index
                                                      ]?.uom_name
                                                    ) {
                                                      if (
                                                        values
                                                          ?.deliveries?.[
                                                          index
                                                        ]?.uom_name.toUpperCase() === "KG"
                                                      ) {
                                                        let multiplyFactor;
                                                        multiplyFactor = data.value && (FEATURES.weightInTonCustomers ? Number(data.value) * 1000 : Number(data.value));
                                                        actualValue =
                                                          multiplyFactor *
                                                          actualFreightValue;
                                                        setFieldValue(
                                                          `deliveries[${index}].final_freight_rate`,
                                                          actualValue
                                                        );
                                                      } else if (
                                                        values
                                                          ?.deliveries?.[
                                                          index
                                                        ]?.uom_name.toUpperCase() === "TON"
                                                      ) {
                                                        let multiplyFactor;
                                                        multiplyFactor = data.value && (FEATURES.weightInTonCustomers ? Number(data.value) : Number(data.value)/1000);
                                                        actualValue =
                                                          multiplyFactor *
                                                          actualFreightValue;
                                                        setFieldValue(
                                                          `deliveries[${index}].final_freight_rate`,
                                                          actualValue
                                                        );
                                                      } else if (
                                                        values
                                                          ?.deliveries?.[
                                                          index
                                                        ]?.uom_name.toUpperCase() === "PER TON PER KM"
                                                      ) {
                                                        let weight_in_ton = data.value && (FEATURES.weightInTonCustomers ? Number(data.value) : Number(data.value)/1000);
                                                        let distance = props?.budgeted_kms && Number(props?.budgeted_kms.replace(' Kms', ''));
                                                        actualValue = weight_in_ton * actualFreightValue * distance;
                                                        setFieldValue(
                                                          `deliveries[${index}].final_freight_rate`,
                                                          actualValue
                                                        );
                                                      }
                                                    }
                                                  }}
                                                /><br/>
                                                { errors?.deliveries?.[index]?.charged_weight &&
                                                  <small className="text-danger">{errors?.deliveries?.[index]?.charged_weight}</small>
                                                }
                                                </>
                                              )}
                                            </Header>
                                          </Table.Cell>
                                        </Table.Row>

                                        <Table.Row>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {FEATURES.orderDetails_showDropLocation &&
                                                (props.movement_type ===
                                                  "Import" ||
                                                  props.movement_type ===
                                                  "Export") ? (
                                                <>
                                                  {" "}
                                                  {t(
                                                    "scheduled_requested_stuffing"
                                                  ) ||
                                                    "Scheduled requested stuffing Date & Time"}
                                                </>
                                              ) : (
                                                <>
                                                  {t("pickup_date") ||
                                                    "Drop Location"}
                                                </>
                                              )}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {!values.deliveries[index][
                                                "active"
                                              ] ? (
                                                <>
                                                  {values?.deliveries?.[index]
                                                    ?.container_pickup_date
                                                    ? moment(
                                                      values.deliveries[index]
                                                        .container_pickup_date
                                                    ).format(
                                                      "DD-MM-YYYY HH:mm"
                                                    )
                                                    : "NA"}
                                                </>
                                              ) : (
                                                <DateData
                                                  name={`deliveries.[${index}].container_pickup_date`}
                                                  disabled={
                                                    !values.deliveries[index][
                                                    "active"
                                                    ]
                                                  }
                                                  autoComplete="off"
                                                  showTimeSelect
                                                  timeFormat="HH:mm"
                                                  popperClassName="dateTime"
                                                  dateFormat="dd/MM/yyyy HH:mm"
                                                  selected={
                                                    new Date(
                                                      values.deliveries[
                                                        index
                                                      ].container_pickup_date
                                                    )
                                                  }
                                                  timeIntervals={10}
                                                  customInput={
                                                    <Input
                                                      icon="time"
                                                      // className="dateWidth"
                                                      iconPosition="left"
                                                    />
                                                  }
                                                />
                                                // null
                                              )}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {FEATURES.orderDetails_showDropLocation &&
                                                (props.movement_type ===
                                                  "Import" ||
                                                  props.movement_type ===
                                                  "Export") ? (
                                                <>
                                                  {t(
                                                    "actual_requested_stuffing"
                                                  ) ||
                                                    "Actual requested stuffing Date & Time"}{" "}
                                                </>
                                              ) : (
                                                <>
                                                  {t("actual_pickup_date") ||
                                                    "Drop Location"}
                                                </>
                                              )}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {!values.deliveries[index][
                                                "active"
                                              ] ? (
                                                <>
                                                  {values.deliveries[index]
                                                    .actual_pickup_date
                                                    ? moment(
                                                      values.deliveries[index]
                                                        .actual_pickup_date
                                                    ).format(
                                                      "DD-MM-YYYY HH:mm"
                                                    )
                                                    : "NA"}
                                                </>
                                              ) : (
                                                <DateData
                                                  // style={{ width: "100% !important" }}
                                                  name={`deliveries.[${index}].actual_pickup_date`}
                                                  disabled={
                                                    !values.deliveries[index][
                                                    "active"
                                                    ]
                                                  }
                                                  autoComplete="off"
                                                  showTimeSelect
                                                  timeFormat="HH:mm"
                                                  popperClassName="dateTime"
                                                  dateFormat="dd/MM/yyyy HH:mm"
                                                  selected={
                                                    new Date(
                                                      values.deliveries[
                                                        index
                                                      ].actual_pickup_date
                                                    )
                                                  }
                                                  timeIntervals={10}
                                                  customInput={
                                                    <Input
                                                      icon="time"
                                                      // className="dateWidth"
                                                      iconPosition="left"
                                                    />
                                                  }
                                                />
                                                // null
                                              )}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell>
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {t("difference") || "Difference"}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell>
                                            {values.deliveries[index]
                                              .actual_pickup_date &&
                                              values.deliveries[index]
                                                .container_pickup_date ? (
                                              <>
                                                {getDiff(
                                                  values.deliveries[index]
                                                    .actual_pickup_date,
                                                  values.deliveries[index]
                                                    .container_pickup_date
                                                )}
                                              </>
                                            ) : (
                                              "NA"
                                            )}
                                          </Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {t("delivery_date") ||
                                                "Drop Location"}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {!values.deliveries[index][
                                                "active"
                                              ] ? (
                                                <>
                                                  {values?.deliveries?.[index]
                                                    ?.delivery_date
                                                    ? moment(
                                                      values.deliveries[index]
                                                        .delivery_date
                                                    ).format(
                                                      "DD-MM-YYYY HH:mm"
                                                    )
                                                    : "NA"}
                                                </>
                                              ) : (
                                                <DateData
                                                  name={`deliveries.[${index}].delivery_date`}
                                                  disabled={
                                                    !values.deliveries[index][
                                                    "active"
                                                    ]
                                                  }
                                                  autoComplete="off"
                                                  showTimeSelect
                                                  timeFormat="HH:mm"
                                                  popperClassName="dateTime"
                                                  dateFormat="dd/MM/yyyy HH:mm"
                                                  selected={
                                                    new Date(
                                                      values.deliveries[
                                                        index
                                                      ].delivery_date
                                                    )
                                                  }
                                                  timeIntervals={10}
                                                  customInput={
                                                    <Input
                                                      icon="time"
                                                      iconPosition="left"
                                                    />
                                                  }
                                                />
                                                // null
                                              )}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {t("actual_delivery_date") ||
                                                "Drop Location"}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {!values.deliveries[index][
                                                "active"
                                              ] ? (
                                                <>
                                                  {values.deliveries[index]
                                                    .actual_delivery_date
                                                    ? moment(
                                                      values.deliveries[index]
                                                        .actual_delivery_date
                                                    ).format(
                                                      "DD-MM-YYYY HH:mm"
                                                    )
                                                    : "NA"}
                                                </>
                                              ) : (
                                                <DateData
                                                  name={`deliveries.[${index}].actual_delivery_date`}
                                                  disabled={
                                                    !values.deliveries[index][
                                                    "active"
                                                    ]
                                                  }
                                                  autoComplete="off"
                                                  showTimeSelect
                                                  timeFormat="HH:mm"
                                                  popperClassName="dateTime"
                                                  dateFormat="dd/MM/yyyy HH:mm"
                                                  selected={
                                                    new Date(
                                                      values.deliveries[
                                                        index
                                                      ].actual_delivery_date
                                                    )
                                                  }
                                                  timeIntervals={10}
                                                  customInput={
                                                    <Input
                                                      icon="time"
                                                      // className="dateWidth"
                                                      iconPosition="left"
                                                    />
                                                  }
                                                />
                                                // null
                                              )}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell>
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {t("difference") || "Difference"}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell>
                                            {values.deliveries[index]
                                              .actual_delivery_date &&
                                              values.deliveries[index]
                                                .delivery_date ? (
                                              <>
                                                {getDiffDelivery(
                                                  values.deliveries[index]
                                                    .actual_delivery_date,
                                                  values.deliveries[index]
                                                    .delivery_date
                                                )}
                                              </>
                                            ) : (
                                              "NA"
                                            )}
                                          </Table.Cell>
                                        </Table.Row>

                                        <Table.Row>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {t("insurance_no") ||
                                                "Insurance Number"}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {!values.deliveries[index][
                                                "active"
                                              ] ? (
                                                <>
                                                  {values?.deliveries?.[index]?.insurance_no ? values?.deliveries?.[index]?.insurance_no : "NA"}
                                                </>
                                              ) : (
                                                <Field
                                                  component={MyNormalInput}
                                                  name={`deliveries.[${index}].insurance_no`}
                                                />
                                              )}
                                            </Header>
                                          </Table.Cell>

                                          { FEATURES.contractualCustomerFieldEnabled &&
                                          <>
                                            <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {t("contractual_customer") ||
                                                "Contractual Customer"}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {!values.deliveries[index][
                                                "active"
                                              ] ? (
                                                <>
                                                  {values?.deliveries?.[index]?.contractual_customer_name ? values?.deliveries?.[index]?.contractual_customer_name : "NA"}
                                                </>
                                              ) : (
                                                <>
                                                <Field
                                                  component={MyBillingPartyComponent}
                                                  name={`deliveries.[${index}].contractual_customer_id`}
                                                  value = {values?.deliveries?.[index]?.contractual_customer_id}
                                                /><br/>
                                                { errors?.deliveries?.[index]?.contractual_customer_id &&
                                                   <small className="text-danger">{errors?.deliveries?.[index]?.contractual_customer_id}</small>
                                                }
                                                </>
                                              )}
                                            </Header>
                                          </Table.Cell>
                                          </>}
  
                                        </Table.Row>



                                        <Table.Row>
                                          <>
                                            <Table.Cell colSpan="2">
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {FEATURES.lineItemsTitleForRemarks ? (
                                                  <>
                                                    {t("remarks1166") ||
                                                      "STO/SO/RGP-NRGP/LineItems"}
                                                  </>
                                                ) : (
                                                  <>
                                                    {t("remarks") || "Remarks"}
                                                  </>
                                                )}
                                              </Header>
                                            </Table.Cell>
                                            <Table.Cell colSpan="2">
                                              <div className="display-flex-center">
                                                <Header
                                                  className="p-bold-500 labelName margin-0"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {!values.deliveries[index][
                                                    "active"
                                                  ] &&
                                                    !(
                                                      orderEditModeAftrAllotRemarks &&
                                                      props.edit &&
                                                      ((props?.currenOrder
                                                        ?.allotment_status &&
                                                        props?.currenOrder
                                                          ?.allotment_status
                                                          ?.allotment_code ==
                                                        "ALLOC") ||
                                                        props?.currenOrder
                                                          ?.allotment_status
                                                          ?.allotment_code ==
                                                        "CANCEL" ||
                                                        props?.currenOrder
                                                          ?.allotment_status
                                                          ?.allotment_code ==
                                                        "COMPLETE")
                                                    ) ? (
                                                    <>
                                                      {values?.deliveries?.[
                                                        index
                                                      ]?.remarks
                                                        ? values.deliveries[
                                                          index
                                                        ].remarks
                                                        : "NA"}

                                                      {props.edit &&
                                                        ((props?.currenOrder
                                                          ?.allotment_status &&
                                                          props?.currenOrder
                                                            ?.allotment_status
                                                            ?.allotment_code ==
                                                          "ALLOC") ||
                                                          props?.currenOrder
                                                            ?.allotment_status
                                                            ?.allotment_code ==
                                                          "CANCEL" ||
                                                          props?.currenOrder
                                                            ?.allotment_status
                                                            ?.allotment_code ==
                                                          "COMPLETE") ? (
                                                        <>
                                                          <Button
                                                            icon
                                                            basic
                                                            size="medium"
                                                            className="margin-left-20 green"
                                                            disabled={
                                                              props.role ==
                                                                "Quality Control"
                                                                ? true
                                                                : false
                                                            }
                                                            type="button"
                                                            onClick={(e) => {
                                                              e.preventDefault();
                                                              e.stopPropagation();
                                                              setOrderEditModeAftrAllotRemarks(
                                                                true
                                                              );
                                                            }}
                                                          >
                                                            <Icon name="edit" />
                                                          </Button>
                                                        </>
                                                      ) : null}
                                                    </>
                                                  ) : (
                                                    <>
                                                      <Field
                                                        component="textarea"
                                                        style={{
                                                          paddingTop: "5.5px",
                                                          whiteSpace: "nowrap",
                                                        }}
                                                        type="text"
                                                        rows="2"
                                                        name={`deliveries[${index}].remarks`}
                                                        values={
                                                          values.deliveries[
                                                            index
                                                          ].remarks
                                                        }
                                                      />
                                                    </>
                                                  )}
                                                </Header>
                                                <Header className="margin-0">
                                                  {!values.deliveries[index][
                                                    "active"
                                                  ] &&
                                                    !(
                                                      orderEditModeAftrAllotRemarks &&
                                                      props.edit &&
                                                      ((props?.currenOrder
                                                        ?.allotment_status &&
                                                        props?.currenOrder
                                                          ?.allotment_status
                                                          ?.allotment_code ==
                                                        "ALLOC") ||
                                                        props?.currenOrder
                                                          ?.allotment_status
                                                          ?.allotment_code ==
                                                        "CANCEL" ||
                                                        props?.currenOrder
                                                          ?.allotment_status
                                                          ?.allotment_code ==
                                                        "COMPLETE")
                                                    ) ? null : (
                                                    <>
                                                      {!values.deliveries[
                                                        index
                                                      ]["active"] ||
                                                        (orderEditModeAftrAllotRemarks &&
                                                          props.edit &&
                                                          ((props?.currenOrder
                                                            ?.allotment_status &&
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "ALLOC") ||
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "CANCEL" ||
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "COMPLETE")) ? (
                                                        <>
                                                          <div className="order-edit-mode-allot display-flex-center-justify-spacearnd">
                                                            <Button
                                                              className="ui blue"
                                                              disabled={
                                                                props.role ==
                                                                  "Quality Control"
                                                                  ? true
                                                                  : false
                                                              }
                                                              onClick={isSubmitting ? null :
                                                                (e) => {
                                                                  e.stopPropagation();
                                                                  setUpdateRemarks(
                                                                    true
                                                                  );
                                                                }}
                                                              type={isSubmitting ? "button" : "submit"}
                                                              basic
                                                              size="medium"
                                                              icon
                                                            >
                                                              <Icon name={isSubmitting ? "loading spinner" : "save"} />
                                                            </Button>
                                                            <Button
                                                              className="ui blue"
                                                              onClick={(e) => {
                                                                e.stopPropagation();
                                                                /*cancelOrderUpdate();*/ setUpdateRemarks(
                                                                  true
                                                                );
                                                                setOrderEditModeAftrAllotRemarks(
                                                                  false
                                                                );
                                                              }}
                                                              basic
                                                              size="medium"
                                                              icon
                                                            >
                                                              <Icon name="times" />
                                                            </Button>
                                                          </div>
                                                        </>
                                                      ) : null}
                                                    </>
                                                  )}
                                                </Header>
                                              </div>
                                            </Table.Cell>
                                          </>
                                          <>

                                            <Table.Cell colSpan="2">
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {"Other LR "}{" "}
                                              </Header>
                                            </Table.Cell>
                                            <Table.Cell colSpan="2" className="display-grid-center">
                                              {values?.deliveries?.[index]?.delivery_related_lr_documents?.length > 0 ?
                                                <>
                                                  {values.deliveries[index].delivery_related_lr_documents.map((item, docNo) => {
                                                    return (
                                                      <>
                                                        {item?.doc_type && item.doc_type === 'other' ?
                                                          <>  <input
                                                            type="file"
                                                            accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                            onChange={(event) => {
                                                              if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                                setFieldValue(`deliveries[${index}].other_lr`, event.currentTarget.files[0])
                                                                if (event.currentTarget.files[0]) {
                                                                  setEnableOtherDocs(false)
                                                                }
                                                              } else {
                                                                setEnableOtherDocs(true)
                                                                cogoToast.error(INVALID_FILE_TYPE)
                                                              }
                                                            }}
                                                          />
                                                            <div className="d-flex align-items-center">
                                                              <Button
                                                                className="docsButton"
                                                                size="mini"
                                                                disabled={enableOtherDocs}
                                                                type="button"
                                                                onClick={() => {
                                                                  uploadLRs('other', values.deliveries[index].other_lr, values.deliveries[index].common_delivery_id)
                                                                }
                                                                }
                                                                basic
                                                                color="green"
                                                                icon
                                                              >
                                                                <Icon name="upload" />
                                                              </Button>
                                                              <Button
                                                                className="docsButton"
                                                                size="mini"
                                                                basic
                                                                type="button"
                                                                onClick={() => {
                                                                  downloadLRs('other', item.doc_key, values.deliveries[index].common_delivery_id)
                                                                }
                                                                }
                                                                color="primary"
                                                                icon
                                                              >
                                                                <Icon name="download" />
                                                              </Button>
                                                              <Button
                                                                className="docsButton"
                                                                size="mini"
                                                                basic
                                                                type="button"
                                                                onClick={() => {
                                                                  deleteLRs('other', item.doc_key, values.deliveries[index].common_delivery_id)
                                                                  setEnableOtherDocs(true)
                                                                }
                                                                }
                                                                color="red"
                                                                icon
                                                              >
                                                                <Icon name="trash" />
                                                              </Button>
                                                              <div
                                                                className="fileName"
                                                              >
                                                                {item.doc_name}
                                                              </div>
                                                              <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                            </div>
                                                          </>
                                                          :
                                                          <>
                                                            {(item.doc_type.localeCompare('other') != 0 && (docNo == values.deliveries[index].delivery_related_lr_documents.length - 1) && values.deliveries[index].delivery_related_lr_documents.length <= 1)
                                                              ?
                                                              <>
                                                                <input
                                                                  //name="daughter_invoice"
                                                                  type="file"
                                                                  accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                                  onChange={(event) => {
                                                                    if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                                      setFieldValue(`deliveries[${index}].other_lr`, event.currentTarget.files[0])
                                                                      if (event.currentTarget.files[0]) {
                                                                        setEnableOtherDocs(false)
                                                                      }
                                                                    } else {
                                                                      setEnableOtherDocs(true)
                                                                      cogoToast.error(INVALID_FILE_TYPE)
                                                                    }
                                                                  }}
                                                                />
                                                                <div className="d-flex align-items-center">
                                                                  <Button
                                                                    className="docsButton"
                                                                    disabled={enableOtherDocs}
                                                                    size="mini"
                                                                    type="button"
                                                                    onClick={() => {
                                                                      uploadLRs('other', values.deliveries[index].other_lr, values.deliveries[index].common_delivery_id)
                                                                    }
                                                                    }
                                                                    basic
                                                                    color="green"
                                                                    icon
                                                                  >
                                                                    <Icon name="upload" />
                                                                  </Button>
                                                                  <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                                </div>
                                                              </>
                                                              :
                                                              null}
                                                          </>
                                                        }
                                                      </>
                                                    )
                                                  })}
                                                </>
                                                :
                                                <>
                                                  <input
                                                    type="file"
                                                    accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                    onChange={(event) => {
                                                      if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                        setFieldValue(`deliveries[${index}].other_lr`, event.currentTarget.files[0])
                                                        if (event.currentTarget.files[0]) {
                                                          setEnableOtherDocs(false)
                                                        }
                                                      } else {
                                                        setEnableOtherDocs(true)
                                                        cogoToast.error(INVALID_FILE_TYPE)
                                                      }
                                                    }}
                                                  />
                                                  <div className="d-flex align-items-center">
                                                    <Button
                                                      className="docsButton"
                                                      disabled={enableOtherDocs}
                                                      size="mini"
                                                      type="button"
                                                      onClick={() => {
                                                        uploadLRs('other', values.deliveries[index].other_lr, values.deliveries[index].common_delivery_id)
                                                      }
                                                      }
                                                      basic
                                                      color="green"
                                                      icon
                                                    >
                                                      <Icon name="upload" />
                                                    </Button>
                                                    <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                  </div>
                                                </>
                                              }
                                            </Table.Cell>
                                            <Table.Cell colSpan="1">
                                            </Table.Cell >
                                            <Table.Cell colSpan="1">
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {"Physical LR"}{" "}
                                              </Header>
                                            </Table.Cell>
                                            <Table.Cell colSpan="2" className="display-grid-center">
                                              {values?.deliveries?.[index]?.delivery_related_lr_documents?.length > 0 ?
                                                <>
                                                  {values.deliveries[index].delivery_related_lr_documents.map((item, docNo) => {
                                                    return (
                                                      <>
                                                        {item.doc_type === 'physical_lr_copy' ?
                                                          <>
                                                            <input
                                                              //name="daughter_invoice"
                                                              type="file"
                                                              accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                              onChange={(event) => {
                                                                if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                                  setFieldValue(`deliveries[${index}].physical_lr`, event.currentTarget.files[0])
                                                                  if (event.currentTarget.files[0]) {
                                                                    setEnablePLR(false)
                                                                  }
                                                                } else {
                                                                  setEnablePLR(true)
                                                                  cogoToast.error(INVALID_FILE_TYPE)
                                                                }
                                                              }}
                                                            />
                                                            <div className="d-flex align-items-center">
                                                              <Button
                                                                className="docsButton"
                                                                disabled={enablePLR}
                                                                size="mini"
                                                                type="button"
                                                                onClick={() => {
                                                                  uploadLRs('physical_lr_copy', values.deliveries[index].physical_lr, values.deliveries[index].common_delivery_id)
                                                                }
                                                                }
                                                                basic
                                                                color="green"
                                                                icon
                                                              >
                                                                <Icon name="upload" />
                                                              </Button>
                                                              <Button
                                                                className="docsButton"
                                                                size="mini"
                                                                basic
                                                                type="button"
                                                                onClick={() => {
                                                                  downloadLRs('physical_lr_copy', item.doc_key, values.deliveries[index].common_delivery_id)

                                                                }
                                                                }
                                                                color="primary"
                                                                icon
                                                              >
                                                                <Icon name="download" />
                                                              </Button>
                                                              <Button
                                                                className="docsButton"
                                                                size="mini"
                                                                basic
                                                                type="button"
                                                                onClick={() => {
                                                                  deleteLRs('physical_lr_copy', item.doc_key, values.deliveries[index].common_delivery_id)
                                                                  setEnablePLR(true)
                                                                }
                                                                }
                                                                color="red"
                                                                icon
                                                              >
                                                                <Icon name="trash" />
                                                              </Button>
                                                              <div
                                                                className="fileName"
                                                              >
                                                                {item.doc_name}
                                                              </div>

                                                              <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                            </div>
                                                          </>
                                                          :
                                                          <>
                                                            {(item.doc_type.localeCompare('physical_lr_copy') != 0 && (docNo == values.deliveries[index].delivery_related_lr_documents.length - 1) && values.deliveries[index].delivery_related_lr_documents.length <= 1)
                                                              ?
                                                              <>
                                                                <input
                                                                  type="file"
                                                                  accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                                  onChange={(event) => {
                                                                    if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                                      setFieldValue(`deliveries[${index}].physical_lr`, event.currentTarget.files[0])
                                                                      if (event.currentTarget.files[0]) {
                                                                        setEnablePLR(false)
                                                                      }
                                                                    } else {
                                                                      setEnablePLR(true)
                                                                      cogoToast.error(INVALID_FILE_TYPE)
                                                                    }
                                                                  }}
                                                                />
                                                                <div className="d-flex align-items-center">
                                                                  <Button
                                                                    className="docsButton"
                                                                    disabled={enablePLR}
                                                                    size="mini"
                                                                    type="button"
                                                                    onClick={() => {
                                                                      uploadLRs('physical_lr_copy', values.deliveries[index].physical_lr, values.deliveries[index].common_delivery_id)
                                                                    }
                                                                    }
                                                                    basic
                                                                    color="green"
                                                                    icon
                                                                  >
                                                                    <Icon name="upload" />
                                                                  </Button>
                                                                  <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                                </div>
                                                              </>
                                                              :
                                                              null}
                                                          </>}
                                                      </>
                                                    )
                                                  })}
                                                </>
                                                :
                                                <>
                                                  <input
                                                    //name="daughter_invoice"
                                                    type="file"
                                                    accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                    onChange={(event) => {
                                                      if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                        setFieldValue(`deliveries[${index}].physical_lr`, event.currentTarget.files[0])
                                                        if (event.currentTarget.files[0]) {
                                                          setEnablePLR(false)
                                                        }
                                                      } else {
                                                        setEnablePLR(true)
                                                        cogoToast.error(INVALID_FILE_TYPE)
                                                      }
                                                    }}
                                                  />
                                                  <div className="d-flex align-items-center">
                                                    <Button
                                                      className="docsButton"
                                                      disabled={enablePLR}
                                                      size="mini"
                                                      type="button"
                                                      onClick={() => {
                                                        uploadLRs('physical_lr_copy', values.deliveries[index].physical_lr, values.deliveries[index].common_delivery_id)
                                                      }
                                                      }
                                                      basic
                                                      color="green"
                                                      icon
                                                    >
                                                      <Icon name="upload" />
                                                    </Button>
                                                    <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                  </div>
                                                </>
                                              }
                                            </Table.Cell>
                                          </>
                                        </Table.Row>
                                        {props.movement_type &&
                                          (props.movement_type === "Import" ||
                                            props.movement_type ===
                                            "Importar" ||
                                            props.movement_type ===
                                            "Export") && (
                                            <>
                                              <Table.Row>
                                                <Table.Cell colSpan="2">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {t("drop_location") ||
                                                      "Drop Location"}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell colSpan="2">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {values?.deliveries?.[index]
                                                      ?.drop_location
                                                      ? values.deliveries[index]
                                                        .drop_location
                                                      : "NA"}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell colSpan="2">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {t("ata") ||
                                                      "Drop Location"}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell colSpan="2">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {!values.deliveries[index][
                                                      "active"
                                                    ] ? (
                                                      <>
                                                        {values.deliveries[
                                                          index
                                                        ].ata_date
                                                          ? moment(
                                                            values.deliveries[
                                                              index
                                                            ].ata_date
                                                          ).format(
                                                            "DD-MM-YYYY"
                                                          )
                                                          : "NA"}
                                                      </>
                                                    ) : (
                                                      <DateData
                                                        // style={{ width: "100% !important" }}
                                                        name={`deliveries.[${index}].ata_date`}
                                                        disabled={
                                                          !values.deliveries[
                                                          index
                                                          ]["active"]
                                                        }
                                                        autoComplete="off"
                                                        // showTimeSelect
                                                        timeFormat="HH:mm"
                                                        popperClassName="dateTime"
                                                        dateFormat="dd/MM/yyyy"
                                                        selected={
                                                          new Date(
                                                            values.deliveries[
                                                              index
                                                            ].ata_date
                                                          )
                                                        }
                                                        timeIntervals={5}
                                                        customInput={
                                                          <Input
                                                            icon="time"
                                                            // className="dateWidth"
                                                            iconPosition="left"
                                                          />
                                                        }
                                                      />
                                                      // null
                                                    )}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell>
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {t("daughter_invoice") ||
                                                      "Daughter Invoice"}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell>
                                                  {values.deliveries[index]
                                                    .daughter_invoice ? (
                                                    <>
                                                      <input
                                                        id="daughter_invoice1"
                                                        name="daughter_invoice"
                                                        type="file"
                                                        style={{
                                                          display: "none",
                                                        }}
                                                        accept="application/pdf, application/vnd.ms-excel"
                                                        onChange={(event) => {
                                                          updateFile(
                                                            "daughter_invoice",
                                                            event.currentTarget
                                                              .files[0],
                                                            values.deliveries[
                                                              index
                                                            ].container_no,
                                                            values.deliveries[
                                                              index
                                                            ].delivery_id
                                                          );
                                                        }}
                                                      />
                                                      {
                                                        values.deliveries[index]
                                                          .daughter_invoice
                                                          .document_name
                                                      }
                                                      &nbsp;
                                                      <Button
                                                        size="mini"
                                                        type="button"
                                                        onClick={() =>
                                                          getFileid(
                                                            "daughter_invoice1"
                                                          )
                                                        }
                                                        basic
                                                        color="green"
                                                        icon
                                                      >
                                                        <Icon name="upload" />
                                                      </Button>
                                                      &nbsp;
                                                      <Button
                                                        size="mini"
                                                        basic
                                                        type="button"
                                                        onClick={() =>
                                                          downloadFile(
                                                            values.deliveries[
                                                              index
                                                            ].daughter_invoice
                                                              .container_number,
                                                            values.deliveries[
                                                              index
                                                            ].daughter_invoice
                                                              .delivery_id,
                                                            values.deliveries[
                                                              index
                                                            ].daughter_invoice
                                                              .document_id
                                                          )
                                                        }
                                                        color="primary"
                                                        icon
                                                      >
                                                        <Icon name="download" />
                                                      </Button>
                                                      &nbsp;
                                                      <Button
                                                        size="mini"
                                                        basic
                                                        type="button"
                                                        onClick={() =>
                                                          deleteFile(
                                                            values.deliveries[
                                                              index
                                                            ].daughter_invoice
                                                              .container_number,
                                                            values.deliveries[
                                                              index
                                                            ].daughter_invoice
                                                              .delivery_id,
                                                            values.deliveries[
                                                              index
                                                            ].daughter_invoice
                                                              .document_id
                                                          )
                                                        }
                                                        color="red"
                                                        icon
                                                      >
                                                        <Icon name="trash" />
                                                      </Button>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <input
                                                        id="daughter_invoice"
                                                        name="daughter_invoice"
                                                        type="file"
                                                        style={{ width: "80%" }}
                                                        accept="application/pdf, application/vnd.ms-excel"
                                                        onChange={(event) => {
                                                          setFile(
                                                            "daughter_invoice",
                                                            event.currentTarget
                                                              .files[0],
                                                            values.deliveries[
                                                              index
                                                            ].container_no,
                                                            values.deliveries[
                                                              index
                                                            ].delivery_id
                                                          );
                                                          setFieldValue(
                                                            "daughter_invoice",
                                                            event.currentTarget
                                                              .files[0]
                                                          );
                                                        }}
                                                      />
                                                      &nbsp;&nbsp;
                                                      <Button
                                                        size="mini"
                                                        type="button"
                                                        disabled={disablebtn}
                                                        onClick={() =>
                                                          uploadDaughterInvoice(
                                                            "daughter_invoice",
                                                            values.deliveries[
                                                              index
                                                            ].container_no,
                                                            values.deliveries[
                                                              index
                                                            ].delivery_id
                                                          )
                                                        }
                                                        basic
                                                        color="green"
                                                        icon
                                                      >
                                                        <Icon name="upload" />
                                                      </Button>
                                                    </>
                                                  )}
                                                </Table.Cell>
                                              </Table.Row>
                                              <Table.Row>
                                                <Table.Cell colSpan="2">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {t("drop_date") ||
                                                      "Drop Location"}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell colSpan="2">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {!values.deliveries[index][
                                                      "active"
                                                    ] ? (
                                                      <>
                                                        {values.deliveries[
                                                          index
                                                        ].container_return_date
                                                          ? moment(
                                                            values.deliveries[
                                                              index
                                                            ]
                                                              .container_return_date
                                                          ).format(
                                                            "DD-MM-YYYY HH:mm"
                                                          )
                                                          : "NA"}
                                                      </>
                                                    ) : (
                                                      <DateData
                                                        // style={{ width: "100% !important" }}
                                                        name={`deliveries.[${index}].container_return_date`}
                                                        disabled={
                                                          !values.deliveries[
                                                          index
                                                          ]["active"]
                                                        }
                                                        autoComplete="off"
                                                        showTimeSelect
                                                        timeFormat="HH:mm"
                                                        popperClassName="dateTime"
                                                        dateFormat="dd/MM/yyyy HH:mm"
                                                        selected={
                                                          new Date(
                                                            values.deliveries[
                                                              index
                                                            ].container_return_date
                                                          )
                                                        }
                                                        timeIntervals={5}
                                                        customInput={
                                                          <Input
                                                            icon="time"
                                                            // className="dateWidth"
                                                            iconPosition="left"
                                                          />
                                                        }
                                                      />
                                                      // null
                                                    )}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell colSpan="2">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {t("actual_drop_date") ||
                                                      "Drop Location"}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell colSpan="2">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {!values.deliveries[index][
                                                      "active"
                                                    ] ? (
                                                      <>
                                                        {values.deliveries[
                                                          index
                                                        ]
                                                          .actual_container_return_date
                                                          ? moment(
                                                            values.deliveries[
                                                              index
                                                            ]
                                                              .actual_container_return_date
                                                          ).format(
                                                            "DD-MM-YYYY HH:mm"
                                                          )
                                                          : "NA"}
                                                      </>
                                                    ) : (
                                                      <DateData
                                                        // style={{ width: "100% !important" }}
                                                        name={`deliveries.[${index}].actual_container_return_date`}
                                                        disabled={
                                                          !values.deliveries[
                                                          index
                                                          ]["active"]
                                                        }
                                                        autoComplete="off"
                                                        showTimeSelect
                                                        timeFormat="HH:mm"
                                                        popperClassName="dateTime"
                                                        dateFormat="dd/MM/yyyy HH:mm"
                                                        selected={
                                                          new Date(
                                                            values.deliveries[
                                                              index
                                                            ].actual_container_return_date
                                                          )
                                                        }
                                                        timeIntervals={5}
                                                        customInput={
                                                          <Input
                                                            icon="time"
                                                            // className="dateWidth"
                                                            iconPosition="left"
                                                          />
                                                        }
                                                      />
                                                      // null
                                                    )}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell>
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {t("difference") ||
                                                      "Difference"}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell>
                                                  {values.deliveries[index]
                                                    .actual_container_return_date &&
                                                    values.deliveries[index]
                                                      .container_return_date ? (
                                                    <>
                                                      {getReturnDiff(
                                                        values.deliveries[index]
                                                          .actual_container_return_date,
                                                        values.deliveries[index]
                                                          .container_return_date
                                                      )}
                                                    </>
                                                  ) : (
                                                    "NA"
                                                  )}
                                                </Table.Cell>
                                              </Table.Row>
                                              <Table.Row>
                                                <Table.Cell colSpan="2">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {t("storage_expiration") ||
                                                      "Drop Location"}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell colSpan="2">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {!values.deliveries[index][
                                                      "active"
                                                    ] ? (
                                                      <>
                                                        {values.deliveries[
                                                          index
                                                        ]
                                                          .storage_expiration_date
                                                          ? moment(
                                                            values.deliveries[
                                                              index
                                                            ]
                                                              .storage_expiration_date
                                                          ).format(
                                                            "DD-MM-YYYY"
                                                          )
                                                          : "NA"}
                                                      </>
                                                    ) : (
                                                      <DateData
                                                        // style={{ width: "100% !important" }}
                                                        name={`deliveries.[${index}].storage_expiration_date`}
                                                        disabled={
                                                          !values.deliveries[
                                                          index
                                                          ]["active"]
                                                        }
                                                        autoComplete="off"
                                                        // showTimeSelect
                                                        timeFormat="HH:mm"
                                                        popperClassName="dateTime"
                                                        dateFormat="dd/MM/yyyy HH:mm:ss"
                                                        selected={
                                                          new Date(
                                                            values.deliveries[
                                                              index
                                                            ].storage_expiration_date
                                                          )
                                                        }
                                                        timeIntervals={5}
                                                        customInput={
                                                          <Input
                                                            icon="time"
                                                            // className="dateWidth"
                                                            iconPosition="left"
                                                          />
                                                        }
                                                      />
                                                      // null
                                                    )}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell colSpan="2">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {FEATURES.createOrderShowDemurageExpiration ? (
                                                      <>
                                                        {t(
                                                          "do_no_expiration"
                                                        ) || "Do No Expiration"}
                                                      </>
                                                    ) : (
                                                      <>
                                                        {t(
                                                          "demurrage_expiration"
                                                        ) ||
                                                          "Demurrage Expiration"}
                                                      </>
                                                    )}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell colSpan="4">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {!values.deliveries[index][
                                                      "active"
                                                    ] ? (
                                                      <>
                                                        {values.deliveries[
                                                          index
                                                        ]
                                                          .demurrage_expiration_date
                                                          ? moment(
                                                            values.deliveries[
                                                              index
                                                            ]
                                                              .demurrage_expiration_date
                                                          ).format(
                                                            "DD-MM-YYYY"
                                                          )
                                                          : "NA"}
                                                      </>
                                                    ) : (
                                                      <DateData
                                                        // style={{ width: "100% !important" }}
                                                        name={`deliveries.[${index}].demurrage_expiration_date`}
                                                        disabled={
                                                          !values.deliveries[
                                                          index
                                                          ]["active"]
                                                        }
                                                        autoComplete="off"
                                                        // showTimeSelect
                                                        // timeFormat="HH:mm"
                                                        popperClassName="dateTime"
                                                        dateFormat="dd/MM/yyyy"
                                                        selected={
                                                          new Date(
                                                            values.deliveries[
                                                              index
                                                            ].demurrage_expiration_date
                                                          )
                                                        }
                                                        timeIntervals={5}
                                                        customInput={
                                                          <Input
                                                            icon="time"
                                                            // className="dateWidth"
                                                            iconPosition="left"
                                                          />
                                                        }
                                                      />
                                                    )}
                                                  </Header>
                                                </Table.Cell>
                                              </Table.Row>

                                              <Table.Row>
                                                <Table.Cell colSpan="2">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {t("container_number") ||
                                                      "Container Number"}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell colSpan="2">
                                                  <div className="display-flex-center">
                                                    <Header
                                                      className="p-bold-500 labelName margin-0"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      {!values.deliveries[index][
                                                        "active"
                                                      ] &&
                                                        !(
                                                          orderEditModeAftrAllotContainerNumber &&
                                                          props.edit &&
                                                          ((props?.currenOrder
                                                            ?.allotment_status &&
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "ALLOC") ||
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "CANCEL" ||
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "COMPLETE")
                                                        ) ? (
                                                        <>
                                                          {values?.deliveries?.[index]
                                                            ?.container_no
                                                            ? values.deliveries[index]
                                                              .container_no
                                                            : "NA"}
                                                          {props.edit && ((props?.currenOrder
                                                            ?.allotment_status &&
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "ALLOC") ||
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "CANCEL") ? (
                                                            <>
                                                              <Button
                                                                icon
                                                                basic
                                                                size="medium"
                                                                className="margin-left-20 green"
                                                                disabled={
                                                                  props.role ==
                                                                    "Quality Control"
                                                                    ? true
                                                                    : false
                                                                }
                                                                type="button"
                                                                onClick={(e) => {
                                                                  e.preventDefault();
                                                                  e.stopPropagation();
                                                                  setorderEditModeAftrAllotContainerNumber(
                                                                    true
                                                                  );
                                                                  setDefaultContainerNoVal(
                                                                    values.deliveries[index]
                                                                      .container_no
                                                                  );
                                                                }}
                                                              >
                                                                <Icon name="edit" />
                                                              </Button>
                                                            </>
                                                          ) : null}
                                                        </>
                                                      ) : (
                                                        <>
                                                          <Field
                                                            component={MyNormalInput}
                                                            autoComplete="off"
                                                            name={`deliveries.[${index}].container_no`}
                                                          />
                                                        </>
                                                      )}
                                                    </Header>
                                                    <Header className="margin-0">
                                                      {!values.deliveries[index][
                                                        "active"
                                                      ] &&
                                                        !(
                                                          orderEditModeAftrAllotContainerNumber &&
                                                          props.edit &&
                                                          ((props?.currenOrder
                                                            ?.allotment_status &&
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "ALLOC") ||
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "CANCEL" ||
                                                            props?.currenOrder
                                                              ?.allotment_status
                                                              ?.allotment_code ==
                                                            "COMPLETE")
                                                        ) ? null : (
                                                        <>
                                                          {!values.deliveries[
                                                            index
                                                          ]["active"] ||
                                                            (orderEditModeAftrAllotContainerNumber &&
                                                              props.edit && ((props?.currenOrder
                                                                ?.allotment_status &&
                                                                props?.currenOrder
                                                                  ?.allotment_status
                                                                  ?.allotment_code ==
                                                                "ALLOC") ||
                                                                props?.currenOrder
                                                                  ?.allotment_status
                                                                  ?.allotment_code ==
                                                                "CANCEL" ||
                                                                props?.currenOrder
                                                                  ?.allotment_status
                                                                  ?.allotment_code ==
                                                                "COMPLETE")) ? (
                                                            <>
                                                              <div className="order-edit-mode-allot display-flex-center-justify-spacearnd">
                                                                <Button
                                                                  className="ui blue"
                                                                  disabled={
                                                                    props.role ==
                                                                      "Quality Control"
                                                                      ? true
                                                                      : false
                                                                  }

                                                                  type={isSubmitting ? "button" : "submit"}
                                                                  basic
                                                                  size="medium"
                                                                  icon
                                                                  onClick={isSubmitting ? null :
                                                                    (e) => {
                                                                      e.stopPropagation();
                                                                      setUpdateContainerNo(
                                                                        true
                                                                      );
                                                                    }}
                                                                >
                                                                  <Icon name={isSubmitting ? "loading spinner" : "save"} />
                                                                </Button>
                                                                <Button
                                                                  className="ui blue"
                                                                  onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    values.deliveries[index].container_no = defaultContainerNoVal
                                                                    setorderEditModeAftrAllotContainerNumber(
                                                                      false
                                                                    );
                                                                  }}
                                                                  basic
                                                                  size="medium"
                                                                  icon
                                                                >
                                                                  <Icon name="times" />
                                                                </Button>
                                                              </div>
                                                            </>
                                                          ) : null}
                                                        </>
                                                      )}
                                                    </Header>
                                                  </div>
                                                </Table.Cell>
                                                <Table.Cell colSpan="2">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {t("container_size") ||
                                                      "Container Size"}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell colSpan="2">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    <Dropdown
                                                      clearable
                                                      disabled={
                                                        !values.deliveries[
                                                        index
                                                        ]["active"]
                                                      }
                                                      style={{
                                                        width: "100%",
                                                        fontWeight: "normal",
                                                      }}
                                                      search
                                                      name={`deliveries[${index}].container_size`}
                                                      selection
                                                      placeholder={
                                                        props.t(
                                                          "container_size"
                                                        ) || "Container Type"
                                                      }
                                                      value={
                                                        values.deliveries[index]
                                                          .container_size
                                                      }
                                                      onChange={(name, data) =>
                                                        setFieldValue(
                                                          `deliveries[${index}].container_size`,
                                                          data.value
                                                        )
                                                      }
                                                      options={containerSizeList}
                                                    />
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell>
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {t("container_type_id") ||
                                                      "Container Type"}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell>
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    <Dropdown
                                                      clearable
                                                      style={{
                                                        width: "100%",
                                                        fontWeight: "normal",
                                                      }}
                                                      search
                                                      name={`deliveries[${index}].container_type_id`}
                                                      selection
                                                      disabled={
                                                        !values.deliveries[
                                                        index
                                                        ]["active"]
                                                      }
                                                      placeholder={
                                                        props.t(
                                                          "container_type_id"
                                                        ) || "Container Type"
                                                      }
                                                      defaultValue={
                                                        values.deliveries[index]
                                                          .container_type_id
                                                      }
                                                      onChange={(name, data) =>
                                                        setFieldValue(
                                                          `deliveries[${index}].container_type_id`,
                                                          data.value
                                                        )
                                                      }
                                                      options={containerType}
                                                    />
                                                  </Header>
                                                </Table.Cell>

                                              </Table.Row>


                                              <Table.Row>
                                                <Table.Cell colSpan="2">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {t("container_seal_no") ||
                                                      "Container Seal Number"}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell colSpan="2">
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    <Field
                                                      disabled={
                                                        !values.deliveries[
                                                        index
                                                        ]["active"]
                                                      }
                                                      component={MyNormalInput}
                                                      name={`deliveries.[${index}].container_seal_no`}
                                                    />
                                                  </Header>
                                                </Table.Cell>
                                              </Table.Row>
                                            </>
                                          )}

                                        {(props.movement_type &&
                                          props.movement_type == "Export") ||
                                          (props.movement_type &&
                                            props.movement_type == "Import") ? (
                                          <>
                                            <Table.Row>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {props.movement_type == "Import" ? 'CRO Date' : props.movement_type == "Export" ? t("do_date") || "DO Date" : null}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {!values.deliveries[index][
                                                    "active"
                                                  ] ? (
                                                    <>
                                                      {values.deliveries[index]
                                                        .do_validity_date
                                                        ? moment(
                                                          values.deliveries[
                                                            index
                                                          ].do_validity_date
                                                        ).format("DD-MM-YYYY")
                                                        : "NA"}
                                                    </>
                                                  ) : (
                                                    <DateData
                                                      // style={{ width: "100% !important" }}
                                                      name={`deliveries.[${index}].do_validity_date`}
                                                      disabled={
                                                        !values.deliveries[
                                                        index
                                                        ]["active"]
                                                      }
                                                      autoComplete="off"
                                                      // showTimeSelect
                                                      timeFormat="HH:mm"
                                                      popperClassName="dateTime"
                                                      dateFormat="dd/MM/yyyy"
                                                      selected={
                                                        new Date(
                                                          values.deliveries[
                                                            index
                                                          ].do_validity_date
                                                        )
                                                      }
                                                      timeIntervals={5}
                                                      customInput={
                                                        <Input
                                                          icon="time"
                                                          // className="dateWidth"
                                                          iconPosition="left"
                                                        />
                                                      }
                                                    />
                                                    // null
                                                  )}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {props.movement_type == "Import" ? 'CRO No' : props.movement_type == "Export" ? t("do_no") || "DO No" : null}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  <Field
                                                    disabled={
                                                      !values.deliveries[index][
                                                      "active"
                                                      ]
                                                    }
                                                    component={MyNormalInput}
                                                    name={`deliveries.[${index}].do_no`}
                                                  />
                                                </Header>
                                              </Table.Cell>

                                              <>
                                                <Table.Cell>
                                                  <Header
                                                    className="p-bold-500 labelName"
                                                    size="tiny"
                                                    as="label"
                                                    color="grey"
                                                  >
                                                    {t("upload_do") ||
                                                      "Daughter Invoice"}
                                                  </Header>
                                                </Table.Cell>
                                                <Table.Cell>
                                                  {values.deliveries[index]
                                                    .delivery_order ? (
                                                    <>
                                                      <input
                                                        id="delivery_order1"
                                                        name="delivery_order"
                                                        type="file"
                                                        style={{
                                                          display: "none",
                                                        }}
                                                        accept="application/pdf, application/vnd.ms-excel"
                                                        onChange={(event) => {
                                                          douploadfile(
                                                            "delivery_order",
                                                            event.currentTarget
                                                              .files[0],
                                                            values.deliveries[
                                                              index
                                                            ].delivery_id
                                                          );
                                                        }}
                                                      />
                                                      {
                                                        values.deliveries[index]
                                                          .delivery_order
                                                          .document_name
                                                      }
                                                      &nbsp;
                                                      <Button
                                                        size="mini"
                                                        type="button"
                                                        onClick={() =>
                                                          getdoField(
                                                            "delivery_order1"
                                                          )
                                                        }
                                                        basic
                                                        color="green"
                                                        icon
                                                      >
                                                        <Icon name="upload" />
                                                      </Button>
                                                      &nbsp;
                                                      <Button
                                                        size="mini"
                                                        basic
                                                        type="button"
                                                        onClick={() =>
                                                          downloadDO(
                                                            values.deliveries[
                                                              index
                                                            ].delivery_order
                                                              .delivery_id,
                                                            values.deliveries[
                                                              index
                                                            ].delivery_order
                                                              .document_id
                                                          )
                                                        }
                                                        color="primary"
                                                        icon
                                                      >
                                                        <Icon name="download" />
                                                      </Button>
                                                      &nbsp;
                                                      <Button
                                                        size="mini"
                                                        basic
                                                        type="button"
                                                        onClick={() =>
                                                          deleteDO(
                                                            values.deliveries[
                                                              index
                                                            ].delivery_order
                                                              .delivery_id,
                                                            values.deliveries[
                                                              index
                                                            ].delivery_order
                                                              .document_id
                                                          )
                                                        }
                                                        color="red"
                                                        icon
                                                      >
                                                        <Icon name="trash" />
                                                      </Button>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <input
                                                        id="delivery_order"
                                                        name="delivery_order"
                                                        type="file"
                                                        style={{ width: "80%" }}
                                                        accept="application/pdf, application/vnd.ms-excel"
                                                        onChange={(event) => {
                                                          setDOFile(
                                                            "delivery_order",
                                                            event.currentTarget
                                                              .files[0]
                                                          );
                                                          setFieldValue(
                                                            "delivery_order",
                                                            event.currentTarget
                                                              .files[0]
                                                          );
                                                        }}
                                                      />
                                                      &nbsp;&nbsp;
                                                      <Button
                                                        size="mini"
                                                        type="button"
                                                        disabled={disablebtn}
                                                        onClick={() =>
                                                          uploadDODoc(
                                                            "delivery_order",
                                                            values.deliveries[
                                                              index
                                                            ].delivery_id
                                                          )
                                                        }
                                                        basic
                                                        color="green"
                                                        icon
                                                      >
                                                        <Icon name="upload" />
                                                      </Button>
                                                    </>
                                                  )}
                                                </Table.Cell>
                                              </>
                                            </Table.Row>
                                          </>
                                        ) : null}

                                        {props.movement_type &&
                                          props.movement_type == "Export" || props.movement_type == "Import" ? (
                                          <>
                                            <Table.Row>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {t("shiping_line") ||
                                                    "Shipping Line"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">

                                                <Dropdown
                                                  clearable
                                                  style={{
                                                    width: "100%",
                                                    fontWeight: "normal",
                                                  }}
                                                  search
                                                  name={`deliveries[${index}].shipping_line_id`}
                                                  disabled={
                                                    !values.deliveries[index][
                                                    "active"
                                                    ]
                                                  }
                                                  selection
                                                  placeholder={
                                                    props.t("shiping_line") ||
                                                    "Shipping Line"
                                                  }
                                                  value={
                                                    values.deliveries[index]
                                                      .shipping_line_id
                                                  }
                                                  onChange={(name, data) =>
                                                    setFieldValue(
                                                      `deliveries[${index}].shipping_line_id`,
                                                      data.value
                                                    )
                                                  }
                                                  options={shipingline}
                                                />

                                              </Table.Cell>

                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {t("cha") || "CHA"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">

                                                <Dropdown
                                                  clearable
                                                  style={{
                                                    width: "100%",
                                                    fontWeight: "normal",
                                                  }}
                                                  search
                                                  name={`deliveries[${index}].cha_id`}
                                                  disabled={
                                                    !values.deliveries[index][
                                                    "active"
                                                    ]
                                                  }
                                                  selection
                                                  placeholder={
                                                    props.t("cha") || "CHA"
                                                  }
                                                  defaultValue={
                                                    values.deliveries[index]
                                                      .cha_id
                                                  }
                                                  onChange={(name, data) =>
                                                    setFieldValue(
                                                      `deliveries[${index}].cha_id`,
                                                      data.value
                                                    )
                                                  }
                                                  options={cha}
                                                />
                                              </Table.Cell>
                                            </Table.Row>
                                          </>
                                        ) : null}

                                        <>
                                          <Table.Row>
                                            <Table.Cell colSpan="2">
                                              <h3 className="sub-heading-adjust">
                                                {FEATURES.billingPartyFreightDetailsTitle ? (
                                                  <>
                                                    Billing Party Freight
                                                    Details
                                                  </>
                                                ) : (
                                                  <>Freight Details</>
                                                )}
                                              </h3>
                                            </Table.Cell>
                                            <div>
                                              {
                                                LOCAL_STORAGE.freightDetail == '0' ?
                                                  <Table.Cell colSpan="1" style={{
                                                    display: 'flex'
                                                  }}>
                                                    <Button
                                                      basic
                                                      color="green"
                                                      type="button"
                                                      size="mini"
                                                      icon
                                                      //onClick={() => { editEvaluateFreightRate(values, index); }}
                                                      onClick={() => {
                                                        evaluateFreightRate(
                                                          values,
                                                          setFieldValue,
                                                          `deliveries[${index}].proposed_freight_rate`,
                                                          `deliveries[${index}].actual_freight_rate`,
                                                          `deliveries[${index}].final_freight_rate`,
                                                          `deliveries[${index}].cft_kg_factor`,
                                                          `deliveries[${index}].charged_weight`,
                                                          `deliveries[${index}].cft_kg_enable`,
                                                          `deliveries[${index}].final_rate`,
                                                          `deliveries[${index}].charges`,
                                                          index
                                                        );
                                                      }}
                                                    >
                                                      Evaluate Freight
                                                    </Button>
                                                    {
                                                      !editFreightRate ?
                                                        <Button
                                                          basic
                                                          color="green"
                                                          type="button"
                                                          size="mini"
                                                          icon
                                                          onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setEditFreightRate(true)
                                                          }}
                                                        >
                                                          <Icon name="edit" />
                                                        </Button>
                                                        : <Button
                                                          className="ui blue"
                                                          primary
                                                          type={isSubmitting ? "button" : "submit"}
                                                          basic
                                                          size="medium"
                                                          icon
                                                          onClick={isSubmitting ? null :
                                                            (e) => {
                                                              e.preventDefault();
                                                              e.stopPropagation();
                                                              onFreightUpdate(values)
                                                            }}
                                                        >
                                                          <Icon name={isSubmitting ? "loading spinner" : "save"} />
                                                        </Button>
                                                    }

                                                  </Table.Cell>
                                                  : null
                                              }
                                            </div>
                                            <Table.Cell colSpan="6"></Table.Cell>

                                            <Table.Cell>
                                              {
                                                LOCAL_STORAGE.freightDetail == '1' ?
                                                  <Button
                                                    basic
                                                    color="green"
                                                    disabled
                                                    type="button"
                                                    size="mini"
                                                    icon
                                                    onClick={() => {
                                                      evaluateFreightRate(
                                                        values,
                                                        setFieldValue,
                                                        `deliveries[${index}].proposed_freight_rate`,
                                                        `deliveries[${index}].actual_freight_rate`,
                                                        `deliveries[${index}].final_freight_rate`,
                                                        `deliveries[${index}].cft_kg_factor`,
                                                        `deliveries[${index}].charged_weight`,
                                                        `deliveries[${index}].cft_kg_enable`,
                                                        `deliveries[${index}].final_rate`,
                                                        `deliveries[${index}].charges`,
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    Evaluate Freight
                                                  </Button>

                                                  : null
                                              }

                                            </Table.Cell>
                                          </Table.Row>
                                          <Table.Row>
                                            <>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {t("proposed_freight_rate") ||
                                                    "Proposed Freight Rate"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  <>
                                                    {values?.deliveries?.[index]
                                                      ?.proposed_freight_rate
                                                      ? values.deliveries[index]
                                                        .proposed_freight_rate
                                                      : 0}
                                                  </>
                                                </Header>
                                              </Table.Cell>
                                            </>
                                            <>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {t("uom") || "UoM"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                {
                                                  LOCAL_STORAGE.freightDetail == '0' ?
                                                    <Dropdown
                                                      disabled={
                                                        !editFreightRate ? true : false
                                                      }
                                                      name={`deliveries[${index}].uom`}
                                                      clearable
                                                      style={{
                                                        width: "100%",
                                                        fontWeight: "normal",
                                                        opacity: "1",
                                                      }}
                                                      selection
                                                      placeholder={"Unit Of Measurement"}
                                                      options={uomValues}
                                                      defaultValue={"ton"}
                                                      value={values.deliveries[index].uom && Number(values.deliveries[index].uom)}
                                                      onChange={(name, data) => {
                                                        let uomName = uomValues.find((uom)=> uom.value === data.value)?.text
                                                        setFieldValue(
                                                          `deliveries[${index}].uom`,
                                                          data.value
                                                        );
                                                        setFieldValue(
                                                          `deliveries[${index}].uom_name`,
                                                          uomName
                                                        );
                                                        let multiplyFactor = 0,
                                                          actualValue = 0;
                                                        let actualFreightValue =
                                                          values?.deliveries?.[index]
                                                            ?.actual_freight_rate;

                                                        if (
                                                          values?.deliveries?.[index]?.uom
                                                        ) {
                                                          if (uomName?.toUpperCase() === "TRIP") {
                                                            actualValue =
                                                              actualFreightValue;
                                                            setFieldValue(
                                                              `deliveries[${index}].final_freight_rate`,
                                                              actualValue
                                                            );
                                                            setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                          } else if (uomName?.toUpperCase() === "KG") {
                                                            if (
                                                              values?.deliveries?.[index]
                                                                ?.charged_weight
                                                            ) {
                                                              multiplyFactor = values.deliveries[index].charged_weight && (FEATURES.weightInTonCustomers ? Number(values.deliveries[index].charged_weight) * 1000 : Number(values.deliveries[index].charged_weight));
                                                              actualValue =
                                                                multiplyFactor *
                                                                actualFreightValue;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                              setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                            } else {
                                                              actualValue =
                                                                actualFreightValue;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                              setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                            }
                                                          } else if (uomName?.toUpperCase() === "TON") {
                                                            if (
                                                              values?.deliveries?.[index]
                                                                ?.charged_weight
                                                            ) {
                                                              multiplyFactor = values.deliveries[index].charged_weight && (FEATURES.weightInTonCustomers ? Number(values.deliveries[index].charged_weight) : Number(values.deliveries[index].charged_weight) / 1000);
                                                              actualValue =
                                                                multiplyFactor *
                                                                actualFreightValue;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                              setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                            } else {
                                                              actualValue =
                                                                actualFreightValue / 1000;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                              setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                            }
                                                          }else if (uomName?.toUpperCase() === "PER TON PER KM") {
                                                            if (
                                                              values?.deliveries?.[index]
                                                                ?.charged_weight
                                                            ) {
                                                              multiplyFactor = values.deliveries[index].charged_weight && (FEATURES.weightInTonCustomers ? Number(values.deliveries[index].charged_weight) : Number(values.deliveries[index].charged_weight) / 1000);
                                                              let distance = props?.budgeted_kms && Number(props?.budgeted_kms.replace(' Kms', ''));
                                                              actualValue = multiplyFactor * actualFreightValue * distance;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                              setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                            } else {
                                                              actualValue = actualFreightValue;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                              setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                            }
                                                          } else if (uomName?.toUpperCase() === "KM") {
                                                            if (props?.budgeted_kms) {
                                                              multiplyFactor =
                                                                Number(props?.budgeted_kms.replace(' Kms', ''));
                                                              actualValue =
                                                                multiplyFactor *
                                                                actualFreightValue;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                              setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                            } else {
                                                              actualValue =
                                                                actualFreightValue;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                              setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                            }
                                                          } else if (
                                                            uomName?.toUpperCase() === "PER CASE"
                                                          ) {
                                                            if (
                                                              values?.deliveries?.[index]
                                                                ?.total_quantity
                                                            ) {
                                                              multiplyFactor =
                                                                values.deliveries[index]
                                                                  .total_quantity;
                                                              actualValue =
                                                                multiplyFactor *
                                                                actualFreightValue;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                              setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                            } else {
                                                              actualValue =
                                                                actualFreightValue;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                              setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                            }
                                                          } else if (uomName?.toUpperCase() === "CFT") {
                                                            let tempVolume = 0;
                                                            for (
                                                              let indx = 0;
                                                              indx <
                                                              values.deliveries[index]
                                                                .products.length;
                                                              indx++
                                                            ) {

                                                              if (
                                                                values?.deliveries?.[index]
                                                                  ?.products[indx].length &&
                                                                values?.deliveries?.[index]
                                                                  ?.products[indx]
                                                                  .breadth &&
                                                                values?.deliveries?.[index]
                                                                  ?.products[indx].height
                                                              ) {

                                                                tempVolume =
                                                                  tempVolume +
                                                                  values?.deliveries?.[
                                                                    index
                                                                  ]?.products[indx].length *
                                                                  values?.deliveries?.[
                                                                    index
                                                                  ]?.products[indx]
                                                                    .breadth *
                                                                  values?.deliveries?.[
                                                                    index
                                                                  ]?.products[indx]
                                                                    .height;
                                                              }
                                                            }
                                                            if (
                                                              values?.deliveries?.[index]
                                                                ?.total_quantity
                                                            ) {
                                                              multiplyFactor =
                                                                values.deliveries[index]
                                                                  .total_quantity *
                                                                tempVolume;
                                                              actualValue =
                                                                multiplyFactor *
                                                                actualFreightValue;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                              setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                            } else {
                                                              actualValue =
                                                                actualFreightValue;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                              setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                            }
                                                          }
                                                        }
                                                      }}
                                                    /> :
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >{
                                                        values?.deliveries[
                                                          index
                                                        ]?.uom}
                                                    </Header>
                                                }
                                              </Table.Cell>
                                              {values?.deliveries?.[index]
                                                ?.uom_name && values?.deliveries?.[index]
                                                ?.uom_name.toUpperCase()  === "PER CFT KG" ? (
                                                <>
                                                  <Table.Cell colSpan="1">
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      {t("cft_factor") ||
                                                        "CFT KG Factor"}
                                                    </Header>
                                                  </Table.Cell>
                                                  <Table.Cell colSpan="2">
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      <>
                                                        {editFreightRate == false ? (
                                                          <>
                                                            {values?.deliveries?.[index]?.cft_kg_factor
                                                              ? values.deliveries[index].cft_kg_factor
                                                              : 'NA'}
                                                          </>) : (
                                                          <Input
                                                            type="number"
                                                            name={`deliveries[${index}].cft_kg_factor`}
                                                            disabled={editFreightRate
                                                              ? false : true}
                                                            value={values.deliveries[index].cft_kg_factor}
                                                            onChange={(event) => {
                                                              setFieldValue(
                                                                `deliveries[${index}].cft_kg_factor`,
                                                                event.target.value
                                                              );


                                                              if (values?.deliveries?.[index]?.uom_name && values?.deliveries?.[index]?.uom_name.toUpperCase() == "PER CFT KG"
                                                              ) {
                                                                let multiplyFactor = 0, actualValue = 0;
                                                                let tempVolume = 0;
                                                                let actualFreightValue =
                                                                  values?.deliveries?.[index]?.actual_freight_rate;

                                                                for (
                                                                  let indx = 0; indx < values.deliveries[index].products.length; indx++
                                                                ) {
                                                                  if (
                                                                    values?.deliveries?.[index]?.products[indx].quantity &&
                                                                    values?.deliveries?.[index]?.products[indx].length &&
                                                                    values?.deliveries?.[index]?.products[indx].breadth &&
                                                                    values?.deliveries?.[index]?.products[indx].height
                                                                  ) {
                                                                    tempVolume = tempVolume +
                                                                      values.deliveries[index].products[indx].quantity *
                                                                      values.deliveries[index].products[indx].length *
                                                                      values.deliveries[index].products[indx].breadth *
                                                                      values?.deliveries[index].products[indx].height;
                                                                  }
                                                                }

                                                                if (
                                                                  values?.deliveries?.[index]?.uom_name && values?.deliveries?.[index]?.uom_name.toUpperCase() == "PER CFT KG" &&
                                                                  event.target.value > 0
                                                                ) {
                                                                  multiplyFactor = tempVolume * +event.target.value;
                                                                  setFieldValue(`deliveries[${index}].charged_weight`, multiplyFactor);
                                                                } else {
                                                                  multiplyFactor = tempVolume;
                                                                }

                                                                actualValue = multiplyFactor * actualFreightValue;
                                                                setFieldValue(`deliveries[${index}].final_freight_rate`, actualValue);
                                                                setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + actualValue)
                                                              }
                                                            }}
                                                          />
                                                        )}
                                                      </>
                                                    </Header>
                                                  </Table.Cell>
                                                  <Table.Cell colSpan="2"></Table.Cell>
                                                </>
                                              ) : null}
                                            </>
                                          </Table.Row>
                                          <Table.Row>
                                            <>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {t("actual_freight_rate") ||
                                                    "Actual Freight Rate"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                {
                                                  LOCAL_STORAGE.freightDetail == '0' ?
                                                    <Input
                                                      disabled={
                                                        !editFreightRate ? true : false
                                                      }
                                                      style={{
                                                        opacity: "1",
                                                      }}
                                                      type="number"
                                                      name={`deliveries[${index}].actual_freight_rate`}
                                                      onChange={(name, data) => {
                                                        let actualValue = 0;
                                                        setFieldValue(
                                                          `deliveries[${index}].actual_freight_rate`,
                                                          data.value
                                                        );
                                                        if (
                                                          values?.deliveries?.[index]?.uom && values?.deliveries?.[index]?.uom_name
                                                        ) {
                                                          if (
                                                            values.deliveries[index].uom_name.toUpperCase() ===
                                                            "TRIP"
                                                          ) {
                                                            actualValue = data.value;
                                                          } else if (
                                                            values.deliveries[index].uom_name.toUpperCase() ===
                                                            "KG"
                                                          ) {
                                                            let multiplyFactor;
                                                            if (
                                                              values?.deliveries?.[index]
                                                                ?.charged_weight
                                                            ) {
                                                              multiplyFactor = FEATURES.weightInTonCustomers ? Number(values.deliveries[index].charged_weight) * 1000 : Number(values.deliveries[index].charged_weight);
                                                              actualValue =
                                                                multiplyFactor * data.value;
                                                            } else {
                                                              actualValue = data.value;
                                                            }
                                                          } else if (
                                                            values.deliveries[index].uom_name.toUpperCase() ===
                                                            "TON"
                                                          ) {
                                                            let multiplyFactor;
                                                            if (
                                                              values?.deliveries?.[index]
                                                                ?.charged_weight
                                                            ) {
                                                              multiplyFactor = FEATURES.weightInTonCustomers ? Number(values.deliveries[index].charged_weight) : Number(values.deliveries[index].charged_weight) / 1000;
                                                              actualValue =
                                                                multiplyFactor * data.value;
                                                            } else {
                                                              actualValue =
                                                                data.value / 1000;
                                                            }
                                                          }else if (
                                                            values.deliveries[index].uom_name.toUpperCase() ===
                                                            "PER TON PER KM"
                                                          ) {
                                                            let multiplyFactor;
                                                            if (
                                                              values?.deliveries?.[index]
                                                                ?.charged_weight && props?.budgeted_kms
                                                            ) {
                                                              multiplyFactor = FEATURES.weightInTonCustomers ? Number(values.deliveries[index].charged_weight) : Number(values.deliveries[index].charged_weight) / 1000;
                                                              let distance = Number(props?.budgeted_kms.replace(' Kms', ''));
                                                              actualValue =
                                                                multiplyFactor * data.value * distance;
                                                            } else {
                                                              actualValue = data.value;
                                                            }
                                                          } else if (
                                                            values.deliveries[index].uom_name.toUpperCase() ===
                                                            "KM"
                                                          ) {
                                                            let multiplyFactor;
                                                            if (props?.budgeted_kms) {
                                                              multiplyFactor =
                                                                Number(props?.budgeted_kms.replace(' Kms', ''));
                                                              actualValue =
                                                                multiplyFactor * data.value;
                                                            } else {
                                                              actualValue = data.value;
                                                            }
                                                          } else if (
                                                            values.deliveries[index].uom_name.toUpperCase() ===
                                                            "PER CASE"
                                                          ) {
                                                            let multiplyFactor;
                                                            if (
                                                              values?.deliveries?.[index]
                                                                ?.total_quantity
                                                            ) {
                                                              multiplyFactor =
                                                                values.deliveries[index]
                                                                  .total_quantity;
                                                              actualValue =
                                                                multiplyFactor * data.value;
                                                            } else {
                                                              actualValue = data.value;
                                                            }
                                                          } else if (
                                                            values.deliveries[index].uom_name.toUpperCase() ===
                                                            "CFT"
                                                          ) {
                                                            let multiplyFactor;
                                                            let tempVolume = 0;
                                                            for (
                                                              let indx = 0;
                                                              indx <
                                                              values.deliveries[index]
                                                                .products.length;
                                                              indx++
                                                            ) {
                                                              if (
                                                                values?.deliveries?.[index]
                                                                  ?.products[indx].length &&
                                                                values?.deliveries?.[index]
                                                                  ?.products[indx]
                                                                  .breadth &&
                                                                values?.deliveries?.[index]
                                                                  ?.products[indx].height
                                                              ) {
                                                                tempVolume =
                                                                  tempVolume +
                                                                  values?.deliveries?.[
                                                                    index
                                                                  ]?.products[indx].length *
                                                                  values?.deliveries?.[
                                                                    index
                                                                  ]?.products[indx]
                                                                    .breadth *
                                                                  values?.deliveries?.[
                                                                    index
                                                                  ]?.products[indx]
                                                                    .height;
                                                              }
                                                            }
                                                            if (
                                                              values?.deliveries?.[index]
                                                                ?.total_quantity
                                                            ) {
                                                              multiplyFactor =
                                                                values.deliveries[index]
                                                                  .total_quantity *
                                                                tempVolume;
                                                              actualValue =
                                                                multiplyFactor * data.value;
                                                            } else {
                                                              actualValue = data.value;
                                                            }
                                                          }
                                                        }
                                                        setFieldValue(
                                                          `deliveries[${index}].final_freight_rate`,
                                                          actualValue
                                                        );
                                                        setFieldValue(`deliveries[${index}].final_rate`, +values.deliveries[index].charges + +actualValue);
                                                      }}
                                                      value={
                                                        values.deliveries[index]
                                                          .actual_freight_rate
                                                      }
                                                    /> :
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >

                                                      <>
                                                        {values?.deliveries?.[
                                                          index
                                                        ]?.actual_freight_rate
                                                          ? values.deliveries[
                                                            index
                                                          ].actual_freight_rate
                                                          : 0}
                                                      </>

                                                    </Header>
                                                }
                                              </Table.Cell>
                                            </>
                                            <>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {t("final_freight_rate") ||
                                                    "Final Freight Rate"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                {
                                                  LOCAL_STORAGE.freightDetail == '0' ?
                                                    <Input
                                                      disabled={
                                                        !editFreightRate ? true : false
                                                      }
                                                      style={{
                                                        opacity: "1",
                                                      }}
                                                      type="number"
                                                      name={`deliveries[${index}].final_freight_rate`}
                                                      //disabled={true}
                                                      readonly
                                                      /* onChange={(name, data) => {
                                                        setFieldValue(`deliveries[${index}].final_freight_rate`, data.value);
                                                        setFieldValue(`deliveries[${index}].actual_freight_rate`, data.value);
                                                      }} */
                                                      value={
                                                        values.deliveries[index].final_freight_rate
                                                      }
                                                    /> :
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      <>
                                                        {values?.deliveries?.[
                                                          index
                                                        ]?.final_freight_rate
                                                          ? values.deliveries[
                                                            index
                                                          ].final_freight_rate
                                                          : 0}
                                                      </>
                                                    </Header>
                                                }
                                              </Table.Cell>
                                              <Table.Cell colSpan="2"></Table.Cell>
                                            </>
                                          </Table.Row>
                                        </>
                                        {LOCAL_STORAGE.freightDetail == '0' ? (
                                          <>
                                            {
                                              !editFreightRate ?
                                                <Table.Row className="mb-4 mt-4">
                                                  <div className="col-md-12">
                                                    <TableB size="sm" className="ui unstackable table" >
                                                      <thead>
                                                        {values?.deliveries?.[index]
                                                          ?.lr_other_charges && (
                                                            <tr className="tr-heading">
                                                              <td> Other Charges</td>
                                                              <td>Amount</td>
                                                            </tr>
                                                          )}
                                                      </thead>
                                                      <tbody>
                                                        <>
                                                          {
                                                            values.deliveries[
                                                              index
                                                            ].lr_other_charges.map(
                                                              (
                                                                object,
                                                                ind,
                                                                key
                                                              ) => {

                                                                return (
                                                                  <>
                                                                    <tr
                                                                      key={index}
                                                                    >
                                                                      <td
                                                                        style={{
                                                                          width:
                                                                            "25%",
                                                                        }}
                                                                      >
                                                                        <Field
                                                                          size="mini"
                                                                          disabled={true}
                                                                          className="labelName"
                                                                          name={`deliveries[${index}].lr_other_charges[${ind}].psId`}
                                                                          placeholder={
                                                                            values
                                                                              .deliveries[
                                                                              index
                                                                            ]
                                                                              .lr_other_charges[
                                                                              ind
                                                                            ]
                                                                              .charge_type_desc
                                                                          }
                                                                          component={
                                                                            MyPSLineItem
                                                                          }
                                                                          advanceType="Vendor"
                                                                          id={`deliveries[${index}].lr_other_charges[${ind}].charge_type_id`}
                                                                        />
                                                                        <ErrorMessage
                                                                          name={`deliveries[${index}].lr_other_charges[${ind}].charge_type_id`}
                                                                        />
                                                                      </td>
                                                                      <td
                                                                        style={{
                                                                          width:
                                                                            "25%",
                                                                        }}
                                                                      >
                                                                        <Field
                                                                          size="big"
                                                                          disabled={true}
                                                                          component={
                                                                            MyNormalInput
                                                                          }
                                                                          placeholder={
                                                                            values
                                                                              .deliveries[
                                                                              index
                                                                            ]
                                                                              .lr_other_charges[
                                                                              ind
                                                                            ]
                                                                              .charges
                                                                          }
                                                                          name={`deliveries[${index}].lr_other_charges[${ind}].charges`}
                                                                        />
                                                                        <ErrorMessage
                                                                          name={`deliveries[${index}].lr_other_charges[${ind}].charges`}
                                                                        />
                                                                      </td>
                                                                    </tr>
                                                                  </>
                                                                );
                                                              }
                                                            )}
                                                          {values?.deliveries?.[
                                                            index
                                                          ]
                                                            ?.lr_other_charges && (
                                                              <tr>
                                                                <td>Total</td>
                                                                <td>
                                                                  {
                                                                    values?.deliveries?.[index]?.lr_other_charges.reduce((accumulator, object) => {
                                                                      return accumulator + +object.charges;
                                                                    }, 0)
                                                                  }
                                                                </td>
                                                              </tr>
                                                            )}
                                                        </>

                                                      </tbody>

                                                    </TableB>

                                                    <FormUi.Field className="m-0 mb-2">
                                                      <label className="labelName">
                                                        {"Final Rate"}{" "}
                                                      </label>
                                                    </FormUi.Field>
                                                    <FormUi.Field className="m-0 mb-2">
                                                      {
                                                        LOCAL_STORAGE.freightDetail == '0' ?
                                                          <Input
                                                            type="number"
                                                            name={`deliveries[${index}].final_rate`}
                                                            disabled={!editFreightRate ? true : false}
                                                            readonly
                                                            value={
                                                              values?.deliveries?.[index]?.lr_other_charges.reduce((accumulator, object) => {
                                                                return accumulator + +object.charges;
                                                              }, 0) + +values?.deliveries?.[index]?.final_freight_rate
                                                            }
                                                          /> : <Header
                                                            className="p-bold-500 labelName"
                                                            size="tiny"
                                                            as="label"
                                                            color="grey">
                                                            {
                                                              values?.deliveries?.[index]?.final_rate
                                                            }
                                                          </Header>
                                                      }

                                                    </FormUi.Field>
                                                  </div>
                                                </Table.Row>
                                                : <Table.Row className="mb-4 mt-4">
                                                  <div className="col-md-12">
                                                    <TableB
                                                      size="sm"
                                                      className="ui unstackable table"
                                                    >
                                                      <thead>
                                                        {values?.deliveries?.[index]
                                                          ?.lr_other_charges && (
                                                            <tr className="tr-heading">
                                                              <td> Other Charges</td>
                                                              <td>Amount</td>
                                                            </tr>
                                                          )}
                                                      </thead>
                                                      <tbody>
                                                        <FieldArray
                                                          name={`deliveries[${index}].lr_other_charges`}
                                                          render={(arrayHelpers) => {
                                                            values.deliveries[
                                                              index
                                                            ].charges = 0;
                                                            return (
                                                              <>
                                                                {values?.deliveries?.[
                                                                  index
                                                                ]?.lr_other_charges &&
                                                                  values.deliveries[
                                                                    index
                                                                  ].lr_other_charges.map(
                                                                    (
                                                                      object,
                                                                      ind,
                                                                      key
                                                                    ) => {
                                                                      values.deliveries[
                                                                        index
                                                                      ].charges +=
                                                                        +object.charges;
                                                                      return (
                                                                        <>
                                                                          <tr
                                                                            key={index}
                                                                          >
                                                                            <td
                                                                              style={{
                                                                                width:
                                                                                  "25%",
                                                                              }}
                                                                            >
                                                                              <Field
                                                                                size="mini"
                                                                                className="labelName"
                                                                                name={`deliveries[${index}].lr_other_charges[${ind}].psId`}
                                                                                advanceMode={
                                                                                  true
                                                                                }
                                                                                placeholder={
                                                                                  values
                                                                                    .deliveries[
                                                                                    index
                                                                                  ]
                                                                                    .lr_other_charges[
                                                                                    ind
                                                                                  ]
                                                                                    .charge_type_desc
                                                                                }
                                                                                component={
                                                                                  MyPSLineItem
                                                                                }
                                                                                advanceType="Vendor"
                                                                                id={`deliveries[${index}].lr_other_charges[${ind}].charge_type_id`}
                                                                              />
                                                                              <ErrorMessage
                                                                                name={`deliveries[${index}].lr_other_charges[${ind}].charge_type_id`}
                                                                              />
                                                                            </td>
                                                                            <td
                                                                              style={{
                                                                                width:
                                                                                  "25%",
                                                                              }}
                                                                            >
                                                                              <Field
                                                                                size="big"
                                                                                component={
                                                                                  MyNormalInput
                                                                                }
                                                                                placeholder={
                                                                                  values
                                                                                    .deliveries[
                                                                                    index
                                                                                  ]
                                                                                    .lr_other_charges[
                                                                                    ind
                                                                                  ]
                                                                                    .charges
                                                                                }
                                                                                name={`deliveries[${index}].lr_other_charges[${ind}].charges`}
                                                                                onBlur={() => {
                                                                                  if (
                                                                                    values
                                                                                      .deliveries[
                                                                                      index
                                                                                    ]
                                                                                      .charges
                                                                                  ) {
                                                                                    setFieldValue(
                                                                                      `deliveries[${index}].final_rate`,
                                                                                      Number(
                                                                                        values
                                                                                          .deliveries[
                                                                                          index
                                                                                        ]
                                                                                          .final_freight_rate
                                                                                      ) +
                                                                                      values
                                                                                        .deliveries[
                                                                                        index
                                                                                      ]
                                                                                        .charges
                                                                                    );
                                                                                  }
                                                                                }}
                                                                              />
                                                                              <ErrorMessage
                                                                                name={`deliveries[${index}].lr_other_charges[${ind}].charges`}
                                                                              />
                                                                            </td>
                                                                            <td>
                                                                              <Button
                                                                                basic
                                                                                color="red"
                                                                                type="button"
                                                                                id={
                                                                                  ind
                                                                                }
                                                                                onClick={(
                                                                                  e
                                                                                ) => {
                                                                                  object.is_deleted = 1;
                                                                                  deletedOtherCharges.push(
                                                                                    object
                                                                                  );
                                                                                  setFieldValue(
                                                                                    `deliveries[${index}].final_rate`,
                                                                                    Number(
                                                                                      values
                                                                                        .deliveries[
                                                                                        index
                                                                                      ]
                                                                                        .final_rate
                                                                                    ) -
                                                                                    +object.charges
                                                                                  );
                                                                                  arrayHelpers.remove(
                                                                                    ind
                                                                                  );
                                                                                }}
                                                                                size="mini"
                                                                              >
                                                                                <i className="fa fa-trash" color="red"></i>
                                                                              </Button>
                                                                            </td>
                                                                          </tr>
                                                                        </>
                                                                      );
                                                                    }
                                                                  )}
                                                                {values?.deliveries?.[
                                                                  index
                                                                ]
                                                                  ?.lr_other_charges && (
                                                                    <tr>
                                                                      <td>Total</td>
                                                                      <td>
                                                                        {
                                                                          values
                                                                            .deliveries[
                                                                            index
                                                                          ].charges
                                                                        }
                                                                      </td>
                                                                    </tr>
                                                                  )}
                                                                <Button
                                                                  basic
                                                                  color="blue"
                                                                  className="m-2"
                                                                  type="button"
                                                                  size="mini"
                                                                  onClick={() =>
                                                                    arrayHelpers.push(
                                                                      {
                                                                        charge_type_id:
                                                                          "",
                                                                        charges: "",
                                                                      }
                                                                    )
                                                                  }
                                                                >
                                                                  + Add More Expense
                                                                </Button>
                                                              </>
                                                            );
                                                          }}
                                                        />
                                                      </tbody>
                                                    </TableB>
                                                    <FormUi.Field className="m-0 mb-2">
                                                      <label className="labelName">
                                                        {"Final Rate"}{" "}
                                                      </label>
                                                    </FormUi.Field>
                                                    <FormUi.Field className="m-0 mb-2">
                                                      <Input
                                                        type="number"
                                                        name={`deliveries[${index}].final_rate`}
                                                        disabled={!values.deliveries[index][
                                                          "active"
                                                        ] ? true : false}
                                                        readonly
                                                        value={
                                                          values?.deliveries?.[index]
                                                            ?.final_rate ? values.deliveries[index].final_rate :
                                                            values?.deliveries?.[index]?.lr_other_charges.reduce((accumulator, object) => {
                                                              return accumulator + +object.charges;
                                                            }, 0) + +values?.deliveries?.[index]?.final_freight_rate
                                                        }
                                                      />
                                                    </FormUi.Field>
                                                  </div>
                                                </Table.Row>
                                            }

                                          </>
                                        ) : (
                                          <Table.Row className="mb-4 mt-4">
                                            <div className="col-md-12">
                                              <TableB
                                                size="sm"
                                                className="ui unstackable table"
                                              >
                                                <thead>
                                                  {values?.deliveries?.[index]
                                                    ?.lr_other_charges && (
                                                      <tr className="tr-heading">
                                                        <td> Other Charges</td>
                                                        <td>Amount</td>
                                                      </tr>
                                                    )}
                                                </thead>
                                                <tbody>
                                                  <FieldArray
                                                    name={`deliveries[${index}].lr_other_charges`}
                                                    render={(arrayHelpers) => {
                                                      values.deliveries[
                                                        index
                                                      ].charges = 0;
                                                      return (
                                                        <>
                                                          {values?.deliveries?.[
                                                            index
                                                          ]?.lr_other_charges &&
                                                            values.deliveries[
                                                              index
                                                            ].lr_other_charges.map(
                                                              (
                                                                object,
                                                                ind,
                                                                key
                                                              ) => {
                                                                values.deliveries[
                                                                  index
                                                                ].charges +=
                                                                  +object.charges;
                                                                return (
                                                                  <>
                                                                    <tr
                                                                      key={index}
                                                                    >
                                                                      <td
                                                                        style={{
                                                                          width:
                                                                            "25%",
                                                                        }}
                                                                      >
                                                                        <Field
                                                                          size="mini"
                                                                          className="labelName"
                                                                          name={`deliveries[${index}].lr_other_charges[${ind}].psId`}
                                                                          advanceMode={
                                                                            true
                                                                          }
                                                                          placeholder={
                                                                            values
                                                                              .deliveries[
                                                                              index
                                                                            ]
                                                                              .lr_other_charges[
                                                                              ind
                                                                            ]
                                                                              .charge_type_desc
                                                                          }
                                                                          component={
                                                                            MyPSLineItem
                                                                          }
                                                                          advanceType="Vendor"
                                                                          id={`deliveries[${index}].lr_other_charges[${ind}].charge_type_id`}
                                                                        />
                                                                        <ErrorMessage
                                                                          name={`deliveries[${index}].lr_other_charges[${ind}].charge_type_id`}
                                                                        />
                                                                      </td>
                                                                      <td
                                                                        style={{
                                                                          width:
                                                                            "25%",
                                                                        }}
                                                                      >
                                                                        <Field
                                                                          size="big"
                                                                          component={
                                                                            MyNormalInput
                                                                          }
                                                                          placeholder={
                                                                            values
                                                                              .deliveries[
                                                                              index
                                                                            ]
                                                                              .lr_other_charges[
                                                                              ind
                                                                            ]
                                                                              .charges
                                                                          }
                                                                          name={`deliveries[${index}].lr_other_charges[${ind}].charges`}
                                                                          onBlur={() => {
                                                                            if (
                                                                              values
                                                                                .deliveries[
                                                                                index
                                                                              ]
                                                                                .charges
                                                                            ) {
                                                                              setFieldValue(
                                                                                `deliveries[${index}].final_rate`,
                                                                                Number(
                                                                                  values
                                                                                    .deliveries[
                                                                                    index
                                                                                  ]
                                                                                    .final_freight_rate
                                                                                ) +
                                                                                values
                                                                                  .deliveries[
                                                                                  index
                                                                                ]
                                                                                  .charges
                                                                              );
                                                                            }
                                                                          }}
                                                                        />
                                                                        <ErrorMessage
                                                                          name={`deliveries[${index}].lr_other_charges[${ind}].charges`}
                                                                        />
                                                                      </td>
                                                                      <td>
                                                                        <Button
                                                                          basic
                                                                          color="red"
                                                                          type="button"
                                                                          id={
                                                                            ind
                                                                          }
                                                                          onClick={(
                                                                            e
                                                                          ) => {
                                                                            object.is_deleted = 1;
                                                                            deletedOtherCharges.push(
                                                                              object
                                                                            );
                                                                            setFieldValue(
                                                                              `deliveries[${index}].final_rate`,
                                                                              Number(
                                                                                values
                                                                                  .deliveries[
                                                                                  index
                                                                                ]
                                                                                  .final_rate
                                                                              ) -
                                                                              +object.charges
                                                                            );
                                                                            arrayHelpers.remove(
                                                                              ind
                                                                            );
                                                                          }}
                                                                          size="mini"
                                                                        >
                                                                          <i className="fa fa-trash" color="red"></i>
                                                                        </Button>
                                                                      </td>
                                                                    </tr>
                                                                  </>
                                                                );
                                                              }
                                                            )}
                                                          {values?.deliveries?.[
                                                            index
                                                          ]
                                                            ?.lr_other_charges && (
                                                              <tr>
                                                                <td>Total</td>
                                                                <td>
                                                                  {
                                                                    values
                                                                      .deliveries[
                                                                      index
                                                                    ].charges
                                                                  }
                                                                </td>
                                                              </tr>
                                                            )}
                                                          <Button
                                                            basic
                                                            color="blue"
                                                            className="m-2"
                                                            type="button"
                                                            size="mini"
                                                            onClick={() =>
                                                              arrayHelpers.push(
                                                                {
                                                                  charge_type_id:
                                                                    "",
                                                                  charges: "",
                                                                }
                                                              )
                                                            }
                                                          >
                                                            + Add More Expense
                                                          </Button>
                                                        </>
                                                      );
                                                    }}
                                                  />
                                                </tbody>
                                              </TableB>
                                              <FormUi.Field className="m-0 mb-2">
                                                <label className="labelName">
                                                  {"Final Rate"}{" "}
                                                </label>
                                              </FormUi.Field>
                                              <FormUi.Field className="m-0 mb-2">
                                                <Input
                                                  type="number"
                                                  name={`deliveries[${index}].final_rate`}
                                                  disabled={!values.deliveries[index][
                                                    "active"
                                                  ] ? true : false}
                                                  readonly
                                                  value={
                                                    values?.deliveries?.[index]
                                                      ?.final_rate ? values.deliveries[index].final_rate :
                                                      values?.deliveries?.[index]?.lr_other_charges.reduce((accumulator, object) => {
                                                        return accumulator + +object.charges;
                                                      }, 0) + +values?.deliveries?.[index]?.final_freight_rate
                                                  }
                                                />
                                              </FormUi.Field>
                                            </div>
                                          </Table.Row>
                                        )}

                                        <Table.Row className="hide-section">

                                          <div style={partyOrderDetailsAccess}>
                                            <Table.Cell colSpan="2">
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {t("billing_party") ||
                                                  "Billing Party"}
                                              </Header>
                                            </Table.Cell>
                                            <Table.Cell colSpan="2">
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {!values.deliveries[index][
                                                  "active"
                                                ] ? (
                                                  <>
                                                    {values.deliveries[index]
                                                      .billing_party_name
                                                      ? values.deliveries[
                                                        index
                                                      ].billing_party_name
                                                      : "NA"}
                                                  </>
                                                ) : (
                                                  <Field
                                                    name={`deliveries[${index}].billing_party_id`}
                                                    defaultValue={
                                                      values.deliveries[index]
                                                        .billing_party_id
                                                    }
                                                    placeholder={
                                                      values.deliveries[index]
                                                        .billing_party_id
                                                        ? values.deliveries[
                                                          index
                                                        ].billing_party_name
                                                        : props.t(
                                                          "billing_party"
                                                        ) || "Billing Party"
                                                    }
                                                    component={
                                                      MyBillingPartyComponent
                                                    }
                                                    getBillingPartySelected={
                                                      getBillingPartySelected
                                                    }
                                                    onChange={(
                                                      name,
                                                      data
                                                    ) => {
                                                      setFieldValue(
                                                        `deliveries[${index}].billing_party_id`,
                                                        +data.value
                                                      );
                                                      checkBillingParty(
                                                        name,
                                                        data
                                                      );
                                                    }}
                                                    orderModal={true}
                                                  />
                                                )}
                                              </Header>
                                            </Table.Cell>
                                          </div>


                                          <div style={partyOrderDetailsAccess}>
                                            <Table.Cell colSpan="2" >
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {t("billing_pary_branch") ||
                                                  "Billing Party Branch"}
                                              </Header>
                                            </Table.Cell>
                                            <Table.Cell colSpan="2">
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {!values.deliveries[index][
                                                  "active"
                                                ] ? (
                                                  <>
                                                    {values.deliveries[index]
                                                      .billing_party_branch_name
                                                      ? values.deliveries[
                                                        index
                                                      ]
                                                        .billing_party_branch_name
                                                      : "NA"}
                                                  </>
                                                ) : (
                                                  <Dropdown
                                                    name={`deliveries[${index}].billing_party_branch_id`}
                                                    placeholder={
                                                      values.deliveries[index]
                                                        .billing_party_branch_id
                                                        ? values.deliveries[
                                                          index
                                                        ]
                                                          .billing_party_branch_name
                                                        : props.t(
                                                          "billing_party_branch"
                                                        ) ||
                                                        "Billing Party Branch"
                                                    }
                                                    clearable
                                                    style={{ width: "100%" }}
                                                    selection
                                                    search
                                                    onChange={(
                                                      name,
                                                      data
                                                    ) => {
                                                      setFieldValue(
                                                        `deliveries[${index}].billing_party_branch_id`,
                                                        +data.value
                                                      );
                                                      getConsigneeConsignorArray(
                                                        values.deliveries[
                                                          index
                                                        ].billing_party_id,
                                                        +data.value
                                                      );
                                                    }}
                                                    // value={values.deliveries[index].billing_party_branch_id}
                                                    options={
                                                      billingpartybranch
                                                    }
                                                  />
                                                )}
                                              </Header>
                                            </Table.Cell>
                                          </div>

                                          <div style={partyOrderDetailsAccess}>
                                            <Table.Cell>
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {t("customer_type") ||
                                                  "Customer Type"}
                                              </Header>
                                            </Table.Cell>
                                            <Table.Cell>
                                              <Header
                                                className="p-bold-500 labelName"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {!values.deliveries[index][
                                                  "active"
                                                ] ? (
                                                  <>
                                                    {values.deliveries[index]
                                                      .customer_type_name
                                                      ? values.deliveries[
                                                        index
                                                      ].customer_type_name
                                                      : "NA"}
                                                  </>
                                                ) : (
                                                  <Dropdown
                                                    clearable
                                                    style={{
                                                      width: "100%",
                                                      fontWeight: "normal",
                                                    }}
                                                    search
                                                    selection
                                                    name={`deliveries[${index}].customer_type_name`}
                                                    placeholder={
                                                      values?.deliveries?.[index]
                                                        ?.customer_type_name ? values.deliveries[index]
                                                        .customer_type_name :
                                                        props.t(
                                                          "delivery_form.customer_type.placeholder"
                                                        ) || "Customer Type"
                                                    }
                                                    value={
                                                      values.deliveries[index]
                                                        .customer_type_id
                                                    }
                                                    onChange={(name, data) => {
                                                      if (data?.value) {
                                                        setFieldValue(
                                                          `deliveries[${index}].customer_type_id`,
                                                          data.value
                                                        )
                                                      } else {
                                                        setFieldValue(
                                                          `deliveries[${index}].customer_type_name`,
                                                          null
                                                        )
                                                      }
                                                    }}
                                                    options={customertype}
                                                  />
                                                )}
                                              </Header>
                                            </Table.Cell>
                                          </div>
                                        </Table.Row>
                                        <Table.Row className="hide-section" style={deliverAccess}>
                                          <Table.Cell colSpan="2">
                                            <Header
                                              className="p-bold-500 labelName"
                                              size="tiny"
                                              as="label"
                                              color="grey"
                                            >
                                              {t("deliver_to") ||
                                                "Deliver To"}
                                            </Header>
                                          </Table.Cell>
                                          <Table.Cell colSpan="2" style={deliverAccess}>
                                            <div className="display-flex-center">
                                              <Header
                                                className="p-bold-500 labelName margin-0"
                                                size="tiny"
                                                as="label"
                                                color="grey"
                                              >
                                                {!values.deliveries[index][
                                                  "active"
                                                ] &&
                                                  !(
                                                    orderEditModeAftrAllotDeliverTo &&
                                                    props.edit &&
                                                    ((props?.currenOrder
                                                      ?.allotment_status &&
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "ALLOC") ||
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "CANCEL" ||
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "COMPLETE")
                                                  ) ? (
                                                  <>
                                                    {values.deliveries[index]
                                                      .deliver_to
                                                      ? values.deliveries[
                                                        index
                                                      ].deliver_to
                                                      : "NA"}

                                                    {props.edit &&
                                                      ((props?.currenOrder
                                                        ?.allotment_status &&
                                                        props?.currenOrder
                                                          ?.allotment_status
                                                          ?.allotment_code ==
                                                        "ALLOC") ||
                                                        props?.currenOrder
                                                          ?.allotment_status
                                                          ?.allotment_code ==
                                                        "CANCEL" ||
                                                        props?.currenOrder
                                                          ?.allotment_status
                                                          ?.allotment_code ==
                                                        "COMPLETE") ? (
                                                      <>
                                                        <Button
                                                          className="margin-left-20"
                                                          color="green"
                                                          disabled={
                                                            props.role ==
                                                              "Quality Control"
                                                              ? true
                                                              : false
                                                          }
                                                          type="button"
                                                          onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setOrderEditModeAftrAllotDeliverTo(
                                                              true
                                                            );
                                                          }}
                                                          basic
                                                          size="mini"
                                                          icon
                                                        >
                                                          <Icon name="edit outline" />
                                                        </Button>
                                                      </>
                                                    ) : null}
                                                  </>
                                                ) : (
                                                  <>
                                                    <Dropdown
                                                      name={`deliveries[${index}].deliver_to`}
                                                      clearable
                                                      style={{
                                                        width: "100%",
                                                        fontWeight: "normal",
                                                      }}
                                                      selection
                                                      placeholder={
                                                        t("deliver_to") ||
                                                        "Deliver To"
                                                      }
                                                      onChange={(
                                                        name,
                                                        data
                                                      ) => {
                                                        setFieldValue(
                                                          `deliveries[${index}].deliver_to`,
                                                          data.value
                                                        );
                                                        if (
                                                          data.value ==
                                                          "consignee"
                                                        ) {
                                                          setFieldValue(
                                                            `deliveries[${index}].deliver_to_address`,
                                                            getCurrentOrderDetails
                                                              ?.deliveries?.[
                                                              index
                                                            ]?.consignee
                                                              .consignee_address
                                                          );
                                                        } else {
                                                          setFieldValue(
                                                            `deliveries[${index}].deliver_to_address`,
                                                            getCurrentOrderDetails
                                                              ?.deliveries?.[
                                                              index
                                                            ]
                                                              ?.deliver_to_address
                                                              ? getCurrentOrderDetails
                                                                .deliveries[
                                                                index
                                                              ]
                                                                .deliver_to_address
                                                              : null
                                                          );
                                                        }
                                                      }}
                                                      options={[
                                                        {
                                                          key: "1",
                                                          text: "Consignee",
                                                          value: "consignee",
                                                        },
                                                        {
                                                          key: "2",
                                                          text: "Branch",
                                                          value: "branch",
                                                        },
                                                        {
                                                          key: "3",
                                                          text: "Other",
                                                          value: "other",
                                                        },
                                                      ]}
                                                      value={
                                                        values.deliveries[
                                                          index
                                                        ].deliver_to
                                                          ? values.deliveries[
                                                            index
                                                          ].deliver_to
                                                          : null
                                                      }
                                                    />
                                                  </>
                                                )}
                                              </Header>
                                              <Header className="margin-0">
                                                {!values.deliveries[index][
                                                  "active"
                                                ] &&
                                                  !(
                                                    orderEditModeAftrAllotDeliverTo &&
                                                    props.edit &&
                                                    ((props?.currenOrder
                                                      ?.allotment_status &&
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "ALLOC") ||
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "CANCEL" ||
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "COMPLETE")
                                                  ) ? null : (
                                                  <>
                                                    {!values.deliveries[
                                                      index
                                                    ]["active"] ||
                                                      (orderEditModeAftrAllotDeliverTo &&
                                                        props.edit &&
                                                        ((props?.currenOrder
                                                          ?.allotment_status &&
                                                          props?.currenOrder
                                                            ?.allotment_status
                                                            ?.allotment_code ==
                                                          "ALLOC") ||
                                                          props?.currenOrder
                                                            ?.allotment_status
                                                            ?.allotment_code ==
                                                          "CANCEL" ||
                                                          props?.currenOrder
                                                            ?.allotment_status
                                                            ?.allotment_code ==
                                                          "COMPLETE")) ? (
                                                      <>
                                                        <div className="order-edit-mode-allot display-flex-center-justify-spacearnd">
                                                          <Button
                                                            color="blue"
                                                            className="box-shadow-none"
                                                            disabled={
                                                              props.role ==
                                                                "Quality Control"
                                                                ? true
                                                                : false
                                                            }
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              setUpdateDeliveryLocation(
                                                                true
                                                              );
                                                            }}
                                                            type="submit"
                                                            basic
                                                            size="mini"
                                                            icon
                                                          >
                                                            <Icon
                                                              name="save"
                                                              style={{
                                                                fontSize:
                                                                  "20px",
                                                              }}
                                                            />
                                                          </Button>
                                                          <Button
                                                            color="blue"
                                                            className="order-edit-mode-allot"
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                                /*cancelOrderUpdate();*/ setUpdateDeliveryLocation(
                                                                true
                                                              );
                                                              setOrderEditModeAftrAllotDeliverTo(
                                                                false
                                                              );
                                                            }}
                                                            basic
                                                            size="mini"
                                                            icon
                                                          >
                                                            <Icon
                                                              name="times"
                                                              style={{
                                                                fontSize:
                                                                  "20px",
                                                              }}
                                                            />
                                                          </Button>
                                                        </div>
                                                      </>
                                                    ) : null}
                                                  </>
                                                )}
                                              </Header>
                                            </div>
                                          </Table.Cell>
                                          {values.deliveries[index]
                                            .deliver_to == "consignee" ? (
                                            <>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {t("deliver_to_address") ||
                                                    "Deliver To Address"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {!values.deliveries[index][
                                                    "active"
                                                  ] ? (
                                                    <>
                                                      {values.deliveries[
                                                        index
                                                      ].deliver_to_address
                                                        ? values.deliveries[
                                                          index
                                                        ].deliver_to_address
                                                        : "NA"}
                                                    </>
                                                  ) : (
                                                    <Field
                                                      component="textarea"
                                                      readOnly
                                                      style={{
                                                        paddingTop: "5.5px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                      type="number"
                                                      rows="2"
                                                      name={`deliveries[${index}].deliver_to_address`}
                                                      values={
                                                        values.deliveries[
                                                          index
                                                        ].deliver_to_address
                                                      }
                                                    />
                                                  )}
                                                </Header>
                                              </Table.Cell>
                                            </>
                                          ) : (
                                            <>
                                              {values.deliveries[index]
                                                .deliver_to == "other" ? (
                                                <>
                                                  <Table.Cell colSpan="2">
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      {t(
                                                        "deliver_to_address"
                                                      ) ||
                                                        "Deliver To Address"}
                                                    </Header>
                                                  </Table.Cell>
                                                  <Table.Cell colSpan="2">
                                                    <Header
                                                      className="p-bold-500 labelName"
                                                      size="tiny"
                                                      as="label"
                                                      color="grey"
                                                    >
                                                      {!values.deliveries[
                                                        index
                                                      ]["active"] ? (
                                                        <>
                                                          {values.deliveries[
                                                            index
                                                          ].deliver_to_address
                                                            ? values
                                                              .deliveries[
                                                              index
                                                            ]
                                                              .deliver_to_address
                                                            : "NA"}
                                                        </>
                                                      ) : (
                                                        <Field
                                                          component="textarea"
                                                          style={{
                                                            paddingTop:
                                                              "5.5px",
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                          type="number"
                                                          rows="2"
                                                          name={`deliveries[${index}].deliver_to_address`}
                                                          values={
                                                            values.deliveries[
                                                              index
                                                            ]
                                                              .deliver_to_address
                                                          }
                                                        />
                                                      )}
                                                    </Header>
                                                  </Table.Cell>
                                                </>
                                              ) : null}
                                            </>
                                          )}
                                          {values.deliveries[index]
                                            .deliver_to == "branch" ? (
                                            <>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {t("deliver_to_address") ||
                                                    "Deliver To Address"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {!values.deliveries[index][
                                                    "active"
                                                  ] ? (
                                                    <>
                                                      {values.deliveries[
                                                        index
                                                      ].deliver_to_address
                                                        ? values.deliveries[
                                                          index
                                                        ].deliver_to_address
                                                        : "NA"}
                                                    </>
                                                  ) : (
                                                    <Dropdown
                                                      name={`deliveries[${index}].deliver_to_address`}
                                                      clearable
                                                      style={{
                                                        width: "100%",
                                                        fontWeight: "normal",
                                                      }}
                                                      selection
                                                      placeholder={
                                                        t(
                                                          "deliver_to_address"
                                                        ) ||
                                                        "Deliver To Address"
                                                      }
                                                      onChange={(
                                                        name,
                                                        data
                                                      ) => {
                                                        setFieldValue(
                                                          `deliveries[${index}].deliver_to_address`,
                                                          data.value
                                                        );
                                                      }}
                                                      options={branchs}
                                                      value={
                                                        values.deliveries[
                                                          index
                                                        ].deliver_to_address
                                                      }
                                                    />
                                                  )}
                                                </Header>
                                              </Table.Cell>
                                            </>
                                          ) : null}
                                        </Table.Row>
                                        {/* <FieldArray
                                          name={`deliveries.[${index}].invoices`}
                                          render={(invoiceDetails) => (
                                            <>
                                              {values.deliveries[
                                                index
                                              ].invoices.map((item, idx) => (
                                                <Table.Row
                                                  key={`invoices+${idx}`}
                                                >
                                                  <Table.Cell colSpan="12">
                                                    <Table>
                                                      <Table.Header>
                                                        <Table.Row>
                                                          <TableHeaderCell colSpan="10">
                                                            {t(
                                                              "invoice_title"
                                                            ) || "Invoice"}{" "}
                                                            {idx + 1}
                                                          </TableHeaderCell>
                                                          <TableHeaderCell
                                                            colSpan="2"
                                                            className="text-right"
                                                          >
                                                            {values
                                                              ?.deliveries?.[
                                                              index
                                                            ]?.invoices?.[idx]
                                                              ?.addNewInvoice ? (
                                                              <>
                                                                <Button
                                                                  basic
                                                                  color="red"
                                                                  type="button"
                                                                  onClick={() =>
                                                                    productDetails.remove(
                                                                      i
                                                                    )
                                                                  }
                                                                  size="mini"
                                                                  icon
                                                                >
                                                                  {" "}
                                                                  <Icon
                                                                    name="trash"
                                                                    color="red"
                                                                  />{" "}
                                                                </Button>
                                                                <Button
                                                                  basic
                                                                  color="green"
                                                                  type="button"
                                                                  onClick={(
                                                                    e
                                                                  ) => {
                                                                    e.stopPropagation();
                                                                    saveAddedInvoice(
                                                                      values
                                                                        .deliveries[
                                                                        index
                                                                      ]
                                                                        .invoices[
                                                                      idx
                                                                      ],
                                                                      values
                                                                        .deliveries[
                                                                        index
                                                                      ]
                                                                        .delivery_id
                                                                    );
                                                                  }}
                                                                  size="mini"
                                                                  icon
                                                                >
                                                                  {" "}
                                                                  <Icon name="save" />{" "}
                                                                </Button>
                                                              </>
                                                            ) : (
                                                              <></>
                                                            )}
                                                          </TableHeaderCell>
                                                        </Table.Row>
                                                      </Table.Header>
                                                      <Table.Body>
                                                        <Grid className="m-2">
                                                          <Grid.Row columns={4} style={orderDetails} >
                                                            <Grid.Column>
                                                              <label>
                                                                {t(
                                                                  "invoice_code"
                                                                ) ||
                                                                  "Invoice Number"}
                                                              </label>
                                                              <br></br>
                                                              {item?.invoice_no &&
                                                                !values
                                                                  ?.deliveries?.[
                                                                  index
                                                                ]?.invoices?.[idx]
                                                                  ?.addNewInvoice ? (
                                                                item.invoice_no
                                                              ) : (
                                                                <>
                                                                  {values
                                                                    ?.deliveries?.[
                                                                    index
                                                                  ]?.invoices?.[
                                                                    idx
                                                                  ]
                                                                    ?.addNewInvoice ? (
                                                                    <>
                                                                      <Field
                                                                        disabled={
                                                                          !values
                                                                            .deliveries[
                                                                          index
                                                                          ][
                                                                          "active"
                                                                          ]
                                                                        }
                                                                        name={`deliveries[${index}].invoices[${idx}].invoice_no`}
                                                                        component={
                                                                          MyInput
                                                                        }
                                                                      />
                                                                    </>
                                                                  ) : (
                                                                    "NA"
                                                                  )}
                                                                </>
                                                              )}
                                                            </Grid.Column>
                                                            <Grid.Column>
                                                              <label>
                                                                {t(
                                                                  "invoice_date"
                                                                ) ||
                                                                  "Invoice Date"}
                                                              </label>
                                                              <br></br>
                                                              {!values
                                                                .deliveries[
                                                                index
                                                              ]["active"] ? (
                                                                <>
                                                                  {values
                                                                    .deliveries[
                                                                    index
                                                                  ].invoices[
                                                                    idx
                                                                  ].invoice_date
                                                                    ? moment(
                                                                      values
                                                                        .deliveries[
                                                                        index
                                                                      ]
                                                                        .invoices[
                                                                        idx
                                                                      ]
                                                                        .invoice_date
                                                                    ).format(
                                                                      "DD-MM-YYYY"
                                                                    )
                                                                    : "NA"}
                                                                </>
                                                              ) : (
                                                                <DateData
                                                                  // style={{ width: "100% !important" }}
                                                                  name={`deliveries[${index}].invoices[${idx}].invoice_date`}
                                                                  disabled={
                                                                    !values
                                                                      .deliveries[
                                                                    index
                                                                    ]["active"]
                                                                  }
                                                                  autoComplete="off"
                                                                  // showTimeSelect
                                                                  //timeFormat="HH:mm"
                                                                  popperClassName="dateTime"
                                                                  dateFormat="dd/MM/yyyy"
                                                                  selected={
                                                                    new Date(
                                                                      values.deliveries[
                                                                        index
                                                                      ].invoices[
                                                                        idx
                                                                      ].invoice_date
                                                                    )
                                                                  }
                                                                  timeIntervals={
                                                                    5
                                                                  }
                                                                  customInput={
                                                                    <Input
                                                                      icon="time"
                                                                      // className="dateWidth"
                                                                      iconPosition="left"
                                                                    />
                                                                  }
                                                                />
                                                                // null
                                                              )}
                                                            </Grid.Column>
                                                            <Grid.Column>
                                                              <label>
                                                                {t(
                                                                  "invoice_quantity"
                                                                ) || "Quantity"}
                                                              </label>
                                                              <br></br>
                                                              <Field
                                                                disabled={
                                                                  !values
                                                                    .deliveries[
                                                                  index
                                                                  ]["active"]
                                                                }
                                                                type="number"
                                                                name={`deliveries[${index}].invoices[${idx}].invoice_quantity`}
                                                                component={
                                                                  MyNormalInput
                                                                }
                                                              />
                                                            </Grid.Column>
                                                            <Grid.Column>
                                                              <label>
                                                                {t(
                                                                  "invoice_amount"
                                                                ) ||
                                                                  "Invoice Amount"}
                                                              </label>
                                                              <br></br>
                                                              <Field
                                                                disabled={
                                                                  !values
                                                                    .deliveries[
                                                                  index
                                                                  ]["active"]
                                                                }
                                                                type="number"
                                                                name={`deliveries[${index}].invoices[${idx}].invoice_amount`}
                                                                component={
                                                                  MyNormalInput
                                                                }
                                                              />
                                                            </Grid.Column>
                                                          </Grid.Row>
                                                          <Grid.Row columns={4} style={orderDetails}>
                                                            <Grid.Column>
                                                              <label>
                                                                {
                                                                  "Eway Bill Number"
                                                                }
                                                              </label>
                                                              <br></br>
                                                              {!values
                                                                .deliveries[
                                                                index
                                                              ]["active"] ? (
                                                                item.eway_bill_no ? item.eway_bill_no : 'NA'
                                                              ) : (
                                                                <>
                                                                  {values
                                                                    .deliveries[
                                                                    index
                                                                  ]["active"] ? (
                                                                    <>
                                                                      <Field
                                                                        disabled={
                                                                          !values
                                                                            .deliveries[
                                                                          index
                                                                          ][
                                                                          "active"
                                                                          ]
                                                                        }
                                                                        maxLength={12}
                                                                        type='number'
                                                                        name={`deliveries[${index}].invoices[${idx}].eway_bill_no`}
                                                                        value={item.eway_bill_no ? item.eway_bill_no : ''}
                                                                        component={
                                                                          MyNumInput
                                                                        }
                                                                        min={0}
                                                                        error={
                                                                          getIn(
                                                                            errors,
                                                                            `deliveries[${index}].invoices[${idx}].eway_bill_no`
                                                                          ) &&
                                                                            getIn(
                                                                              touched,
                                                                              `deliveries[${index}].invoices[${idx}].eway_bill_no`
                                                                            )
                                                                            ? true
                                                                            : false
                                                                        }
                                                                      />
                                                                    </>
                                                                  ) : (
                                                                    "NA"
                                                                  )}
                                                                  <ErrorMessages
                                                                    className="fileTypes"
                                                                    name={`deliveries[${index}].invoices[${idx}].eway_bill_no`}
                                                                    />
                                                                </>    
                                                              )}
                                                            </Grid.Column>
                                                            <Grid.Column style={orderDetails}>
                                                              <label>
                                                                {
                                                                  "Eway Bill Expiry Date"
                                                                }
                                                              </label>
                                                              <br></br>
                                                              {!values
                                                                .deliveries[
                                                                index
                                                              ]["active"] ? (
                                                                <>
                                                                  {values
                                                                    .deliveries[
                                                                    index
                                                                  ].invoices[
                                                                    idx
                                                                  ].eway_bill_expirydate
                                                                    ? moment(
                                                                      item.eway_bill_expirydate
                                                                    ).format(
                                                                      "DD-MM-yyyy"
                                                                    )
                                                                    : "NA"}
                                                                </>
                                                              ) : (
                                                                <DateData
                                                                  name={`deliveries[${index}].invoices[${idx}].eway_bill_expirydate`}
                                                                  disabled={
                                                                    !values
                                                                      .deliveries[
                                                                    index
                                                                    ]["active"]
                                                                  }
                                                                  popperClassName="date"
                                                                  dateFormat="dd-MM-yyyy"
                                                                  minDate={moment().toDate()}
                                                                  filterDate={(
                                                                    date
                                                                  ) => {
                                                                    return (
                                                                      moment() <
                                                                      date
                                                                    );
                                                                  }}
                                                                  selected={
                                                                    new Date(
                                                                      values.deliveries[
                                                                        index
                                                                      ].invoices[
                                                                        idx
                                                                      ].eway_bill_expirydate
                                                                    )
                                                                  }
                                                                  customInput={
                                                                    <Input
                                                                      value={
                                                                        values
                                                                          .deliveries[
                                                                          index
                                                                        ]
                                                                          .invoices[
                                                                          idx
                                                                        ]
                                                                          .eway_bill_expirydate
                                                                      }
                                                                      icon="time"
                                                                      iconPosition="left"
                                                                    />
                                                                  }
                                                                />
                                                              )}
                                                            </Grid.Column>
                                                            {values
                                                              ?.deliveries?.[
                                                              index
                                                            ]?.invoices?.[idx]
                                                              ?.id ? (
                                                              <Grid.Column style={orderDetails}>
                                                                <label>
                                                                  {t(
                                                                    "goods_invoice"
                                                                  ) ||
                                                                    "Goods Invoice"}
                                                                </label>
                                                                <br />
                                                                {values
                                                                  .deliveries[
                                                                  index
                                                                ].invoices[idx]
                                                                  .invoice_document_path ? (
                                                                  <>
                                                                    <input
                                                                      id="goods_invoice"
                                                                      name="goods_invoice"
                                                                      type="file"
                                                                      style={{
                                                                        display:
                                                                          "none",
                                                                      }}
                                                                      accept="application/pdf, application/vnd.ms-excel"
                                                                      onChange={(
                                                                        event
                                                                      ) => {
                                                                        updateGoodsInvoice(
                                                                          "invoice_doc",
                                                                          event
                                                                            .currentTarget
                                                                            .files[0],
                                                                          values
                                                                            .deliveries[
                                                                            index
                                                                          ]
                                                                            .invoices[
                                                                            idx
                                                                          ].id
                                                                        );
                                                                      }}
                                                                    />
                                                                    <Button
                                                                      className="docsButton"
                                                                      size="mini"
                                                                      type="button"
                                                                      onClick={() =>
                                                                        getFileid(
                                                                          "goods_invoice"
                                                                        )
                                                                      }
                                                                      basic
                                                                      color="green"
                                                                      icon
                                                                    >
                                                                      <Icon name="upload" />
                                                                    </Button>
                                                                    &nbsp;
                                                                    <Button
                                                                      className="docsButton"
                                                                      size="mini"
                                                                      basic
                                                                      type="button"
                                                                      onClick={() =>
                                                                        downloadGoodsInvoiceFile(
                                                                          values
                                                                            .deliveries[
                                                                            index
                                                                          ]
                                                                            .invoices[
                                                                            idx
                                                                          ].id
                                                                        )
                                                                      }
                                                                      color="primary"
                                                                      icon
                                                                    >
                                                                      <Icon name="download" />
                                                                    </Button>
                                                                  </>
                                                                ) : (
                                                                  <>
                                                                    <input
                                                                      id="goods_invoice"
                                                                      name="goods_invoice"
                                                                      type="file"
                                                                      style={{
                                                                        width:
                                                                          "80%",
                                                                      }}
                                                                      accept="application/pdf, application/vnd.ms-excel"
                                                                      onChange={(
                                                                        event
                                                                      ) => {
                                                                        setGoodsInvoiceFile(
                                                                          "invoice_doc",
                                                                          event
                                                                            .currentTarget
                                                                            .files[0]
                                                                        );
                                                                        setFieldValue(
                                                                          "deliveries[${index}].invoices[${idx}].invoice_document_path",
                                                                          event
                                                                            .currentTarget
                                                                            .files[0]
                                                                        );
                                                                      }}
                                                                    />
                                                                    <div className="d-flex">
                                                                    <Button
                                                                      className="docsButton"
                                                                      size="mini"
                                                                      type="button"
                                                                      disabled={
                                                                        disableGoodsInvoicebtn
                                                                      }
                                                                      onClick={() =>
                                                                        uploadGoodsInvoice(
                                                                          "invoice_doc",
                                                                          values
                                                                            .deliveries[
                                                                            index
                                                                          ]
                                                                            .invoices[
                                                                            idx
                                                                          ].id
                                                                        )
                                                                      }
                                                                      basic
                                                                      color="green"
                                                                      icon
                                                                    >
                                                                      <Icon name="upload" />
                                                                    </Button>
                                                                    </div>
                                                                  </>
                                                                )}
                                                              </Grid.Column>
                                                            ) : null}
                                                            <Grid.Column style={orderDetails}>
                                                              <label>
                                                                {
                                                                  "Invoice Copy"
                                                                }
                                                              </label>
                                                              {values?.deliveries?.[index]?.invoices?.[idx]?.invoice_related_documents?.length > 0 ?
                                                                <>
                                                                  {values.deliveries[index].invoices?.[idx].invoice_related_documents.map((item, docNo) => {
                                                                    return (
                                                                      <>
                                                                        {item.doc_type === 'invoice_no' ?
                                                                          <>
                                                                            <input
                                                                              type="file"
                                                                              accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                                              onChange={(event) => {
                                                                                if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                                                  setFieldValue(`deliveries[${index}].invoices[${idx}].invoice_copy`, event.currentTarget.files[0])
                                                                                  if (event.currentTarget.files[0]) {
                                                                                    setEnableInvoiceDoc(false)
                                                                                  }
                                                                                } else {
                                                                                  setEnableInvoiceDoc(true)
                                                                                  cogoToast.error(INVALID_FILE_TYPE)
                                                                                }
                                                                              }}
                                                                            />
                                                                            <div className="d-flex align-items-center">
                                                                              <Button
                                                                                className="docsButton"
                                                                                disabled={enableInvoiceDoc}
                                                                                size="mini"
                                                                                type="button"
                                                                                onClick={() => {
                                                                                  uploadInvoices('invoice_no', values.deliveries[index].invoices[idx].invoice_copy, values.deliveries[index].invoices[idx].id)
                                                                                }
                                                                                }
                                                                                basic
                                                                                color="green"
                                                                                icon
                                                                              >
                                                                                <Icon name="upload" />
                                                                              </Button>
                                                                              <Button
                                                                                className="docsButton"
                                                                                size="mini"
                                                                                basic
                                                                                type="button"
                                                                                onClick={() => {
                                                                                  downloadInvoices('invoice_no', item.doc_key, values.deliveries[index].invoices[idx].id)

                                                                                }
                                                                                }
                                                                                color="primary"
                                                                                icon
                                                                              >
                                                                                <Icon name="download" />
                                                                              </Button>
                                                                              <Button
                                                                                className="docsButton"
                                                                                size="mini"
                                                                                basic
                                                                                type="button"
                                                                                onClick={() => {
                                                                                  deleteInvoiceDocs('invoice_no', item.doc_key, values.deliveries[index].invoices[idx].id)
                                                                                  setEnableInvoiceDoc(true)
                                                                                }
                                                                                }
                                                                                color="red"
                                                                                icon
                                                                              >
                                                                                <Icon name="trash" />
                                                                              </Button>
                                                                              <div className="fileName">
                                                                                {
                                                                                  item.doc_key.replace(/^.*(\\|\/|\:|-)/, '')
                                                                                }
                                                                              </div>
                                                                              <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                                            </div>
                                                                          </>
                                                                          :
                                                                          <>
                                                                            {(item.doc_type.localeCompare('invoice_no') != 0 && (docNo == values.deliveries[index].invoices[idx].invoice_related_documents.length - 1) && values.deliveries[index].invoices[idx].invoice_related_documents.length <= 1)
                                                                              ?
                                                                              <>
                                                                                <input
                                                                                  type="file"
                                                                                  accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                                                  onChange={(event) => {
                                                                                    if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                                                      setFieldValue(`deliveries[${index}].invoices[${idx}].invoice_copy`, event.currentTarget.files[0])
                                                                                      if (event.currentTarget.files[0]) {
                                                                                        setEnableInvoiceDoc(false)
                                                                                      }
                                                                                    } else {
                                                                                      setEnableInvoiceDoc(true)
                                                                                      cogoToast.error(INVALID_FILE_TYPE)
                                                                                    }
                                                                                  }}
                                                                                />
                                                                                <div className="d-flex align-items-center">
                                                                                  <Button
                                                                                    className="docsButton"
                                                                                    disabled={enableInvoiceDoc}
                                                                                    size="mini"
                                                                                    type="button"
                                                                                    onClick={() => {
                                                                                      uploadInvoices('invoice_no', values.deliveries[index].invoices[idx].invoice_copy, values.deliveries[index].invoices[idx].id)
                                                                                    }
                                                                                    }
                                                                                    basic
                                                                                    color="green"
                                                                                    icon
                                                                                  >
                                                                                    <Icon name="upload" />
                                                                                  </Button>
                                                                                  <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                                                </div>
                                                                              </>
                                                                              :
                                                                              null}
                                                                          </>}
                                                                      </>
                                                                    )
                                                                  })}
                                                                </>
                                                                :
                                                                <>
                                                                  <input
                                                                    type="file"
                                                                    accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                                    onChange={(event) => {
                                                                      if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                                        setFieldValue(`deliveries[${index}].invoices[${idx}].invoice_copy`, event.currentTarget.files[0])
                                                                        if (event.currentTarget.files[0]) {
                                                                          setEnableInvoiceDoc(false)
                                                                        }
                                                                      } else {
                                                                        setEnableInvoiceDoc(true)
                                                                        cogoToast.error(INVALID_FILE_TYPE)
                                                                      }
                                                                    }}
                                                                  />
                                                                  <div className="d-flex align-items-center">
                                                                    <Button
                                                                      className="docsButton"
                                                                      disabled={enableInvoiceDoc}
                                                                      size="mini"
                                                                      type="button"
                                                                      onClick={() => {
                                                                        uploadInvoices('invoice_no', values.deliveries[index].invoices[idx].invoice_copy, values.deliveries[index].invoices[idx].id)
                                                                      }
                                                                      }
                                                                      basic
                                                                      color="green"
                                                                      icon
                                                                    >
                                                                      <Icon name="upload" />
                                                                    </Button>
                                                                    <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                                  </div>
                                                                </>
                                                              }
                                                            </Grid.Column>

                                                            <Grid.Column style={orderDetails}>
                                                              <label>
                                                                {
                                                                  "Eway Bill Copy"
                                                                }
                                                              </label>
                                                              {values?.deliveries?.[index]?.invoices?.[idx]?.invoice_related_documents?.length > 0 ?
                                                                <>
                                                                  {values.deliveries[index].invoices?.[idx].invoice_related_documents.map((item, docNo) => {
                                                                    return (
                                                                      <>
                                                                        {item.doc_type === 'eway_bill' ?
                                                                          <>

                                                                            <input
                                                                              //name="daughter_invoice"
                                                                              type="file"
                                                                              accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                                              onChange={(event) => {
                                                                                if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                                                  setFieldValue(`deliveries[${index}].invoices[${idx}].eway_bill_copy`, event.currentTarget.files[0])
                                                                                  if (event.currentTarget.files[0]) {
                                                                                    setEnableEwayDoc(false)
                                                                                  }
                                                                                } else {
                                                                                  setEnableEwayDoc(true)
                                                                                  cogoToast.error(INVALID_FILE_TYPE)
                                                                                }
                                                                              }}
                                                                            />
                                                                            <div className="d-flex align-items-center">
                                                                              <Button
                                                                                className="docsButton"
                                                                                disabled={enableEwayDoc}
                                                                                size="mini"
                                                                                type="button"
                                                                                onClick={() => {
                                                                                  uploadInvoices('eway_bill', values.deliveries[index].invoices[idx].eway_bill_copy, values.deliveries[index].invoices[idx].id)
                                                                                }
                                                                                }
                                                                                basic
                                                                                color="green"
                                                                                icon
                                                                              >
                                                                                <Icon name="upload" />
                                                                              </Button>
                                                                              <Button
                                                                                className="docsButton"
                                                                                size="mini"
                                                                                basic
                                                                                type="button"
                                                                                onClick={() => {
                                                                                  downloadInvoices('eway_bill', item.doc_key, values.deliveries[index].invoices[idx].id)

                                                                                }
                                                                                }
                                                                                color="primary"
                                                                                icon
                                                                              >
                                                                                <Icon name="download" />
                                                                              </Button>
                                                                              <Button
                                                                                className="docsButton"
                                                                                size="mini"
                                                                                basic
                                                                                type="button"
                                                                                onClick={() => {
                                                                                  deleteInvoiceDocs('eway_bill', item.doc_key, values.deliveries[index].invoices[idx].id)
                                                                                  setEnableEwayDoc(true)
                                                                                }
                                                                                }
                                                                                color="red"
                                                                                icon
                                                                              >
                                                                                <Icon name="trash" />
                                                                              </Button>
                                                                              <div className="fileName">
                                                                                {
                                                                                  item.doc_key.replace(/^.*(\\|\/|\:|-)/, '')
                                                                                }
                                                                              </div>
                                                                              <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                                            </div>
                                                                          </>
                                                                          :
                                                                          <>
                                                                            {(item.doc_type.localeCompare('eway_bill') != 0 && (docNo == values.deliveries[index].invoices[idx].invoice_related_documents.length - 1) && values.deliveries[index].invoices[idx].invoice_related_documents.length <= 1)
                                                                              ?
                                                                              <>
                                                                                <input                                                                                  type="file"
                                                                                  accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                                                  onChange={(event) => {
                                                                                    if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                                                      setFieldValue(`deliveries[${index}].invoices[${idx}].eway_bill_copy`, event.currentTarget.files[0])
                                                                                      if (event.currentTarget.files[0]) {
                                                                                        setEnableEwayDoc(false)
                                                                                      }
                                                                                    } else {
                                                                                      setEnableEwayDoc(true)
                                                                                      cogoToast.error(INVALID_FILE_TYPE)
                                                                                    }
                                                                                  }}
                                                                                />
                                                                                <div className="d-flex align-items-center">
                                                                                  <Button
                                                                                    className="docsButton"
                                                                                    disabled={enableEwayDoc}
                                                                                    size="mini"
                                                                                    type="button"
                                                                                    onClick={() => {
                                                                                      uploadInvoices('eway_bill', values.deliveries[index].invoices[idx].eway_bill_copy, values.deliveries[index].invoices[idx].id)
                                                                                    }
                                                                                    }
                                                                                    basic
                                                                                    color="green"
                                                                                    icon
                                                                                  >
                                                                                    <Icon name="upload" />
                                                                                  </Button>
                                                                                  <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                                                </div>
                                                                              </>
                                                                              :
                                                                              null}
                                                                          </>}
                                                                      </>
                                                                    )
                                                                  })}
                                                                </>
                                                                :
                                                                <>
                                                                  <input
                                                                    type="file"
                                                                    accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                                    onChange={(event) => {
                                                                      if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                                        setFieldValue(`deliveries[${index}].invoices[${idx}].eway_bill_copy`, event.currentTarget.files[0])
                                                                        if (event.currentTarget.files[0]) {
                                                                          setEnableEwayDoc(false)
                                                                        }
                                                                      } else {
                                                                        setEnableEwayDoc(true)
                                                                        cogoToast.error(INVALID_FILE_TYPE)
                                                                      }
                                                                    }}
                                                                  />
                                                                  <div className="d-flex align-items-center">
                                                                    <Button
                                                                      className="docsButton"
                                                                      disabled={enableEwayDoc}
                                                                      size="mini"
                                                                      type="button"
                                                                      onClick={() => {
                                                                        uploadInvoices('eway_bill', values.deliveries[index].invoices[idx].eway_bill_copy, values.deliveries[index].invoices[idx].id)
                                                                      }
                                                                      }
                                                                      basic
                                                                      color="green"
                                                                      icon
                                                                    >
                                                                      <Icon name="upload" />
                                                                    </Button>
                                                                    <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                                  </div>
                                                                </>
                                                              }
                                                            </Grid.Column>
                                                          </Grid.Row>
                                                          <Grid.Row columns={4}>
                                                            {props.movement_type &&
                                                              (props.movement_type ===
                                                                "Import" ||
                                                                props.movement_type ===
                                                                "Importar" ||
                                                                props.movement_type ===
                                                                "Export") ? (
                                                              <>
                                                                <Grid.Column>
                                                                  <label>
                                                                    {t(
                                                                      "bl_no"
                                                                    ) ||
                                                                      "BL NO"}
                                                                  </label>

                                                                  <br />
                                                                  {item.bl_no ? (
                                                                    item.bl_no
                                                                  ) : (
                                                                    <>
                                                                      {values
                                                                        ?.deliveries?.[
                                                                        index
                                                                      ]
                                                                        ?.invoices?.[
                                                                        idx
                                                                      ]
                                                                        ?.addNewInvoice ? (
                                                                        <>
                                                                          <Field
                                                                            disabled={
                                                                              !values
                                                                                .deliveries[
                                                                              index
                                                                              ][
                                                                              "active"
                                                                              ]
                                                                            }
                                                                            name={`deliveries[${index}].invoices[${idx}].bl_no`}
                                                                            component={
                                                                              MyInput
                                                                            }
                                                                          />
                                                                        </>
                                                                      ) : (
                                                                        "NA"
                                                                      )}
                                                                    </>
                                                                  )}
                                                                </Grid.Column>
                                                                <Grid.Column style={orderDetails}>
                                                                  <label>
                                                                    {t(
                                                                      "boe_no"
                                                                    ) ||
                                                                      "BoE NO"}
                                                                  </label>
                                                                  <br />
                                                                  <Field
                                                                    disabled={
                                                                      !values
                                                                        .deliveries[
                                                                      index
                                                                      ][
                                                                      "active"
                                                                      ]
                                                                    }
                                                                    name={`deliveries[${index}].invoices[${idx}].boe_no`}
                                                                    component={
                                                                      MyNormalInput
                                                                    }
                                                                  />
                                                                </Grid.Column>
                                                                <Grid.Column style={orderDetails}>
                                                                  <label>
                                                                    {t(
                                                                      "boe_date"
                                                                    ) ||
                                                                      "boe_date"}
                                                                  </label>

                                                                  <br />
                                                                  {!values
                                                                    .deliveries[
                                                                    index
                                                                  ][
                                                                    "active"
                                                                  ] ? (
                                                                    <>
                                                                      {values
                                                                        .deliveries[
                                                                        index
                                                                      ]
                                                                        .invoices[
                                                                        idx
                                                                      ].boe_date
                                                                        ? moment(
                                                                          values
                                                                            .deliveries[
                                                                            index
                                                                          ]
                                                                            .invoices[
                                                                            idx
                                                                          ]
                                                                            .boe_date
                                                                        ).format(
                                                                          "DD-MM-YYYY"
                                                                        )
                                                                        : "NA"}
                                                                    </>
                                                                  ) : (
                                                                    <DateData
                                                                      // style={{ width: "100% !important" }}
                                                                      name={`deliveries[${index}].invoices[${idx}].boe_date`}
                                                                      disabled={
                                                                        !values
                                                                          .deliveries[
                                                                        index
                                                                        ][
                                                                        "active"
                                                                        ]
                                                                      }
                                                                      autoComplete="off"
                                                                      // showTimeSelect
                                                                      //timeFormat="HH:mm"
                                                                      popperClassName="dateTime"
                                                                      dateFormat="dd/MM/yyyy"
                                                                      selected={
                                                                        new Date(
                                                                          values.deliveries[
                                                                            index
                                                                          ].invoices[
                                                                            idx
                                                                          ].boe_date
                                                                        )
                                                                      }
                                                                      timeIntervals={
                                                                        5
                                                                      }
                                                                      customInput={
                                                                        <Input
                                                                          icon="time"
                                                                          // className="dateWidth"
                                                                          iconPosition="left"
                                                                        />
                                                                      }
                                                                    />
                                                                    // null
                                                                  )}
                                                                </Grid.Column>
                                                              </>
                                                            ) : null}
                                                          </Grid.Row>
                                                        </Grid>
                                                      </Table.Body>
                                                    </Table>
                                                  </Table.Cell>
                                                </Table.Row>
                                              ))}
                                              <Table.Row>
                                                <Table.Cell
                                                  colSpan="12"
                                                  className="text-left border-0"
                                                >
                                                  {values.deliveries[index][
                                                    "active"
                                                  ] &&
                                                    !(
                                                      (props?.currenOrder
                                                        ?.allotment_status &&
                                                        props?.currenOrder
                                                          ?.allotment_status
                                                          ?.allotment_code ==
                                                        "ALLOC") ||
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "CANCEL" ||
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "COMPLETE"
                                                    ) ? (
                                                    <Button
                                                      basic
                                                      color="blue"
                                                      className="m-2"
                                                      type="button"
                                                      onClick={() => {
                                                        invoiceDetails.push({
                                                          addNewInvoice: true,
                                                          invoice_id: null,
                                                          invoice_no: "",
                                                          bl_no: "",
                                                          invoice_date:
                                                            new Date(),
                                                          boe_date: "",
                                                          boe_no: "",
                                                          invoice_quantity: "",
                                                          invoice_amount: "",
                                                          tracking_number: "",
                                                          eway_bill_expirydate: new Date(),
                                                          eway_bill_no: ""
                                                        });
                                                      }}
                                                      size="mini"
                                                    >
                                                      {" "}
                                                      {props.t(
                                                        "action_button.add_more_invoice"
                                                      ) ||
                                                        "Add More Invoices"}{" "}
                                                    </Button>
                                                  ) : null}
                                                </Table.Cell>
                                              </Table.Row>
                                            </>
                                          )}
                                        /> */}

                                        <FieldArray
                                          name={`deliveries.[${index}].invoices`}
                                          render={(invoiceDetails) => (
                                            <>
                                              {values.deliveries[
                                                index
                                              ].invoices.map((item, idx) =>
                                                item.eway_bill_copy || item.eway_bill_expirydate || item.eway_bill_no || item.invoice_amount ||
                                                  item.invoice_code || item.invoice_copy || item.invoice_date || item.invoice_quantity || values
                                                    .deliveries[
                                                  index
                                                  ][
                                                  "active"
                                                  ] ?
                                                  (
                                                    <Table.Row
                                                      key={`invoices+${idx}`}
                                                    >

                                                      <Table.Cell colSpan="22">
                                                        <Table>
                                                          <Table.Header>
                                                            <Table.Row>
                                                              <TableHeaderCell colSpan="10">
                                                                {t(
                                                                  "invoice_title"
                                                                ) || "Invoice"}{" "}
                                                                {idx + 1}
                                                              </TableHeaderCell>
                                                              <TableHeaderCell
                                                                colSpan="2"
                                                                className="text-right"
                                                              >
                                                                {values
                                                                  ?.deliveries?.[
                                                                  index
                                                                ]?.invoices?.[idx]
                                                                  ?.addNewInvoice ? (
                                                                  <>
                                                                    <Button
                                                                      basic
                                                                      color="red"
                                                                      type="button"
                                                                      onClick={() =>
                                                                        productDetails.remove(
                                                                          i
                                                                        )
                                                                      }
                                                                      size="mini"
                                                                      icon
                                                                    >
                                                                      {" "}
                                                                      <Icon
                                                                        name="trash"
                                                                        color="red"
                                                                      />{" "}
                                                                    </Button>
                                                                    <Button
                                                                      basic
                                                                      color="green"
                                                                      type="button"
                                                                      onClick={(
                                                                        e
                                                                      ) => {
                                                                        e.stopPropagation();
                                                                        saveAddedInvoice(
                                                                          values
                                                                            .deliveries[
                                                                            index
                                                                          ]
                                                                            .invoices[
                                                                          idx
                                                                          ],
                                                                          values
                                                                            .deliveries[
                                                                            index
                                                                          ]
                                                                            .delivery_id
                                                                        );
                                                                      }}
                                                                      size="mini"
                                                                      icon
                                                                    >
                                                                      {" "}
                                                                      <Icon name="save" />{" "}
                                                                    </Button>
                                                                  </>
                                                                ) : (
                                                                  <></>
                                                                )}
                                                              </TableHeaderCell>
                                                            </Table.Row>
                                                          </Table.Header>
                                                          <Table.Body>
                                                            <Grid className="m-2">
                                                              <Grid.Row columns={3} style={orderDetails} >
                                                                <Grid.Column className="mt-2">
                                                                  <label>
                                                                    {t(
                                                                      "invoice_code"
                                                                    ) ||
                                                                      "Invoice Number"}
                                                                  </label>
                                                                  <br></br>
                                                                  <Field
                                                                    disabled={
                                                                      !values
                                                                        .deliveries[
                                                                      index
                                                                      ][
                                                                      "active"
                                                                      ]
                                                                    }
                                                                    style={{ width: "100%" }}
                                                                    name={`deliveries[${index}].invoices[${idx}].invoice_no`}
                                                                    component={
                                                                      MyNormalInput
                                                                    }
                                                                  />
                                                                </Grid.Column>

                                                                <Grid.Column className="mt-2">
                                                                  <label>
                                                                    {t(
                                                                      "invoice_reference_no"
                                                                    ) ||
                                                                      "Invoice Reference Number"}
                                                                  </label>
                                                                  <br></br>
                                                                  <Field
                                                                    disabled={
                                                                      !values
                                                                        .deliveries[
                                                                      index
                                                                      ][
                                                                      "active"
                                                                      ]
                                                                    }
                                                                    style={{ width: "100%" }}
                                                                    name={`deliveries[${index}].invoices[${idx}].invoice_reference_no`}
                                                                    component={
                                                                      MyNormalInput
                                                                    }
                                                                  />
                                                                </Grid.Column>

                                                                <Grid.Column className="mt-2">
                                                                  <label>
                                                                    {t(
                                                                      "invoice_date"
                                                                    ) ||
                                                                      "Invoice Date"}
                                                                  </label>
                                                                  <br></br>

                                                                  <DateData
                                                                    // style={{ width: "100% !important" }}
                                                                    name={`deliveries[${index}].invoices[${idx}].invoice_date`}
                                                                    disabled={
                                                                      !values
                                                                        .deliveries[
                                                                      index
                                                                      ]["active"]
                                                                    }
                                                                    autoComplete="off"
                                                                    popperClassName="dateTime"
                                                                    dateFormat="dd/MM/yyyy"
                                                                    selected={
                                                                      new Date(
                                                                        values.deliveries[
                                                                          index
                                                                        ].invoices[
                                                                          idx
                                                                        ].invoice_date
                                                                      )
                                                                    }
                                                                    timeIntervals={
                                                                      5
                                                                    }
                                                                    customInput={
                                                                      <Input
                                                                        icon="time"
                                                                        // className="dateWidth"
                                                                        iconPosition="left"
                                                                      />
                                                                    }
                                                                  />

                                                                </Grid.Column>
                                                                <Grid.Column className="mt-2">
                                                                  <label>
                                                                    {t(
                                                                      "invoice_quantity"
                                                                    ) || "Quantity"}
                                                                  </label>
                                                                  <br></br>
                                                                  <Field
                                                                    disabled={
                                                                      !values
                                                                        .deliveries[
                                                                      index
                                                                      ]["active"]
                                                                    }
                                                                    type="number"
                                                                    style={{ width: "100%" }}
                                                                    name={`deliveries[${index}].invoices[${idx}].invoice_quantity`}
                                                                    component={
                                                                      MyNormalInput
                                                                    }
                                                                  />
                                                                </Grid.Column>
                                                                <Grid.Column className="mt-2">
                                                                  <label>
                                                                    {t(
                                                                      "invoice_amount"
                                                                    ) ||
                                                                      "Invoice Amount"}
                                                                  </label>
                                                                  <br></br>
                                                                  <Field
                                                                    disabled={
                                                                      !values
                                                                        .deliveries[
                                                                      index
                                                                      ]["active"]
                                                                    }
                                                                    type="number"
                                                                    style={{ width: "100%" }}
                                                                    name={`deliveries[${index}].invoices[${idx}].invoice_amount`}
                                                                    component={
                                                                      MyNormalInput
                                                                    }
                                                                  />
                                                                </Grid.Column>

                                                                <Grid.Column className="mt-2">
                                                                  <label>
                                                                    {
                                                                      "Eway Bill Number"
                                                                    }
                                                                  </label>
                                                                  <br></br>
                                                                  {
                                                                  }
                                                                  <Field
                                                                    disabled={
                                                                      !values
                                                                        .deliveries[
                                                                      index
                                                                      ][
                                                                      "active"
                                                                      ]
                                                                    }
                                                                    maxLength={12}
                                                                    name={`deliveries[${index}].invoices[${idx}].eway_bill_no`}
                                                                    value={item.eway_bill_no ? item.eway_bill_no : ''}
                                                                    component={
                                                                      MyNumInput
                                                                    }
                                                                    min={0}
                                                                    error={
                                                                      getIn(
                                                                        errors,
                                                                        `deliveries[${index}].invoices[${idx}].eway_bill_no`
                                                                      ) &&
                                                                        getIn(
                                                                          touched,
                                                                          `deliveries[${index}].invoices[${idx}].eway_bill_no`
                                                                        )
                                                                        ? true
                                                                        : false
                                                                    }
                                                                  />
                                                                  {
                                                                    getIn(
                                                                      errors,
                                                                      `deliveries[${index}].invoices[${idx}].eway_bill_no`
                                                                    ) &&
                                                                      getIn(
                                                                        touched,
                                                                        `deliveries[${index}].invoices[${idx}].eway_bill_no`
                                                                      ) ? <div style={{ color: 'red' }}>{INVALID_FIELDS.INVALID_EWAYBILL_NO}</div> : null
                                                                  }

                                                                </Grid.Column>
                                                                <Grid.Column style={orderDetails} className="mt-2">
                                                                  <label>
                                                                    {
                                                                      "Eway Bill Expiry Date"
                                                                    }
                                                                  </label>
                                                                  <br></br>
                                                                  <DateData
                                                                    name={`deliveries[${index}].invoices[${idx}].eway_bill_expirydate`}
                                                                    disabled={
                                                                      !values
                                                                        .deliveries[
                                                                      index
                                                                      ][
                                                                      "active"
                                                                      ]
                                                                    }
                                                                    autoComplete="off"
                                                                    // showTimeSelect
                                                                    //timeFormat="HH:mm"
                                                                    popperClassName="dateTime"
                                                                    dateFormat="dd/MM/yyyy"
                                                                    selected={
                                                                      new Date(
                                                                        (values.deliveries[
                                                                          index
                                                                        ].invoices[
                                                                          idx
                                                                        ].eway_bill_expirydate != '0000-00-00' ? values.deliveries[
                                                                          index
                                                                        ].invoices[
                                                                          idx
                                                                        ].eway_bill_expirydate : new Date())
                                                                      )
                                                                    }
                                                                    timeIntervals={
                                                                      5
                                                                    }
                                                                    customInput={
                                                                      <Input
                                                                        icon="time"
                                                                        // className="dateWidth"
                                                                        iconPosition="left"
                                                                      />
                                                                    }
                                                                  />
                                                                </Grid.Column>
                                                                {values
                                                                  ?.deliveries?.[
                                                                  index
                                                                ]?.invoices?.[idx]
                                                                  ?.id ? (
                                                                  <Grid.Column style={orderDetails} className="mt-2">
                                                                    <label>
                                                                      {t(
                                                                        "goods_invoice"
                                                                      ) ||
                                                                        "Goods Invoice"}
                                                                    </label>
                                                                    <br />
                                                                    {values
                                                                      .deliveries[
                                                                      index
                                                                    ].invoices[idx]
                                                                      .invoice_document_path ? (
                                                                      <>
                                                                        <input
                                                                          id="goods_invoice"
                                                                          name="goods_invoice"
                                                                          type="file"
                                                                          style={{
                                                                            display:
                                                                              "none",
                                                                            width: "100%"
                                                                          }}
                                                                          accept="application/pdf, application/vnd.ms-excel"
                                                                          onChange={(
                                                                            event
                                                                          ) => {
                                                                            updateGoodsInvoice(
                                                                              "invoice_doc",
                                                                              event
                                                                                .currentTarget
                                                                                .files[0],
                                                                              values
                                                                                .deliveries[
                                                                                index
                                                                              ]
                                                                                .invoices[
                                                                                idx
                                                                              ].id
                                                                            );
                                                                          }}
                                                                        />
                                                                        <Button
                                                                          className="docsButton"
                                                                          size="mini"
                                                                          type="button"
                                                                          onClick={() =>
                                                                            getFileid(
                                                                              "goods_invoice"
                                                                            )
                                                                          }
                                                                          basic
                                                                          color="green"
                                                                          icon
                                                                        >
                                                                          <Icon name="upload" />
                                                                        </Button>
                                                                        &nbsp;
                                                                        <Button
                                                                          className="docsButton"
                                                                          size="mini"
                                                                          basic
                                                                          type="button"
                                                                          onClick={() =>
                                                                            downloadGoodsInvoiceFile(
                                                                              values
                                                                                .deliveries[
                                                                                index
                                                                              ]
                                                                                .invoices[
                                                                                idx
                                                                              ].id
                                                                            )
                                                                          }
                                                                          color="primary"
                                                                          icon
                                                                        >
                                                                          <Icon name="download" />
                                                                        </Button>
                                                                      </>
                                                                    ) : (
                                                                      <>
                                                                        <input
                                                                          id="goods_invoice"
                                                                          name="goods_invoice"
                                                                          type="file"
                                                                          style={{
                                                                            width:
                                                                              "100%",
                                                                          }}
                                                                          accept="application/pdf, application/vnd.ms-excel"
                                                                          onChange={(
                                                                            event
                                                                          ) => {
                                                                            setGoodsInvoiceFile(
                                                                              "invoice_doc",
                                                                              event
                                                                                .currentTarget
                                                                                .files[0]
                                                                            );
                                                                            setFieldValue(
                                                                              "deliveries[${index}].invoices[${idx}].invoice_document_path",
                                                                              event
                                                                                .currentTarget
                                                                                .files[0]
                                                                            );
                                                                          }}
                                                                        />
                                                                        <div className="d-flex">
                                                                          <Button
                                                                            className="docsButton"
                                                                            size="mini"
                                                                            type="button"
                                                                            disabled={
                                                                              disableGoodsInvoicebtn
                                                                            }
                                                                            onClick={() =>
                                                                              uploadGoodsInvoice(
                                                                                "invoice_doc",
                                                                                values
                                                                                  .deliveries[
                                                                                  index
                                                                                ]
                                                                                  .invoices[
                                                                                  idx
                                                                                ].id
                                                                              )
                                                                            }
                                                                            basic
                                                                            color="green"
                                                                            icon
                                                                          >
                                                                            <Icon name="upload" />
                                                                          </Button>
                                                                        </div>
                                                                      </>
                                                                    )}
                                                                  </Grid.Column>
                                                                ) : null}
                                                                <Grid.Column style={orderDetails} className="mt-2">
                                                                  <label>
                                                                    {
                                                                      "Invoice Copy"
                                                                    }
                                                                  </label>
                                                                  <br></br>
                                                                  {/* {values?.deliveries?.[index]?.invoices?.[idx]?.invoice_related_documents?.length > 0 ?
                                                                <>
                                                                  {values.deliveries[index].invoices?.[idx].invoice_related_documents.map((item, docNo) => {
                                                                    return (
                                                                      <>
                                                                        {item.doc_type === 'invoice_no' ?
                                                                          <>
                                                                            <input
                                                                              //name="daughter_invoice"
                                                                              type="file"
                                                                              accept="application/pdf, application/vnd.ms-excel"
                                                                              onChange={(event) => {
                                                                                setFieldValue(`deliveries[${index}].invoices[${idx}].invoice_copy`, event.currentTarget.files[0])
                                                                              }}
                                                                            />

                                                                            <Button
                                                                              size="mini"
                                                                              type="button"
                                                                              onClick={() => {
                                                                                uploadInvoices('invoice_no', values.deliveries[index].invoices[idx].invoice_copy, values.deliveries[index].invoices[idx].id)
                                                                              }
                                                                              }
                                                                              basic
                                                                              color="green"
                                                                              icon
                                                                            >
                                                                              <Icon name="upload" />
                                                                            </Button>
                                                                            <Button
                                                                              size="mini"
                                                                              basic
                                                                              type="button"
                                                                              onClick={() => {
                                                                                downloadInvoices('invoice_no', item.doc_key, values.deliveries[index].invoices[idx].id)

                                                                              }
                                                                              }
                                                                              color="primary"
                                                                              icon
                                                                            >
                                                                              <Icon name="download" />
                                                                            </Button>
                                                                          </>
                                                                          :
                                                                          <>
                                                                            {(item.doc_type.localeCompare('invoice_no') != 0 && (docNo == values.deliveries[index].invoices[idx].invoice_related_documents.length - 1) && values.deliveries[index].invoices[idx].invoice_related_documents.length <= 1)
                                                                              ?
                                                                              <>
                                                                                <input
                                                                                  //name="daughter_invoice"
                                                                                  type="file"
                                                                                  accept="application/pdf, application/vnd.ms-excel"
                                                                                  onChange={(event) => {
                                                                                    setFieldValue(`deliveries[${index}].invoices[${idx}].invoice_copy`, event.currentTarget.files[0])
                                                                                  }}
                                                                                />
                                                                                <Button
                                                                                  size="mini"
                                                                                  type="button"
                                                                                  onClick={() => {
                                                                                    uploadInvoices('invoice_no', values.deliveries[index].invoices[idx].invoice_copy, values.deliveries[index].invoices[idx].id)
                                                                                  }
                                                                                  }
                                                                                  basic
                                                                                  color="green"
                                                                                  icon
                                                                                >
                                                                                  <Icon name="upload" />
                                                                                </Button>
                                                                              </>
                                                                              :
                                                                              null}
                                                                          </>}
                                                                      </>
                                                                    )
                                                                  })}
                                                                </>
                                                                :
                                                                <>
                                                                  <input
                                                                    //name="daughter_invoice"
                                                                    type="file"
                                                                    accept="application/pdf, application/vnd.ms-excel"
                                                                    onChange={(event) => {
                                                                      setFieldValue(`deliveries[${index}].invoices[${idx}].invoice_copy`, event.currentTarget.files[0])
                                                                    }}
                                                                  />
                                                                  <Button
                                                                    size="mini"
                                                                    type="button"
                                                                    onClick={() => {
                                                                      uploadInvoices('invoice_no', values.deliveries[index].invoices[idx].invoice_copy, values.deliveries[index].invoices[idx].id)
                                                                    }
                                                                    }
                                                                    basic
                                                                    color="green"
                                                                    icon
                                                                  >
                                                                    <Icon name="upload" />
                                                                  </Button>
                                                                </>
                                                              } */}
                                                                  {values?.deliveries?.[index]?.invoices?.[idx]?.invoice_related_documents?.length > 0 ?
                                                                    <>
                                                                      {values.deliveries[index].invoices?.[idx].invoice_related_documents.map((item, docNo) => {
                                                                        return (
                                                                          <>
                                                                            {item.doc_type === 'invoice_no' ?
                                                                              <>
                                                                                <input
                                                                                  type="file"
                                                                                  accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                                                  onChange={(event) => {
                                                                                    if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                                                      setFieldValue(`deliveries[${index}].invoices[${idx}].invoice_copy`, event.currentTarget.files[0])
                                                                                      if (event.currentTarget.files[0]) {
                                                                                        setEnableInvoiceDoc(false)
                                                                                      }
                                                                                    } else {
                                                                                      setEnableInvoiceDoc(true)
                                                                                      cogoToast.error(INVALID_FILE_TYPE)
                                                                                    }
                                                                                  }}
                                                                                />
                                                                                <div className="d-flex align-items-center">
                                                                                  <Button
                                                                                    className="docsButton"
                                                                                    disabled={enableInvoiceDoc}
                                                                                    size="mini"
                                                                                    type="button"
                                                                                    onClick={() => {
                                                                                      uploadInvoices('invoice_no', values.deliveries[index].invoices[idx].invoice_copy, values.deliveries[index].invoices[idx].id)
                                                                                    }
                                                                                    }
                                                                                    basic
                                                                                    color="green"
                                                                                    icon
                                                                                  >
                                                                                    <Icon name="upload" />
                                                                                  </Button>
                                                                                  <Button
                                                                                    className="docsButton"
                                                                                    size="mini"
                                                                                    basic
                                                                                    type="button"
                                                                                    onClick={() => {
                                                                                      downloadInvoices('invoice_no', item.doc_key, values.deliveries[index].invoices[idx].id)

                                                                                    }
                                                                                    }
                                                                                    color="primary"
                                                                                    icon
                                                                                  >
                                                                                    <Icon name="download" />
                                                                                  </Button>
                                                                                  <Button
                                                                                    className="docsButton"
                                                                                    size="mini"
                                                                                    basic
                                                                                    type="button"
                                                                                    onClick={() => {
                                                                                      deleteInvoiceDocs('invoice_no', item.doc_key, values.deliveries[index].invoices[idx].id)
                                                                                      setEnableInvoiceDoc(true)
                                                                                    }
                                                                                    }
                                                                                    color="red"
                                                                                    icon
                                                                                  >
                                                                                    <Icon name="trash" />
                                                                                  </Button>
                                                                                  <div className="fileName">
                                                                                    {
                                                                                      item.doc_key.replace(/^.*(\\|\/|\:|-)/, '')
                                                                                    }
                                                                                  </div>
                                                                                  <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                                                </div>
                                                                              </>
                                                                              :
                                                                              <>
                                                                                {(item.doc_type.localeCompare('invoice_no') != 0 && (docNo == values.deliveries[index].invoices[idx].invoice_related_documents.length - 1) && values.deliveries[index].invoices[idx].invoice_related_documents.length <= 1)
                                                                                  ?
                                                                                  <>
                                                                                    <input
                                                                                      type="file"
                                                                                      accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                                                      onChange={(event) => {
                                                                                        if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                                                          setFieldValue(`deliveries[${index}].invoices[${idx}].invoice_copy`, event.currentTarget.files[0])
                                                                                          if (event.currentTarget.files[0]) {
                                                                                            setEnableInvoiceDoc(false)
                                                                                          }
                                                                                        } else {
                                                                                          setEnableInvoiceDoc(true)
                                                                                          cogoToast.error(INVALID_FILE_TYPE)
                                                                                        }
                                                                                      }}
                                                                                    />
                                                                                    <div className="d-flex align-items-center">
                                                                                      <Button
                                                                                        className="docsButton"
                                                                                        disabled={enableInvoiceDoc}
                                                                                        size="mini"
                                                                                        type="button"
                                                                                        onClick={() => {
                                                                                          uploadInvoices('invoice_no', values.deliveries[index].invoices[idx].invoice_copy, values.deliveries[index].invoices[idx].id)
                                                                                        }
                                                                                        }
                                                                                        basic
                                                                                        color="green"
                                                                                        icon
                                                                                      >
                                                                                        <Icon name="upload" />
                                                                                      </Button>
                                                                                      <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                                                    </div>
                                                                                  </>
                                                                                  :
                                                                                  null}
                                                                              </>}
                                                                          </>
                                                                        )
                                                                      })}
                                                                    </>
                                                                    :
                                                                    <>
                                                                      <input
                                                                        type="file"
                                                                        accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                                        onChange={(event) => {
                                                                          if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                                            setFieldValue(`deliveries[${index}].invoices[${idx}].invoice_copy`, event.currentTarget.files[0])
                                                                            if (event.currentTarget.files[0]) {
                                                                              setEnableInvoiceDoc(false)
                                                                            }
                                                                          } else {
                                                                            setEnableInvoiceDoc(true)
                                                                            cogoToast.error(INVALID_FILE_TYPE)
                                                                          }
                                                                        }}
                                                                      />
                                                                      <div className="d-flex align-items-center">
                                                                        <Button
                                                                          className="docsButton"
                                                                          disabled={enableInvoiceDoc}
                                                                          size="mini"
                                                                          type="button"
                                                                          onClick={() => {
                                                                            uploadInvoices('invoice_no', values.deliveries[index].invoices[idx].invoice_copy, values.deliveries[index].invoices[idx].id)
                                                                          }
                                                                          }
                                                                          basic
                                                                          color="green"
                                                                          icon
                                                                        >
                                                                          <Icon name="upload" />
                                                                        </Button>
                                                                        <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                                      </div>
                                                                    </>
                                                                  }
                                                                </Grid.Column>

                                                                <Grid.Column style={orderDetails} className="mt-2">
                                                                  <label>
                                                                    {
                                                                      "Eway Bill Copy"
                                                                    }
                                                                  </label>
                                                                  {values?.deliveries?.[index]?.invoices?.[idx]?.invoice_related_documents?.length > 0 ?
                                                                    <>
                                                                      {values.deliveries[index].invoices?.[idx].invoice_related_documents.map((item, docNo) => {
                                                                        return (
                                                                          <>
                                                                            {item.doc_type === 'eway_bill' ?
                                                                              <>

                                                                                <input
                                                                                  //name="daughter_invoice"
                                                                                  type="file"
                                                                                  accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                                                  onChange={(event) => {
                                                                                    if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                                                      setFieldValue(`deliveries[${index}].invoices[${idx}].eway_bill_copy`, event.currentTarget.files[0])
                                                                                      if (event.currentTarget.files[0]) {
                                                                                        setEnableEwayDoc(false)
                                                                                      }
                                                                                    } else {
                                                                                      setEnableEwayDoc(true)
                                                                                      cogoToast.error(INVALID_FILE_TYPE)
                                                                                    }
                                                                                  }}
                                                                                />
                                                                                <div className="d-flex align-items-center">
                                                                                  <Button
                                                                                    className="docsButton"
                                                                                    disabled={enableEwayDoc}
                                                                                    size="mini"
                                                                                    type="button"
                                                                                    onClick={() => {
                                                                                      uploadInvoices('eway_bill', values.deliveries[index].invoices[idx].eway_bill_copy, values.deliveries[index].invoices[idx].id)
                                                                                    }
                                                                                    }
                                                                                    basic
                                                                                    color="green"
                                                                                    icon
                                                                                  >
                                                                                    <Icon name="upload" />
                                                                                  </Button>
                                                                                  <Button
                                                                                    className="docsButton"
                                                                                    size="mini"
                                                                                    basic
                                                                                    type="button"
                                                                                    onClick={() => {
                                                                                      downloadInvoices('eway_bill', item.doc_key, values.deliveries[index].invoices[idx].id)

                                                                                    }
                                                                                    }
                                                                                    color="primary"
                                                                                    icon
                                                                                  >
                                                                                    <Icon name="download" />
                                                                                  </Button>
                                                                                  <Button
                                                                                    className="docsButton"
                                                                                    size="mini"
                                                                                    basic
                                                                                    type="button"
                                                                                    onClick={() => {
                                                                                      deleteInvoiceDocs('eway_bill', item.doc_key, values.deliveries[index].invoices[idx].id)
                                                                                      setEnableEwayDoc(true)
                                                                                    }
                                                                                    }
                                                                                    color="red"
                                                                                    icon
                                                                                  >
                                                                                    <Icon name="trash" />
                                                                                  </Button>
                                                                                  <div className="fileName">
                                                                                    {
                                                                                      item.doc_key.replace(/^.*(\\|\/|\:|-)/, '')
                                                                                    }
                                                                                  </div>
                                                                                  <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                                                </div>
                                                                              </>
                                                                              :
                                                                              <>
                                                                                {(item.doc_type.localeCompare('eway_bill') != 0 && (docNo == values.deliveries[index].invoices[idx].invoice_related_documents.length - 1) && values.deliveries[index].invoices[idx].invoice_related_documents.length <= 1)
                                                                                  ?
                                                                                  <>
                                                                                    <input type="file"
                                                                                      accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                                                      onChange={(event) => {
                                                                                        if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                                                          setFieldValue(`deliveries[${index}].invoices[${idx}].eway_bill_copy`, event.currentTarget.files[0])
                                                                                          if (event.currentTarget.files[0]) {
                                                                                            setEnableEwayDoc(false)
                                                                                          }
                                                                                        } else {
                                                                                          setEnableEwayDoc(true)
                                                                                          cogoToast.error(INVALID_FILE_TYPE)
                                                                                        }
                                                                                      }}
                                                                                    />
                                                                                    <div className="d-flex align-items-center">
                                                                                      <Button
                                                                                        className="docsButton"
                                                                                        disabled={enableEwayDoc}
                                                                                        size="mini"
                                                                                        type="button"
                                                                                        onClick={() => {
                                                                                          uploadInvoices('eway_bill', values.deliveries[index].invoices[idx].eway_bill_copy, values.deliveries[index].invoices[idx].id)
                                                                                        }
                                                                                        }
                                                                                        basic
                                                                                        color="green"
                                                                                        icon
                                                                                      >
                                                                                        <Icon name="upload" />
                                                                                      </Button>
                                                                                      <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                                                    </div>
                                                                                  </>
                                                                                  :
                                                                                  null}
                                                                              </>}
                                                                          </>
                                                                        )
                                                                      })}
                                                                    </>
                                                                    :
                                                                    <>
                                                                      <input
                                                                        type="file"
                                                                        accept="application/pdf ,image/jpeg,  image/jpg, image/png"
                                                                        onChange={(event) => {
                                                                          if ((event.currentTarget.files[0].type === "image/jpeg") || (event.currentTarget.files[0].type === "application/pdf") || (event.currentTarget.files[0].type === "image/png")) {
                                                                            setFieldValue(`deliveries[${index}].invoices[${idx}].eway_bill_copy`, event.currentTarget.files[0])
                                                                            if (event.currentTarget.files[0]) {
                                                                              setEnableEwayDoc(false)
                                                                            }
                                                                          } else {
                                                                            setEnableEwayDoc(true)
                                                                            cogoToast.error(INVALID_FILE_TYPE)
                                                                          }
                                                                        }}
                                                                      />
                                                                      <div className="d-flex align-items-center">
                                                                        <Button
                                                                          className="docsButton"
                                                                          disabled={enableEwayDoc}
                                                                          size="mini"
                                                                          type="button"
                                                                          onClick={() => {
                                                                            uploadInvoices('eway_bill', values.deliveries[index].invoices[idx].eway_bill_copy, values.deliveries[index].invoices[idx].id)
                                                                          }
                                                                          }
                                                                          basic
                                                                          color="green"
                                                                          icon
                                                                        >
                                                                          <Icon name="upload" />
                                                                        </Button>
                                                                        <div className="fileTypes" >{'.pdf .png .jpg'}</div>
                                                                      </div>
                                                                    </>
                                                                  }
                                                                </Grid.Column>
                                                              </Grid.Row>
                                                              <Grid.Row columns={3}>
                                                                {props.movement_type &&
                                                                  (props.movement_type ===
                                                                    "Import" ||
                                                                    props.movement_type ===
                                                                    "Importar" ||
                                                                    props.movement_type ===
                                                                    "Export") ? (
                                                                  <>
                                                                    <Grid.Column>
                                                                      <label>
                                                                        {t(
                                                                          "bl_no"
                                                                        ) ||
                                                                          "BL NO"}
                                                                      </label>

                                                                      <br />
                                                                      {item.bl_no ? (
                                                                        item.bl_no
                                                                      ) : (
                                                                        <>
                                                                          {values
                                                                            ?.deliveries?.[
                                                                            index
                                                                          ]
                                                                            ?.invoices?.[
                                                                            idx
                                                                          ]
                                                                            ?.addNewInvoice ? (
                                                                            <>
                                                                              <Field
                                                                                disabled={
                                                                                  !values
                                                                                    .deliveries[
                                                                                  index
                                                                                  ][
                                                                                  "active"
                                                                                  ]
                                                                                }
                                                                                name={`deliveries[${index}].invoices[${idx}].bl_no`}
                                                                                component={
                                                                                  MyInput
                                                                                }
                                                                              />
                                                                            </>
                                                                          ) : (
                                                                            "NA"
                                                                          )}
                                                                        </>
                                                                      )}
                                                                    </Grid.Column>
                                                                    <Grid.Column style={orderDetails}>
                                                                      <label>
                                                                        {t(
                                                                          "boe_no"
                                                                        ) ||
                                                                          "BoE NO"}
                                                                      </label>
                                                                      <br />
                                                                      <Field
                                                                        disabled={
                                                                          !values
                                                                            .deliveries[
                                                                          index
                                                                          ][
                                                                          "active"
                                                                          ]
                                                                        }
                                                                        name={`deliveries[${index}].invoices[${idx}].boe_no`}
                                                                        component={
                                                                          MyNormalInput
                                                                        }
                                                                      />
                                                                    </Grid.Column>
                                                                    <Grid.Column style={orderDetails}>
                                                                      <label>
                                                                        {t(
                                                                          "boe_date"
                                                                        ) ||
                                                                          "boe_date"}
                                                                      </label>

                                                                      <br />
                                                                      {!values
                                                                        .deliveries[
                                                                        index
                                                                      ][
                                                                        "active"
                                                                      ] ? (
                                                                        <>
                                                                          {values
                                                                            .deliveries[
                                                                            index
                                                                          ]
                                                                            .invoices[
                                                                            idx
                                                                          ].boe_date
                                                                            ? moment(
                                                                              values
                                                                                .deliveries[
                                                                                index
                                                                              ]
                                                                                .invoices[
                                                                                idx
                                                                              ]
                                                                                .boe_date
                                                                            ).format(
                                                                              "DD-MM-YYYY"
                                                                            )
                                                                            : "NA"}
                                                                        </>
                                                                      ) : (
                                                                        <DateData
                                                                          // style={{ width: "100% !important" }}
                                                                          name={`deliveries[${index}].invoices[${idx}].boe_date`}
                                                                          disabled={
                                                                            !values
                                                                              .deliveries[
                                                                            index
                                                                            ][
                                                                            "active"
                                                                            ]
                                                                          }
                                                                          autoComplete="off"
                                                                          // showTimeSelect
                                                                          //timeFormat="HH:mm"
                                                                          popperClassName="dateTime"
                                                                          dateFormat="dd/MM/yyyy"
                                                                          selected={
                                                                            new Date(
                                                                              values.deliveries[
                                                                                index
                                                                              ].invoices[
                                                                                idx
                                                                              ].boe_date
                                                                            )
                                                                          }
                                                                          timeIntervals={
                                                                            5
                                                                          }
                                                                          customInput={
                                                                            <Input
                                                                              icon="time"
                                                                              // className="dateWidth"
                                                                              iconPosition="left"
                                                                            />
                                                                          }
                                                                        />
                                                                        // null
                                                                      )}
                                                                    </Grid.Column>
                                                                  </>
                                                                ) : null}
                                                              </Grid.Row>
                                                            </Grid>
                                                          </Table.Body>
                                                        </Table>
                                                      </Table.Cell>
                                                    </Table.Row>
                                                  ) : null
                                              )}
                                              <Table.Row>
                                                <Table.Cell
                                                  colSpan="12"
                                                  className="text-left border-0"
                                                >
                                                  {values.deliveries[index][
                                                    "active"
                                                  ] &&
                                                    !(
                                                      (props?.currenOrder
                                                        ?.allotment_status &&
                                                        props?.currenOrder
                                                          ?.allotment_status
                                                          ?.allotment_code ==
                                                        "ALLOC") ||
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "CANCEL" ||
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "COMPLETE"
                                                    ) ? (
                                                    <Button
                                                      basic
                                                      color="blue"
                                                      className="m-2"
                                                      type="button"
                                                      onClick={() => {
                                                        invoiceDetails.push({
                                                          addNewInvoice: true,
                                                          invoice_id: null,
                                                          invoice_no: "",
                                                          bl_no: "",
                                                          invoice_date:
                                                            new Date(),
                                                          boe_date: "",
                                                          boe_no: "",
                                                          invoice_quantity: "",
                                                          invoice_amount: "",
                                                          tracking_number: "",
                                                          eway_bill_expirydate: new Date(),
                                                          eway_bill_no: ""
                                                        });
                                                      }}
                                                      size="mini"
                                                    >
                                                      {" "}
                                                      {props.t(
                                                        "action_button.add_more_invoice"
                                                      ) ||
                                                        "Add More Invoices"}{" "}
                                                    </Button>
                                                  ) : null}
                                                </Table.Cell>
                                              </Table.Row>
                                            </>
                                          )}
                                        />

                                        <FieldArray
                                          name={`deliveries.[${index}].products`}
                                          render={(productDetails) => (
                                            <>
                                              {values.deliveries[
                                                index
                                              ].products.map((o, i) => (
                                                <>
                                                  <Table.Row
                                                    key={`products+${i}`}
                                                  >
                                                    <TableHeaderCell colSpan="8">
                                                      <div>
                                                        {t("product_title") ||
                                                          "Product"}{" "}
                                                        {i + 1}
                                                      </div>
                                                    </TableHeaderCell>
                                                    <TableHeaderCell
                                                      colSpan="2"
                                                      className="text-right"
                                                    >
                                                      <div>
                                                        {values?.deliveries?.[
                                                          index
                                                        ]?.products?.[i]
                                                          ?.addNewProduct ? (
                                                          <>
                                                            <Button
                                                              basic
                                                              color="red"
                                                              type="button"
                                                              onClick={() =>
                                                                productDetails.remove(
                                                                  i
                                                                )
                                                              }
                                                              size="mini"
                                                              icon
                                                            >
                                                              {" "}
                                                              <Icon
                                                                name="trash"
                                                                color="red"
                                                              />{" "}
                                                            </Button>
                                                            <Button
                                                              basic
                                                              color="green"
                                                              type="button"
                                                              onClick={(e) => {
                                                                e.stopPropagation();
                                                                saveAddedProduct(
                                                                  values
                                                                    .deliveries[
                                                                    index
                                                                  ].products[i],
                                                                  values
                                                                    .deliveries[
                                                                    index
                                                                  ].delivery_id
                                                                );
                                                              }}
                                                              size="mini"
                                                              icon
                                                            >
                                                              {" "}
                                                              <Icon name="save" />{" "}
                                                            </Button>
                                                          </>
                                                        ) : (
                                                          <></>
                                                        )}
                                                      </div>
                                                    </TableHeaderCell>
                                                  </Table.Row>
                                                  <Table.Row>


                                                    <Table.Cell>
                                                      <Header
                                                        className="p-bold-200 labelName"
                                                        size="tiny"
                                                        as="label"
                                                        color="grey"
                                                      >
                                                        {t("product_name") ||
                                                          "Product Name"}
                                                      </Header>
                                                    </Table.Cell>
                                                    <Table.Cell colSpan="3">
                                                      <Header
                                                        className="p-bold-500 labelName"
                                                        size="tiny"
                                                        as="label"
                                                        color="black"
                                                      >
                                                        {values.deliveries[
                                                          index
                                                        ].products.length > 0 &&
                                                          values.deliveries[index]
                                                            .products[i].sku !=
                                                          null ? (
                                                          <Field
                                                            disabled={
                                                              !values
                                                                .deliveries[
                                                              index
                                                              ]["active"]
                                                            }
                                                            name={`deliveries[${index}].products[${i}].sku.product_name`}
                                                            categoryFieldName={`deliveries[${index}].products[${i}].product_category_id`}
                                                            categoryKeyName={`deliveries[${index}].products[${i}].product_category_name`}
                                                            codeFieldName={`deliveries[${index}].products[${i}].sku.product_code`}
                                                            value={
                                                              values.deliveries[
                                                                index
                                                              ].products[i].sku
                                                                .product_name
                                                            }
                                                            defOption={
                                                              {
                                                                value: values.deliveries[index]
                                                                  ?.products[i]?.sku?.product_name,
                                                                key: values.deliveries[index]
                                                                  ?.products[i]?.sku?.product_name,
                                                                text: values.deliveries[index]
                                                                  ?.products[i]?.sku?.product_name,
                                                              }
                                                            }
                                                            component={
                                                              MySKU
                                                            }
                                                          />
                                                        ) : (
                                                          <>
                                                            {values
                                                              ?.deliveries?.[
                                                              index
                                                            ]?.products?.[i]
                                                              ?.addNewProduct ? (
                                                              <>
                                                                <Field
                                                                  disabled={
                                                                    !values
                                                                      .deliveries[
                                                                      index
                                                                    ]["active"] ? true : false
                                                                  }
                                                                  name={`deliveries[${index}].products[${i}].product_name`}
                                                                  categoryFieldName={`deliveries[${index}].products[${i}].product_category_id`}
                                                                  categoryKeyName={`deliveries[${index}].products[${i}].product_category_name`}
                                                                  codeFieldName={`deliveries[${index}].products[${i}].sku.product_code`}
                                                                  value={
                                                                    values
                                                                      .deliveries[
                                                                      index
                                                                    ].products[
                                                                      i
                                                                    ]
                                                                      .product_name
                                                                  }
                                                                  component={
                                                                    MySKU
                                                                  }
                                                                />
                                                              </>
                                                            ) : (
                                                              "NA"
                                                            )}
                                                          </>
                                                        )}
                                                      </Header>
                                                    </Table.Cell>

                                                    {!FEATURES.createOrderhideFields &&
                                                      (props.movement_type ===
                                                        "Primary" ||
                                                        props.movement_type ==
                                                        "Primário") ? (
                                                      <>
                                                        <Table.Cell>
                                                          <Header
                                                            className="p-bold-200 labelName"
                                                            size="tiny"
                                                            as="label"
                                                            color="grey"
                                                          >
                                                            {t(
                                                              "product_category"
                                                            ) ||
                                                              "Product Catogery"}
                                                          </Header>
                                                        </Table.Cell>
                                                        <Table.Cell colSpan="3">
                                                          <Header
                                                            className="p-bold-500 labelName"
                                                            size="tiny"
                                                            as="label"
                                                            color="black"
                                                          >
                                                            <Field
                                                              disabled
                                                              name={`deliveries[${index}].products[${i}].product_category_id`}
                                                              value={
                                                                values
                                                                  .deliveries[
                                                                  index
                                                                ].products[i]
                                                                  .product_category_name || 'some name'
                                                              }
                                                              component={
                                                                MyNormalInput
                                                              }
                                                            />
                                                          </Header>
                                                        </Table.Cell>
                                                      </>
                                                    ) : null}
                                                    <Table.Cell>
                                                      <Header
                                                        className="p-bold-200 labelName"
                                                        size="tiny"
                                                        as="label"
                                                        color="grey"
                                                      >
                                                        {t("product_code") ||
                                                          "Product Code"}
                                                      </Header>
                                                    </Table.Cell>
                                                    <Table.Cell colSpan="3">
                                                      <Header
                                                        className="p-bold-500 labelName"
                                                        size="tiny"
                                                        as="label"
                                                        color="black"
                                                      >
                                                        {values.deliveries[
                                                          index
                                                        ].products.length > 0 &&
                                                          values.deliveries[index]
                                                            .products[i].sku !=
                                                          null ? (
                                                          <Field
                                                            // disabled={
                                                            //   !values
                                                            //     .deliveries[
                                                            //   index
                                                            //   ]["active"]
                                                            // }
                                                            disabled
                                                            name={`deliveries[${index}].products[${i}].sku.product_code`}
                                                            value={
                                                              values.deliveries[
                                                                index
                                                              ].products[i].sku
                                                                .product_code
                                                            }
                                                            setName={`deliveries[${index}].products[${i}].sku.product_name`}
                                                            component={
                                                              MyNormalInput}
                                                          />
                                                        ) : (
                                                          <>
                                                            {values
                                                              ?.deliveries?.[
                                                              index
                                                            ]?.products?.[i]
                                                              ?.addNewProduct ? (
                                                              <>
                                                                <Field
                                                                  disabled={
                                                                    !values
                                                                      .deliveries[
                                                                    index
                                                                    ]["active"]
                                                                  }
                                                                  name={`deliveries[${index}].products[${i}].product_code`}
                                                                  value={
                                                                    values
                                                                      .deliveries[
                                                                      index
                                                                    ].products[
                                                                      i
                                                                    ]
                                                                      .product_code
                                                                  }
                                                                  setName={`deliveries[${index}].products[${i}].product_name`}
                                                                  component={
                                                                    MyNormalInput
                                                                  }
                                                                />
                                                              </>
                                                            ) : (
                                                              "NA"
                                                            )}
                                                          </>
                                                        )}
                                                      </Header>
                                                    </Table.Cell>
                                                  </Table.Row>
                                                  <Table.Row>
                                                    <Table.Cell>
                                                      <Header
                                                        className="p-bold-200 labelName"
                                                        size="tiny"
                                                        as="label"
                                                        color="grey"
                                                      >
                                                        {t("quantity") ||
                                                          "Quantity"}
                                                      </Header>
                                                    </Table.Cell>
                                                    <Table.Cell colSpan="3">
                                                      <Header
                                                        className="p-bold-500 labelName"
                                                        size="tiny"
                                                        as="label"
                                                        color="black"
                                                      >
                                                        <Field
                                                          disabled={
                                                            !values.deliveries[
                                                            index
                                                            ]["active"]
                                                          }
                                                          name={`deliveries[${index}].products[${i}].quantity`}
                                                          type="number"
                                                          component={
                                                            MyNormalInput
                                                          }
                                                          onBlur={(
                                                            name,
                                                            value
                                                          ) => {
                                                            setFieldValue(
                                                              `deliveries[${index}].total_quantity`, getCounts(values.deliveries[index].products)
                                                            );
                                                            if (
                                                              values.deliveries[index].uom_name && 
                                                              (values.deliveries[index].uom_name.toUpperCase() == "CFT" ||
                                                              values.deliveries[index].uom_name.toUpperCase() == "PER CFT KG")
                                                            ) {
                                                              let multiplyFactor = 0,
                                                                actualValue = 0;
                                                              let tempVolume = 0;
                                                              let actualFreightValue =
                                                                values
                                                                  ?.deliveries?.[
                                                                  index
                                                                ]
                                                                  ?.actual_freight_rate;

                                                              for (
                                                                let indx = 0;
                                                                indx <
                                                                values
                                                                  .deliveries[
                                                                  index
                                                                ].products
                                                                  .length;
                                                                indx++
                                                              ) {
                                                                if (
                                                                  values
                                                                    ?.deliveries?.[
                                                                    index
                                                                  ]?.products[
                                                                    indx
                                                                  ].quantity &&
                                                                  values
                                                                    ?.deliveries?.[
                                                                    index
                                                                  ]?.products[
                                                                    indx
                                                                  ].length &&
                                                                  values
                                                                    ?.deliveries?.[
                                                                    index
                                                                  ]?.products[
                                                                    indx
                                                                  ].breadth &&
                                                                  values
                                                                    ?.deliveries?.[
                                                                    index
                                                                  ]?.products[
                                                                    indx
                                                                  ].height
                                                                ) {
                                                                  tempVolume =
                                                                    tempVolume +
                                                                    values
                                                                      .deliveries[
                                                                      index
                                                                    ].products[
                                                                      indx
                                                                    ].quantity *
                                                                    values
                                                                      .deliveries[
                                                                      index
                                                                    ]
                                                                      .products[
                                                                      indx
                                                                    ].length *
                                                                    values
                                                                      .deliveries[
                                                                      index
                                                                    ]
                                                                      .products[
                                                                      indx
                                                                    ]
                                                                      .breadth *
                                                                    values
                                                                      ?.deliveries[
                                                                      index
                                                                    ]
                                                                      .products[
                                                                      indx
                                                                    ].height;
                                                                }
                                                              }

                                                              if (
                                                                values.deliveries[index].uom_name &&
                                                              values.deliveries[index].uom_name.toUpperCase() == "PER CFT KG" &&
                                                                values
                                                                  ?.deliveries?.[
                                                                  index
                                                                ]
                                                                  ?.cft_kg_factor &&
                                                                values
                                                                  .deliveries[
                                                                  index
                                                                ]
                                                                  .cft_kg_factor >
                                                                0
                                                              ) {
                                                                multiplyFactor =
                                                                  tempVolume *
                                                                  +values
                                                                    .deliveries[
                                                                    index
                                                                  ]
                                                                    .cft_kg_factor;
                                                                setFieldValue(
                                                                  `deliveries[${index}].charged_weight`,
                                                                  multiplyFactor
                                                                );
                                                              } else {
                                                                multiplyFactor =
                                                                  tempVolume;
                                                              }

                                                              actualValue =
                                                                multiplyFactor *
                                                                actualFreightValue;
                                                              setFieldValue(
                                                                `deliveries[${index}].final_freight_rate`,
                                                                actualValue
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      </Header>
                                                    </Table.Cell>
                                                    {!FEATURES.createOrderhideFields &&
                                                      (props.movement_type ===
                                                        "Primary" ||
                                                        props.movement_type ==
                                                        "Primário") ? (
                                                      <>
                                                        <Table.Cell>
                                                          <Header
                                                            className="p-bold-200 labelName"
                                                            size="tiny"
                                                            as="label"
                                                            color="grey"
                                                          >
                                                            {t(
                                                              "packaging_type"
                                                            ) ||
                                                              "Packaging Type"}
                                                          </Header>
                                                        </Table.Cell>
                                                        <Table.Cell colSpan="3">
                                                          <Header
                                                            className="p-bold-500 labelName"
                                                            size="tiny"
                                                            as="label"
                                                            color="black"
                                                          >
                                                            <Field
                                                              disabled={
                                                                !values
                                                                  .deliveries[
                                                                index
                                                                ]["active"]
                                                              }
                                                              name={`deliveries[${index}].products[${i}].packaging_type_id`}
                                                              value={
                                                                values
                                                                  .deliveries[
                                                                  index
                                                                ].products[i]
                                                                  .packaging_type_id
                                                              }
                                                              component={
                                                                MyPackagingType
                                                              }
                                                            />
                                                          </Header>
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                          <Header
                                                            className="p-bold-200 labelName"
                                                            size="tiny"
                                                            as="label"
                                                            color="grey"
                                                          >
                                                            {t(
                                                              "invoice_code"
                                                            ) || "Invoice No"}
                                                          </Header>
                                                        </Table.Cell>
                                                        <Table.Cell colSpan="3">
                                                          <Header
                                                            className="p-bold-500 labelName"
                                                            size="tiny"
                                                            as="label"
                                                            color="black"
                                                          >
                                                            <Field
                                                              disabled={
                                                                !values
                                                                  .deliveries[
                                                                index
                                                                ]["active"]
                                                              }
                                                              name={`deliveries[${index}].products[${i}].invoice_no`}
                                                              value={
                                                                values
                                                                  .deliveries[
                                                                  index
                                                                ].products[i]
                                                                  .invoice_no
                                                              }
                                                              component={
                                                                MyNormalInput
                                                              }
                                                            />
                                                          </Header>
                                                        </Table.Cell>
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </Table.Row>

                                                  {
                                                    FEATURES.transactionDetailsEnabled &&
                                                    <>
                                                    <Table.Row>
                                                    <Table.Cell>
                                                      <Header
                                                        className="p-bold-200 labelName"
                                                        size="tiny"
                                                        as="label"
                                                        color="grey"
                                                      >
                                                        {t("transaction_amount") ||
                                                          "Transaction Amount"}
                                                      </Header>
                                                    </Table.Cell>
                                                    <Table.Cell colSpan="3">
                                                      <Header
                                                        className="p-bold-500 labelName"
                                                        size="tiny"
                                                        as="label"
                                                        color="black"
                                                      >
                                                        <Field
                                                          disabled={
                                                            !values.deliveries[
                                                            index
                                                            ]["active"]
                                                          }
                                                          name={`deliveries[${index}].products[${i}].transaction_amount`}
                                                          value={values.deliveries[index].products[i].transaction_amount}
                                                          type="number"
                                                          component={
                                                            MyNormalInput
                                                          }
                                                        />
                                                      </Header>
                                                    </Table.Cell>

                                                    <Table.Cell>
                                                      <Header
                                                        className="p-bold-200 labelName"
                                                        size="tiny"
                                                        as="label"
                                                        color="grey"
                                                      >
                                                        {t("transaction_quantity") ||
                                                          "Transaction Quantity"}
                                                      </Header>
                                                    </Table.Cell>
                                                    <Table.Cell colSpan="3">
                                                      <Header
                                                        className="p-bold-500 labelName"
                                                        size="tiny"
                                                        as="label"
                                                        color="black"
                                                      >
                                                        <Field
                                                          disabled={
                                                            !values.deliveries[
                                                            index
                                                            ]["active"]
                                                          }
                                                          name={`deliveries[${index}].products[${i}].transaction_quantity`}
                                                          value={values.deliveries[index].products[i].transaction_quantity}
                                                          type="number"
                                                          component={
                                                            MyNormalInput
                                                          }
                                                        />
                                                      </Header>
                                                    </Table.Cell>
                                                  </Table.Row>
                                                    </>
                                                  }

                                                  <Table.Row>
                                                    <Table.Cell>
                                                      <Header
                                                        className="p-bold-200 labelName"
                                                        size="tiny"
                                                        as="label"
                                                        color="grey"
                                                      >
                                                        {t("product_serial_no") ||
                                                          "Product Serial Number"}
                                                      </Header>
                                                    </Table.Cell>
                                                    <Table.Cell colSpan="3">
                                                      <Header
                                                        className="p-bold-500 labelName"
                                                        size="tiny"
                                                        as="label"
                                                        color="black"
                                                      >
                                                        <Field
                                                          disabled={!values.deliveries[
                                                            index
                                                            ]["active"] || 
                                                            (getCurrentOrderDetails.deliveries[index]?.products[i]?.sku_serial_no ? true :false)}
                                                          name={`deliveries[${index}].products[${i}].sku_serial_no`}
                                                          value={values.deliveries[index].products[i].sku_serial_no}
                                                          component={
                                                            MyNormalInput
                                                          }
                                                        />
                                                      </Header>
                                                    </Table.Cell>
                                                  </Table.Row>
                                                  {values.service_type_id ==
                                                    2 ||
                                                    values.deliveries[index].uom_name && 
                                                    (values.deliveries[index].uom_name.toUpperCase() == "CFT" ||
                                                    values.deliveries[index].uom_name.toUpperCase() == "PER CFT KG") ? (
                                                    <Table.Row>
                                                      <>
                                                        <Table.Cell colSpan="2">
                                                          <Header
                                                            className="p-bold-500 labelName"
                                                            size="tiny"
                                                            as="label"
                                                            color="grey"
                                                          >
                                                            {t("length") ||
                                                              "Length"}
                                                          </Header>
                                                        </Table.Cell>
                                                        <Table.Cell colSpan="2">
                                                          <Header
                                                            className="p-bold-500 labelName"
                                                            size="tiny"
                                                            as="label"
                                                            color="grey"
                                                          >
                                                            {!values.deliveries[
                                                              index
                                                            ]["active"] ? (
                                                              <>
                                                                {values
                                                                  .deliveries[
                                                                  index
                                                                ].products[i][
                                                                  "length"
                                                                ]
                                                                  ? values
                                                                    .deliveries[
                                                                    index
                                                                  ].products[
                                                                  i
                                                                  ]["length"]
                                                                  : 0}
                                                              </>
                                                            ) : (
                                                              <Input
                                                                //component={MyNumInput}
                                                                style={{
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                }}
                                                                type="number"
                                                                name={`deliveries[${index}].products[${i}].length`}
                                                                value={
                                                                  values
                                                                    .deliveries[
                                                                    index
                                                                  ].products[i][
                                                                  "length"
                                                                  ]
                                                                }
                                                                onBlur={(
                                                                  name,
                                                                  value
                                                                ) => {
                                                                  if (
                                                                    values.deliveries[index].uom_name && 
                                                                    (values.deliveries[index].uom_name.toUpperCase() == "CFT" ||
                                                                    values.deliveries[index].uom_name.toUpperCase() == "PER CFT KG")
                                                                  ) {
                                                                    let multiplyFactor = 0,
                                                                      actualValue = 0;
                                                                    let tempVolume = 0;
                                                                    let actualFreightValue =
                                                                      values
                                                                        ?.deliveries?.[
                                                                        index
                                                                      ]
                                                                        ?.actual_freight_rate;

                                                                    for (
                                                                      let indx = 0;
                                                                      indx <
                                                                      values
                                                                        .deliveries[
                                                                        index
                                                                      ].products
                                                                        .length;
                                                                      indx++
                                                                    ) {
                                                                      if (
                                                                        values
                                                                          ?.deliveries?.[
                                                                          index
                                                                        ]
                                                                          ?.products[
                                                                          indx
                                                                        ]
                                                                          .quantity &&
                                                                        values
                                                                          ?.deliveries?.[
                                                                          index
                                                                        ]
                                                                          ?.products[
                                                                          indx
                                                                        ]
                                                                          .length &&
                                                                        values
                                                                          ?.deliveries?.[
                                                                          index
                                                                        ]
                                                                          ?.products[
                                                                          indx
                                                                        ]
                                                                          .breadth &&
                                                                        values
                                                                          ?.deliveries?.[
                                                                          index
                                                                        ]
                                                                          ?.products[
                                                                          indx
                                                                        ].height
                                                                      ) {
                                                                        tempVolume =
                                                                          tempVolume +
                                                                          values
                                                                            .deliveries[
                                                                            index
                                                                          ]
                                                                            .products[
                                                                            indx
                                                                          ]
                                                                            .quantity *
                                                                          values
                                                                            .deliveries[
                                                                            index
                                                                          ]
                                                                            .products[
                                                                            indx
                                                                          ]
                                                                            .length *
                                                                          values
                                                                            .deliveries[
                                                                            index
                                                                          ]
                                                                            .products[
                                                                            indx
                                                                          ]
                                                                            .breadth *
                                                                          values
                                                                            ?.deliveries[
                                                                            index
                                                                          ]
                                                                            .products[
                                                                            indx
                                                                          ]
                                                                            .height;
                                                                      }
                                                                    }

                                                                    if (
                                                                      values.deliveries[index].uom_name && 
                                                                      values.deliveries[index].uom_name.toUpperCase() == "PER CFT KG" &&
                                                                      values
                                                                        ?.deliveries?.[
                                                                        index
                                                                      ]
                                                                        ?.cft_kg_factor &&
                                                                      values
                                                                        .deliveries[
                                                                        index
                                                                      ]
                                                                        .cft_kg_factor >
                                                                      0
                                                                    ) {
                                                                      multiplyFactor =
                                                                        tempVolume *
                                                                        +values
                                                                          .deliveries[
                                                                          index
                                                                        ]
                                                                          .cft_kg_factor;
                                                                      setFieldValue(
                                                                        `deliveries[${index}].charged_weight`,
                                                                        multiplyFactor
                                                                      );
                                                                    } else {
                                                                      multiplyFactor =
                                                                        tempVolume;
                                                                    }

                                                                    actualValue =
                                                                      multiplyFactor *
                                                                      actualFreightValue;
                                                                    setFieldValue(
                                                                      `deliveries[${index}].final_freight_rate`,
                                                                      actualValue
                                                                    );
                                                                  }
                                                                }}
                                                                onChange={(
                                                                  value,
                                                                  data
                                                                ) => {
                                                                  setFieldValue(
                                                                    `deliveries[${index}].products[${i}].length`,
                                                                    data.value
                                                                  );
                                                                }}
                                                              />
                                                            )}
                                                          </Header>
                                                        </Table.Cell>
                                                        <Table.Cell colSpan="2">
                                                          <Header
                                                            className="p-bold-500 labelName"
                                                            size="tiny"
                                                            as="label"
                                                            color="grey"
                                                          >
                                                            {t("breadth") ||
                                                              "Breadth"}
                                                          </Header>
                                                        </Table.Cell>
                                                        <Table.Cell colSpan="2">
                                                          <Header
                                                            className="p-bold-500 labelName"
                                                            size="tiny"
                                                            as="label"
                                                            color="grey"
                                                          >
                                                            {!values.deliveries[
                                                              index
                                                            ]["active"] ? (
                                                              <>
                                                                {values
                                                                  .deliveries[
                                                                  index
                                                                ].products[i]
                                                                  .breadth
                                                                  ? values
                                                                    .deliveries[
                                                                    index
                                                                  ].products[
                                                                    i
                                                                  ].breadth
                                                                  : 0}
                                                              </>
                                                            ) : (
                                                              <Input
                                                                //component={MyNumInput}
                                                                style={{
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                }}
                                                                type="number"
                                                                name={`deliveries[${index}].products[${i}].breadth`}
                                                                value={
                                                                  values
                                                                    .deliveries[
                                                                    index
                                                                  ].products[i]
                                                                    .breadth
                                                                }
                                                                onBlur={(
                                                                  name,
                                                                  value
                                                                ) => {
                                                                  if (
                                                                    values.deliveries[index].uom_name && 
                                                                    (values.deliveries[index].uom_name.toUpperCase() == "CFT" ||
                                                                    values.deliveries[index].uom_name.toUpperCase() == "PER CFT KG")
                                                                  ) {
                                                                    let multiplyFactor = 0,
                                                                      actualValue = 0;
                                                                    let tempVolume = 0;
                                                                    let actualFreightValue =
                                                                      values
                                                                        ?.deliveries?.[
                                                                        index
                                                                      ]
                                                                        ?.actual_freight_rate;

                                                                    for (
                                                                      let indx = 0;
                                                                      indx <
                                                                      values
                                                                        .deliveries[
                                                                        index
                                                                      ].products
                                                                        .length;
                                                                      indx++
                                                                    ) {
                                                                      if (
                                                                        values
                                                                          ?.deliveries?.[
                                                                          index
                                                                        ]
                                                                          ?.products[
                                                                          indx
                                                                        ]
                                                                          .quantity &&
                                                                        values
                                                                          ?.deliveries?.[
                                                                          index
                                                                        ]
                                                                          ?.products[
                                                                          indx
                                                                        ]
                                                                          .length &&
                                                                        values
                                                                          ?.deliveries?.[
                                                                          index
                                                                        ]
                                                                          ?.products[
                                                                          indx
                                                                        ]
                                                                          .breadth &&
                                                                        values
                                                                          ?.deliveries?.[
                                                                          index
                                                                        ]
                                                                          ?.products[
                                                                          indx
                                                                        ].height
                                                                      ) {
                                                                        tempVolume =
                                                                          tempVolume +
                                                                          values
                                                                            .deliveries[
                                                                            index
                                                                          ]
                                                                            .products[
                                                                            indx
                                                                          ]
                                                                            .quantity *
                                                                          values
                                                                            .deliveries[
                                                                            index
                                                                          ]
                                                                            .products[
                                                                            indx
                                                                          ]
                                                                            .length *
                                                                          values
                                                                            .deliveries[
                                                                            index
                                                                          ]
                                                                            .products[
                                                                            indx
                                                                          ]
                                                                            .breadth *
                                                                          values
                                                                            ?.deliveries[
                                                                            index
                                                                          ]
                                                                            .products[
                                                                            indx
                                                                          ]
                                                                            .height;
                                                                      }
                                                                    }

                                                                    if (
                                                                      values.deliveries[index].uom_name && 
                                                                      values.deliveries[index].uom_name.toUpperCase() == "PER CFT KG" &&
                                                                      values
                                                                        ?.deliveries?.[
                                                                        index
                                                                      ]
                                                                        ?.cft_kg_factor &&
                                                                      values
                                                                        .deliveries[
                                                                        index
                                                                      ]
                                                                        .cft_kg_factor >
                                                                      0
                                                                    ) {
                                                                      multiplyFactor =
                                                                        tempVolume *
                                                                        +values
                                                                          .deliveries[
                                                                          index
                                                                        ]
                                                                          .cft_kg_factor;
                                                                      setFieldValue(
                                                                        `deliveries[${index}].charged_weight`,
                                                                        multiplyFactor
                                                                      );
                                                                    } else {
                                                                      multiplyFactor =
                                                                        tempVolume;
                                                                    }

                                                                    actualValue =
                                                                      multiplyFactor *
                                                                      actualFreightValue;
                                                                    setFieldValue(
                                                                      `deliveries[${index}].final_freight_rate`,
                                                                      actualValue
                                                                    );
                                                                  }
                                                                }}
                                                                onChange={(
                                                                  value,
                                                                  data
                                                                ) => {
                                                                  setFieldValue(
                                                                    `deliveries[${index}].products[${i}].breadth`,
                                                                    data.value
                                                                  );
                                                                }}
                                                              />
                                                            )}
                                                          </Header>
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                          <Header
                                                            className="p-bold-500 labelName"
                                                            size="tiny"
                                                            as="label"
                                                            color="grey"
                                                          >
                                                            {t("height") ||
                                                              "Height"}
                                                          </Header>
                                                        </Table.Cell>
                                                        <Table.Cell colSpan="3">
                                                          <Header
                                                            className="p-bold-500 labelName"
                                                            size="tiny"
                                                            as="label"
                                                            color="grey"
                                                          >
                                                            {!values.deliveries[
                                                              index
                                                            ]["active"] ? (
                                                              <>
                                                                {values
                                                                  .deliveries[
                                                                  index
                                                                ].products[i]
                                                                  .height
                                                                  ? values
                                                                    .deliveries[
                                                                    index
                                                                  ].products[
                                                                    i
                                                                  ].height
                                                                  : 0}
                                                              </>
                                                            ) : (
                                                              <Input
                                                                //component={MyNumInput}
                                                                style={{
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                }}
                                                                type="number"
                                                                name={`deliveries[${index}].products[${i}].height`}
                                                                value={
                                                                  values
                                                                    .deliveries[
                                                                    index
                                                                  ].products[i]
                                                                    .height
                                                                }
                                                                onBlur={(
                                                                  name,
                                                                  value
                                                                ) => {
                                                                  if (
                                                                    values.deliveries[index].uom_name && 
                                                                    (values.deliveries[index].uom_name.toUpperCase() == "CFT" ||
                                                                    values.deliveries[index].uom_name.toUpperCase() == "PER CFT KG")
                                                                  ) {
                                                                    let multiplyFactor = 0,
                                                                      actualValue = 0;
                                                                    let tempVolume = 0;
                                                                    let actualFreightValue =
                                                                      values
                                                                        ?.deliveries?.[
                                                                        index
                                                                      ]
                                                                        ?.actual_freight_rate;

                                                                    for (
                                                                      let indx = 0;
                                                                      indx <
                                                                      values
                                                                        .deliveries[
                                                                        index
                                                                      ].products
                                                                        .length;
                                                                      indx++
                                                                    ) {
                                                                      if (
                                                                        values
                                                                          ?.deliveries?.[
                                                                          index
                                                                        ]
                                                                          ?.products[
                                                                          indx
                                                                        ]
                                                                          .quantity &&
                                                                        values
                                                                          ?.deliveries?.[
                                                                          index
                                                                        ]
                                                                          ?.products[
                                                                          indx
                                                                        ]
                                                                          .length &&
                                                                        values
                                                                          ?.deliveries?.[
                                                                          index
                                                                        ]
                                                                          ?.products[
                                                                          indx
                                                                        ]
                                                                          .breadth &&
                                                                        values
                                                                          ?.deliveries?.[
                                                                          index
                                                                        ]
                                                                          ?.products[
                                                                          indx
                                                                        ].height
                                                                      ) {
                                                                        tempVolume =
                                                                          tempVolume +
                                                                          values
                                                                            .deliveries[
                                                                            index
                                                                          ]
                                                                            .products[
                                                                            indx
                                                                          ]
                                                                            .quantity *
                                                                          values
                                                                            .deliveries[
                                                                            index
                                                                          ]
                                                                            .products[
                                                                            indx
                                                                          ]
                                                                            .length *
                                                                          values
                                                                            .deliveries[
                                                                            index
                                                                          ]
                                                                            .products[
                                                                            indx
                                                                          ]
                                                                            .breadth *
                                                                          values
                                                                            ?.deliveries[
                                                                            index
                                                                          ]
                                                                            .products[
                                                                            indx
                                                                          ]
                                                                            .height;
                                                                      }
                                                                    }

                                                                    if (
                                                                      values.deliveries[index].uom_name &&
                                                                      values.deliveries[index].uom_name.toUpperCase() == "PER CFT KG" &&
                                                                      values
                                                                        ?.deliveries?.[
                                                                        index
                                                                      ]
                                                                        ?.cft_kg_factor &&
                                                                      values
                                                                        .deliveries[
                                                                        index
                                                                      ]
                                                                        .cft_kg_factor >
                                                                      0
                                                                    ) {
                                                                      multiplyFactor =
                                                                        tempVolume *
                                                                        +values
                                                                          .deliveries[
                                                                          index
                                                                        ]
                                                                          .cft_kg_factor;
                                                                      setFieldValue(
                                                                        `deliveries[${index}].charged_weight`,
                                                                        multiplyFactor
                                                                      );
                                                                    } else {
                                                                      multiplyFactor =
                                                                        tempVolume;
                                                                    }

                                                                    actualValue =
                                                                      multiplyFactor *
                                                                      actualFreightValue;
                                                                    setFieldValue(
                                                                      `deliveries[${index}].final_freight_rate`,
                                                                      actualValue
                                                                    );
                                                                  }
                                                                }}
                                                                onChange={(
                                                                  value,
                                                                  data
                                                                ) => {
                                                                  setFieldValue(
                                                                    `deliveries[${index}].products[${i}].height`,
                                                                    data.value
                                                                  );
                                                                }}
                                                              />
                                                            )}
                                                          </Header>
                                                        </Table.Cell>
                                                      </>
                                                    </Table.Row>
                                                  ) : (
                                                    ""
                                                  )}
                                                </>
                                              ))}
                                              <Table.Row>
                                                <TableHeaderCell
                                                  colSpan="10"
                                                  className="text-left"
                                                >
                                                  {values.deliveries[index][
                                                    "active"
                                                  ] &&
                                                    !(
                                                      (props?.currenOrder
                                                        ?.allotment_status &&
                                                        props?.currenOrder
                                                          ?.allotment_status
                                                          ?.allotment_code ==
                                                        "ALLOC") ||
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "CANCEL" ||
                                                      props?.currenOrder
                                                        ?.allotment_status
                                                        ?.allotment_code ==
                                                      "COMPLETE"
                                                    ) ? (
                                                    <div>
                                                      <Button
                                                        basic
                                                        color="blue"
                                                        className="m-2"
                                                        type="button"
                                                        onClick={() => {
                                                          productDetails.push({
                                                            product_code: "",
                                                            quantity: "",
                                                            invoice_no: "",
                                                            product_category_id:
                                                              "",
                                                            product_id: null,
                                                            product_name: "",
                                                            packaging_type_id:
                                                              "",
                                                            length: null,
                                                            breadth: null,
                                                            height: null,
                                                            addNewProduct: true,
                                                          });
                                                        }}
                                                        size="mini"
                                                      >
                                                        {" "}
                                                        {props.t(
                                                          "action_button.add_more_product"
                                                        ) ||
                                                          "Add More Product"}{" "}
                                                      </Button>
                                                    </div>
                                                  ) : null}
                                                </TableHeaderCell>
                                              </Table.Row>
                                            </>
                                          )}
                                        />


                                      </Table.Body>
                                    </Table>

                                  </Grid.Row >
                                ))
                                }
                              </>
                            )}
                          />
                        </Grid >
                      </div >
                    </>
                    <Modal
                      onClose={() => setQuantityModal(false)}
                      onOpen={() => setQuantityModal(true)}
                      open={quantityModal}
                    >
                      <Modal.Content image>
                        Your Total Ordered Quantity and Product Quantity is Different
                        Can you Continue with that?
                      </Modal.Content>
                      <Modal.Actions>
                        <Button color='black' onClick={() => {
                          setQuantityModal(false)
                          setFieldValue(
                            `deliveries[${quantityIndex}].total_quantity`, getCounts(values.deliveries[quantityIndex].products)
                          )
                          values.deliveries[quantityIndex].total_quantity = getCounts(values.deliveries[quantityIndex].products)
                        }}>
                          Nope
                        </Button>
                        <Button
                          content="Yes, Continue"
                          labelPosition='right'
                          icon='checkmark'
                          onClick={() => setQuantityModal(false)}
                          positive
                        />
                      </Modal.Actions>
                    </Modal>

                    <ConfirmationModal open={actWeightConfirmationModal} msgContent="Are you sure to proceed without Actual weight ?" handleConfirm={()=> handleSubmitConfirmModal(submitForm)} handleCancel={handleCancelConfirmationModal} />
                  </Modal.Description >
                </Modal.Content >
              </Form >
            )}}
          </Formik >
        ) : (
          <LoadingPlaceholder />
        )}
        <Modal.Actions>
          <center>
            {(props?.currenOrder?.allotment_status &&
              props?.currenOrder?.allotment_status?.allotment_code ==
              "ALLOC") ||
              props?.currenOrder?.allotment_status?.allotment_code == "CANCEL" ||
              props?.currenOrder?.allotment_status?.allotment_code ==
              "COMPLETE" ? null : (
              <>
                <Button
                  icon
                  size="mini"
                  className="ui blue inverted"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setOpenModalDelivery(true);
                  }}
                >
                  {" "}
                  <Icon name="plus" /> New Delivery
                </Button>
              </>
            )}
            <Button
              size="mini"
              className="ui blue inverted"
              onClick={props.CloseModal}
            >
              {" "}
              {t("action_button.close") || "Close"}{" "}
            </Button>
          </center>
        </Modal.Actions>
      </Modal >
      <ModalEditAddDeliveries
        size="large"
        btime={21}
        reqon={new Date()}
        t={t}
        route_id={props.currenOrder.shipment.route_id}
        movement_type={props?.movement_type.toLowerCase()}
        OpenModel={openModalDelivery}
        handleClose={setOpenModalDeliveryClose}
        addDeliveryDetails={addDeliveryDetails}
        getCurrentOrderDetails={getCurrentOrderDetails}
        setDeliveryEditMode = {setDeliveryEditMode}
      />

    </>
  );
}

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("order_details")(OrderDetails)
);
